export const en = {
  admin: {
    title: "IRES Admin",
    noAvailableSections: "No functions are enabled for you here.",
    // A refresh failed while a cached answer was shown (AdminReadCache.ts).
    refreshFailed: "Could not refresh: showing the data loaded last.",
    // Authoring screens on a phone (PhoneEditingHint.vue).
    phoneEditingHint: "To edit this, please use a tablet or laptop.",
      renoReview: {
        title: "RENO quick review",
        filters: "Filters",
        deviceTypes: "Device types",
        startAtSerial: "Start at device",
        allDeviceTypes: "All",
        anyDevice: "All",
        anyClient: "All",
        noClients: "No clients found",
        monthsSuffix: "months",
        ageOrActive: "Period / status",
        maxAgeMonths: "Only dryings from the last",
        fromDate: "From date",
        activeOnly: "Only running dryings",
        noAgeLimit: "No limit",
        matchingDryings: "Matching dryings",
        countCapped: "over {0}",
        countApprox: "approx. {0}",
        countNone: "none",
        countLoading: "loading …",
        alreadyReviewed: "Already reviewed",
        ratingModeAll: "All",
        ratingModeUnrated: "Only not yet rated",
        ratingModeOnly: "Only ones I rated",
        hideSeen: "Hide the ones I looked at",
        startReview: "Start review",
        noMatches: "No dryings match these filters.",
        loading: "Loading …",
        device: "Device",
        drying: "Drying",
        client: "Client",
        program: "Program",
        dryingPosition: "Drying {0} of {1} on this device",
        chainStart: "Start",
        chainEnd: "End",
        previous: "Previous",
        next: "Next",
        atFirst: "You are at the first drying.",
        atLast: "You have reviewed all dryings.",
        backToFilters: "Change filters",
        startAtSerialHint: "Nothing matches from device “{0}” onwards. Check the serial number.",
        loadFailed: "The drying could not be loaded.",
        hidden: {
          title: "Hidden dryings",
          none: "You have not hidden any dryings.",
          hiddenAt: "Hidden on",
          restore: "Show again",
          restored: "The drying is back in your review.",
          restoreFailed: "The drying could not be shown again.",
          loadMore: "Load more",
        },
        rating: {
          suppress: "Do not show again",
          previously: "You last rated this {0}.",
          suppressFailed: "The drying could not be hidden.",
          saveFailed: "Your rating could not be saved.",
        },
        note: {
          commentPlaceholder: "Comment (optional)",
          chainSuspect: "Check chain",
          onlyChainSuspect: "Check chain",
          onlyWithComment: "Comment",
          saveFailed: "Your comment could not be saved.",
        },
        marks: {
          filterLabel: "My marks",
          onlySuppressed: "Hidden",
        },
      },
    categories: {
      clients: "Clients",
      production: "Production",
      mira: "Mira",
    },
    sections: {
      clients: {
        title: "Clients",
        description: "Search all clients and filter them by type, contract and status.",
      },
      externalSystems: {
        title: "External systems",
        description: "Every ERP and partner system with its owner, linked clients and status.",
      },
      userSearch: {
        title: "Find users",
        description: "Find a user in every client: by email address, name, short name or staff number.",
      },
      sharedUsers: {
        title: "Shared users",
        description: "Shared email addresses and the shared users of groups, with clean-up for outdated entries.",
      },
      deviceReports: {
        title: "Test reports",
        description: "Look at the production test reports for a device.",
      },
      pdfTemplates: {
        title: "PDF templates",
        description: "Shared PDF templates that clients can take over. A client's own templates are on its detail screen.",
      },
      infoConfig: {
        title: "Descriptions",
        description: "Every version of the project forms, their targets, and checked publishing of new versions.",
      },
      miraInsurers: {
        title: "Insurers",
        description: "The insurers Mira assigns projects to, with their spellings.",
      },
      miraInsurerReview: {
        title: "Unidentified insurers",
        description: "Insurer names Mira could not assign, grouped so you can assign them.",
      },
      miraCompanies: {
        title: "Companies",
        description: "Which clients count as one company in Mira's market comparison.",
      },
      miraExceptions: {
        title: "Mira exceptions",
        description: "Late-recorded project ends and approvals that Mira leaves out of the durations.",
      },
    },
    externalSystems: {
      search: "Search external systems",
      none: "No external systems.",
      moreClients: "{0} and {1} more",
      filters: {
        ALL: "All",
      },
    },
    miraCompanies: {
      title: "Companies",
      search: "Search company or client",
      create: "New company",
      hint: "A company with several clients counts once in Mira's market comparison, with one value over all its clients. A group (master client) already counts once by itself; a client in no company counts on its own.",
      loadFailed: "The companies could not be loaded.",
      none: "No companies",
      saved: "Company saved",
      retiredChip: "Retired",
      effectNote: "Applies to every client's market comparison from Mira's next nightly run.",
      lastChange: "last changed on {0} by {1}",
      clientCount: "{0} clients",
      moreClients: "{0} and {1} more",
      takenBy: "already belongs to {0}",
      masterNote: "Master client: brings its group's clients along",
      inGroup: "comes along with the master client",
      isViewingClient: "shows the company in Mira",
      viewerTakenBy: "already shows the company {0}",
      viewingClientLine: "View in Mira: {0}",
      groupChip: "Group",
      groupMembers: "Included through the master client: {0} clients",
      filters: {
        ACTIVE: "Active",
        RETIRED: "Retired",
        ALL: "All",
      },
      fields: {
        name: "Name",
        clients: "Clients",
        retired: "Retired",
        viewingClient: "View in Mira",
        memberGroupView: "Clients compare themselves with the company",
      },
      hints: {
        clients: "At least two, or one master client alone. A master client brings its group's clients along; every group is a company by itself already.",
        retired: "A retired company no longer counts; its clients then count on their own again.",
        viewingClient: "A client that shows the company in Mira like a group. It does not count as one of its clients.",
        memberGroupView: "Every client of the company sees its value beside the whole company's under \"Group\" in Mira, as the clients of a group do. On by default for a group.",
      },
      fieldErrors: {
        required: "Required",
        clients: "At least two clients or one master client",
      },
      dialog: {
        viewTitle: "Company",
        editTitle: "Edit company",
        createTitle: "New company",
      },
      errors: {
        NO_COMPANY: "This company no longer exists.",
        NO_CLIENT: "One of the clients no longer exists.",
        CHANGED_MEANWHILE: "The company was changed meanwhile. The list is reloaded.",
        INVALID_NAME: "The name is required.",
        INVALID_ACCOUNTS: "Choose at least two clients or one master client.",
        CONFLICT: "{0} already belongs to another company.",
        INVALID_VIEWER: "The client for the view no longer exists.",
        VIEWER_IS_ACCOUNT: "The client for the view must not be one of the company's clients.",
        VIEWER_IS_GROUP: "A master client with its own group cannot show a company.",
        VIEWER_TAKEN: "This client already shows the company {0}.",
        FAILED: "Saving failed.",
      },
    },
    miraExceptions: {
      title: "Mira exceptions",
      search: "Search client or reason",
      create: "New exception",
      hint: "When a client recorded an event after the fact (approvals typed in later in bulk, old projects closed at once), Mira leaves those projects out of the durations built on that event and shows their number on the tile. Counts stay unchanged.",
      loadFailed: "The exceptions could not be loaded.",
      none: "No exceptions",
      saved: "Exception saved",
      retiredChip: "Retired",
      effectNote: "Applies to this client's figures (and its group's or company's) from Mira's next nightly run.",
      lastChange: "last changed on {0} by {1}",
      filters: {
        ACTIVE: "Active",
        RETIRED: "Retired",
        ALL: "All",
      },
      columns: {
        range: "Period",
      },
      fields: {
        client: "Client",
        event: "Recorded late",
        from: "From",
        to: "To",
        reason: "Reason",
        retired: "Retired",
      },
      events: {
        PROJECT_END: "Project completion",
        OFFER_ANSWER: "Approval (insurer's answer)",
      },
      eventFigures: {
        PROJECT_END: "Leaves projects closed in the period after at least 30 days without recorded work out of average project duration and time to project completion, together with an approval recorded at the closing.",
        OFFER_ANSWER: "Leaves approvals recorded in the period at the project's closing (on dried or long idle projects) out of approval time, damage assessment to approval and approval to drying / restoration start.",
      },
      hints: {
        reason: "Visible in the IRES Admin Client only.",
        retired: "A retired exception no longer applies; the projects then count again.",
      },
      fieldErrors: {
        required: "Required",
        range: "The end lies before the start.",
      },
      dialog: {
        viewTitle: "Mira exception",
        editTitle: "Edit Mira exception",
        createTitle: "New Mira exception",
      },
      suggestions: {
        title: "Mira's suggestions",
        hint: "Days on which a client recorded many closings or approvals late, found in Mira's nightly run. Take over creates an exception from one, Dismiss hides the suggestion.",
        entriesTitle: "Exceptions",
        takeOver: "Take over",
        dismissAction: "Dismiss",
        dismissed: "Suggestion dismissed",
        groupCount: "{0} suggestion | {0} suggestions",
        columns: {
          late: "Late / total",
          mean: "Mean with → without",
          median: "Median with → without",
        },
        eventsShort: {
          PROJECT_END: "Project completion",
          OFFER_ANSWER: "Approval",
        },
        change: "{0} → {1} days",
        figure: {
          PROJECT_END: "Project duration {0}: mean {1} days, {2} days without these closings (median {3} → {4})",
          OFFER_ANSWER: "Approval time {0}: mean {1} days, {2} days without these approvals (median {3} → {4})",
        },
        dismiss: {
          title: "Dismiss suggestion",
          action: "Dismiss",
          reason: "Reason",
        },
        errors: {
          NO_SUGGESTION: "This suggestion no longer exists. The list is reloaded.",
          CHANGED_MEANWHILE: "The suggestion was changed meanwhile. The list is reloaded.",
          INVALID_REASON: "Enter a reason.",
          FAILED: "Dismissing failed.",
        },
      },
      errors: {
        NO_EXCEPTION: "This exception no longer exists.",
        NO_CLIENT: "This client does not exist.",
        CHANGED_MEANWHILE: "The exception was changed meanwhile. The list is reloaded.",
        INVALID_EVENT: "Choose what was recorded late.",
        INVALID_RANGE: "The period is invalid.",
        INVALID_REASON: "Enter a reason.",
        FAILED: "Saving failed.",
      },
    },
    miraInsurers: {
      title: "Insurers",
      search: "Search insurers",
      create: "New insurer",
      loadFailed: "The insurers could not be loaded.",
      none: "No insurers",
      saved: "Insurer saved",
      retiredChip: "Retired",
      effectNote: "Applies to every client's insurer figures from Mira's next nightly run.",
      mdisKey: "MDIS key: {0}",
      lastChange: "last changed on {0} by {1}",
      filters: {
        ACTIVE: "Active",
        RETIRED: "Retired",
        ALL: "All",
      },
      columns: {
        origin: "Origin",
        spellings: "Spellings",
      },
      origins: {
        MDIS: "From MDIS's insurer list",
        IRES: "Added by IRES",
      },
      originsShort: {
        MDIS: "MDIS",
        IRES: "IRES",
      },
      fields: {
        key: "Key",
        shortName: "Short name",
        name: "Name",
        spellings: "Further spellings",
        words: "Recognition words",
        retired: "Retired",
      },
      hints: {
        key: "2 to 12 capital letters or digits. You can change it at any time; Mira's figures stay the same.",
        spellings: "One per line. Case, umlauts and punctuation do not matter.",
        words: "One per line, three characters or more: recognises the insurer wherever the word appears in the name.",
        retired: "A retired insurer recognises nothing; its projects then count as unidentified.",
      },
      fieldErrors: {
        key: "2 to 12 capital letters or digits",
        required: "Required",
      },
      dialog: {
        viewTitle: "Insurer",
        editTitle: "Edit insurer",
        createTitle: "New insurer",
      },
      errors: {
        KEY_TAKEN: "This key already exists.",
        NO_INSURER: "This insurer does not exist or is retired.",
        CHANGED_MEANWHILE: "The insurer was changed meanwhile. The list is reloaded.",
        INVALID_KEY: "The key is not valid.",
        INVALID_NAME: "Short name and name are required.",
        INVALID_SPELLINGS: "The spellings are not valid.",
        INVALID_TEXTS: "Choose at least one spelling.",
        INVALID_MERGE: "An insurer cannot be merged into itself.",
        CONFLICT: "“{0}” would belong to more than one insurer ({1}).",
        CONFLICT_NOT_INSURER: "“{0}” cannot belong to {1} and count as “No insurer” at the same time.",
        FAILED: "Saving failed.",
      },
      rowActions: "Actions",
      mergedInto: "Merged into {0}",
      move: {
        menu: "Move spellings",
        title: "Move spellings of {0}",
        spellings: "Spellings",
        words: "Recognition words",
        toInsurer: "To another insurer",
        toNewInsurer: "To a new insurer",
        notInsurer: "No insurer",
        release: "Open again (unidentified)",
        insurer: "Insurer",
        action: "Move",
        done: "Moved",
        effectInsurer: "Applies to every client: from the next nightly run, projects with these spellings no longer count for {0} but for {1}.",
        effectNotInsurer: "Applies to every client: from the next nightly run, projects with these spellings no longer count for {0} but as “No insurer”.",
        effectRelease: "Applies to every client: from the next nightly run, projects with these spellings no longer count for {0} but as unidentified. They appear under Unidentified insurers only after that run.",
      },
      merge: {
        menu: "Merge",
        title: "Merge insurers",
        intro: "{0} ({1}) is merged into another insurer.",
        into: "Merge into",
        action: "Merge",
        done: "Merged",
        effect: "Applies to every client: {0} is retired. Its names, keys, spellings and recognition words then belong to {1}, and its projects count for {1} from the next nightly run.",
      },
    },
    miraInsurerReview: {
      title: "Unidentified insurers",
      search: "Search spellings",
      loadedAt: "As of {0}",
      suggestionsAt: "Suggestions of {0}",
      loadFailed: "The list could not be loaded.",
      views: {
        OPEN: "Open",
        SUGGESTED: "With suggestion",
        NOT_INSURER: "No insurer",
      },
      headings: {
        OPEN: "Groups",
        SUGGESTED: "Groups with a suggestion",
        NOT_INSURER: "No insurer",
      },
      hints: {
        OPEN: "The names Mira could not assign to an insurer in its last nightly run, grouped, the largest first. A decision applies in Mira from the next run.",
        SUGGESTED: "Groups Mira has a suggestion for. The tick opens the dialog already filled in; nothing is saved before its button. The cross dismisses the suggestion.",
        NOT_INSURER: "Spellings decided as “No insurer”. In Mira they count neither as recognised nor as unidentified.",
      },
      none: {
        OPEN: "No open groups",
        SUGGESTED: "No open suggestions",
        NOT_INSURER: "No spelling decided as “No insurer” yet",
      },
      columns: {
        spellings: "Spellings",
        projects: "Projects",
        clients: "Clients",
      },
      moreSpellings: "{0} and {1} more",
      droppedTexts: "{0} rarely used spellings did not fit into the list and are missing here.",
      release: "Take back",
      releaseConfirm: {
        title: "Take back the decision",
        message: "“{0}” then counts as unidentified again from Mira's next run.",
      },
      released: "Decision taken back",
      decided: "Decided",
      decision: {
        title: "Assign group",
        spellings: "Spellings",
        spellingWithCount: "{0} (one project) | {0} ({1} projects)",
        toInsurer: "Assign to an insurer",
        toNewInsurer: "Assign to a new insurer",
        notInsurer: "No insurer (unknown, broker, bank, test …)",
        insurer: "Insurer",
        apply: "Assign",
        next: "Next",
        nextNewInsurer: "In the next step you create the insurer. The spellings are already filled in there.",
        effectInsurer: "Applies to every client: from the next nightly run, projects with these spellings count for {0}.",
        effectNotInsurer: "Applies to every client: from the next nightly run, projects with these spellings count as “No insurer” and no longer in the assignment rate.",
      },
      suggestion: {
        insurer: "Suggestion: {0} ({1})",
        newInsurer: "Suggestion: new insurer {0} ({1})",
        notInsurer: "Suggestion: No insurer",
        unsure: "unsure",
        takeOver: "Take over",
        dismissAction: "Dismiss",
        dismissed: "Suggestion dismissed",
        dismiss: {
          title: "Dismiss suggestion",
          action: "Dismiss",
          reason: "Reason",
        },
        errors: {
          NO_SUGGESTION: "This suggestion no longer exists. The list is reloaded.",
          CHANGED_MEANWHILE: "The suggestions were imported again meanwhile. The list is reloaded.",
          INVALID_REASON: "Enter a reason.",
          FAILED: "Dismissing failed.",
        },
      },
    },
    clients: {
      title: "Clients",
      counts: {
        all: "Clients",
      },
      search: "Name, short name or client number",
      masterClient: "Master",
      helperFunctions: {
        recalculateAllDryings: {
          button: "Recalculate all dryings",
          description: "Recalculates the ASSIST predictions for all dryings of this client with the latest model.",
          confirmTitle: "Recalculate all dryings?",
          confirmMessage: "The ASSIST predictions for all dryings of this client will be recalculated with the latest model. This may take a while.",
          confirmAccept: "Recalculate",
          started: "The recalculation has been started.",
          alreadyRunning: "A recalculation is already running.",
          noOp: "No recalculation was started (the feature may not be activated for this client).",
          error: "Error while starting the recalculation: {0}",
          failed: "The recalculation could not be started.",
          statusStarted: "Started",
          statusAlreadyRunning: "Already running",
          statusNoOp: "Nothing to do",
          refusals: {
            INVALID: "The recalculation could not be started.",
            NO_CLIENT: "This client no longer exists.",
            DELETED_CLIENT: "Nothing can be recalculated for a deleted client.",
            SHARED_LOGIN: "The shared IRES admin login cannot change anything. Sign in with your own user.",
            PERMISSION_DENIED: "You are not allowed to do this.",
          },
        },
      },
      changes: {
        title: "History",
        loadFailed: "The history could not be loaded.",
        none: "Nothing has been changed on this client in the IRES Admin Client yet.",
        showMore: "Show more",
        followsGlobalTarget: "Global version",
        everyProjectType: "Every project type of the products",
        filters: {
          CLIENT_LOGIN: "Sign-ins as client",
        },
        groups: {
          INFO_CONFIG_TARGET: "Description",
          CLIENT_LOGIN: "Signed in as client",
          CREATED: "Created",
          SHARED_EMAIL_ADDRESS: "Shared email address cleaned up",
        },
        fields: {
          membersAdded: "Members added",
          membersRemoved: "Members removed",
          serviceContractSince: "Service contract FW / config since",
          warrantyExtensionSince: "Warranty extension panels since",
          allowedProjectTypeIds: "Project types (IRES)",
          activeProjectTypeIds: "Active at the client",
          enabledFunctions: "Features switched on",
          sharedEmailAddress: "Email address",
          sharedEmailAddressUsersRemoved: "Users removed",
          sharedEmailAddressDeleted: "Entry deleted",
        },
      },
      contracts: {
        editTitle: "Edit contracts",
        since: "Since",
        saved: "Contracts saved.",
        saveFailed: "The contracts could not be saved.",
      },
      testSettings: {
        editTitle: "Edit test",
        saved: "Test saved.",
        saveFailed: "The test could not be saved.",
        usersLoadFailed: "The users could not be loaded.",
        errors: {
          UNKNOWN_TEST_USER: "A chosen test user is not an active user of this client.",
        },
      },
      masterData: {
        clientName: "Name",
        houseNumber: "House number",
        editTitle: "Edit master data",
        projectNumberPrefixKept: "The short name is a label only: this client's IRES project numbers keep starting with {0}.",
        iresTypeWarning: "A client of type IRES has access to the data of every client. Only change the client type if that is intended.",
        saved: "Master data saved.",
        fieldErrors: {
          required: "Required",
          tooLong: "At most 100 characters",
          prefixLength: "Exactly 4 characters",
        },
        errors: {
          CHANGED_MEANWHILE: "The client was changed meanwhile. The current data has been reloaded, please make your change again.",
          PREFIX_TAKEN: "Another client already has this short name.",
          INVALID_VALUE: "A field is invalid.",
          NO_CLIENT: "This client no longer exists.",
          FAILED: "The master data could not be saved.",
        },
      },
      group: {
        editTitle: "Edit group",
        hasMembersHint: "A MASTER client with members stays one until you have removed all members.",
        clientsLoadFailed: "The clients could not be loaded.",
        inactive: "(inactive)",
        deleted: "(deleted)",
        thisClient: "this client",
        overwriteTitle: "Overwrite settings?",
        overwriteMessage: "The settings of {0} replace all settings of this MASTER client.",
        overwriteAccept: "Overwrite",
        saved: "Group saved.",
        saveFailed: "The group could not be saved.",
        migrateSharedUsers: "Migrate shared users",
        migrateSharedUsersMessage: "The group's shared email addresses become shared users of the group. This cannot be undone.",
        migrateSharedUsersAccept: "Migrate",
        migratedSharedUsers: "{0} shared users migrated.",
        noSharedUsersToMigrate: "All shared users are already migrated, or there are none.",
        migrateSharedUsersFailed: "The shared users could not be migrated.",
        refusals: {
          INVALID: "The group could not be saved.",
          NO_CLIENT: "This client no longer exists.",
          DELETED_CLIENT: "The group of a deleted client cannot be changed.",
          CHANGED_MEANWHILE: "The group was changed in the meantime. The view has been reloaded.",
          IS_MEMBER: "A member of a group cannot become a MASTER client.",
          HAS_MEMBERS: "Remove all members first.",
          NOT_A_CANDIDATE: "These clients cannot become members: {0}",
          NOT_A_MEMBER: "Settings can only be taken from a member.",
          DUPLICATE_BRANCH_NUMBERS: "Branch number {0} is used by {1} and by {2}.",
          SHARED_LOGIN: "Nothing can be changed with the shared IRES admin login. Sign in with your own user.",
        },
      },
      products: {
        editTitle: "Edit products",
        saved: "Products saved.",
        saveFailed: "The products could not be saved.",
        saveWarning: "Saving updates the product choice (old) that IRES Project, IRES Work and IRES Office read, and the licences are recalculated.",
        derivedCaption: "Still derived from the product choice and not saved yet.",
        choices: {
          DEVICES_ONLY_WEBSITE: "Device portal",
          WEBSITE: "Project portal",
          DEFAULT: "Project manager",
          PROJECT_OPTION: "Project option",
        },
        explanations: {
          officeDeviceAssignment: "GZ and GL projects in IRES Office. IRES Office itself is always available.",
          project: "Project administration with IRES Project.",
          work: "Device management in the IRES Work app. Without IRES Work, nobody at the client can sign in to IRES Work.",
          interface: "REST interface to an external system.",
        },
        errors: {
          CHANGED_MEANWHILE: "The products were changed in the meantime. The view has been reloaded.",
          INVALID_CLIENT: "This client cannot have products.",
          INVALID: "Invalid product selection.",
          NO_CLIENT: "This client no longer exists.",
          DELETED_CLIENT: "The products of a deleted client cannot be changed.",
          SHARED_LOGIN: "Nothing can be changed with the shared IRES admin login. Sign in with your own user.",
          FAILED: "The products could not be saved.",
        },
      },
      projectTypes: {
        editTitle: "Edit project types",
        explanation: "Which project types of its products the client gets. Types left out are no longer offered by IRES Office, IRES Project, IRES Work or the interfaces.",
        notRestricted: "Not restricted: the client gets every project type of its products.",
        followsMaster: "Set on the MASTER client",
        activeInClientTable: "active at the client",
        inactiveInClientTable: "not active at the client",
        atLeastOne: "Choose at least one project type.",
        withdrawWarning: "Saving switches every project type you left out off in the client's possible project types, so no app offers it any more. Existing projects stay as they are.",
        withdrawWarningMaster: "This also applies to the members that use this MASTER client's project settings.",
        allowNote: "The client can then switch a new project type on under Settings project implementation.",
        saved: "Project types saved.",
        errors: {
          CHANGED_MEANWHILE: "The project types were changed in the meantime. The view has been reloaded.",
          INVALID_CLIENT: "This client cannot have project types.",
          INVALID: "Invalid choice of project types.",
          EMPTY: "Choose at least one project type.",
          NO_CLIENT: "This client no longer exists.",
          DELETED_CLIENT: "The project types of a deleted client cannot be changed.",
          FOLLOWS_MASTER: "This client uses its MASTER client's project settings. Change the project types there.",
          SHARED_LOGIN: "Nothing can be changed with the shared IRES admin login. Sign in with your own user.",
          FAILED: "The project types could not be saved.",
        },
      },
      projectOrganisation: {
        editTitle: "Edit project organisation",
        followsMaster: "Set on the MASTER client",
        notStored: "Not stored: the apps use their default, as shown here.",
        reachNote: "Applies in IRES Office, IRES Project, IRES Work and the interface once saved.",
        reachNoteMaster: "This also applies to the members that use this MASTER client's project settings.",
        saved: "Project organisation saved.",
        errors: {
          CHANGED_MEANWHILE: "The project organisation was changed in the meantime. The view has been reloaded.",
          INVALID_CLIENT: "This client cannot have a project organisation.",
          INVALID: "Invalid choice. Appointments and project completion need at least one app.",
          NO_CLIENT: "This client no longer exists.",
          DELETED_CLIENT: "The project organisation of a deleted client cannot be changed.",
          FOLLOWS_MASTER: "This client uses its MASTER client's project settings. Change the project organisation there.",
          NO_PROJECTS: "This client's products include no projects.",
          SHARED_LOGIN: "Nothing can be changed with the shared IRES admin login. Sign in with your own user.",
          FAILED: "The project organisation could not be saved.",
        },
      },
      systemConfiguration: {
        editTitle: "Edit system configuration",
        followsMaster: "Set on the MASTER client",
        notStored: "Not stored: IRES Office uses the client's older settings, as shown here.",
        reachNote: "Applies to every user of this client once saved.",
        reachNoteMaster: "This also applies to the members that use this MASTER client's system configuration.",
        saved: "System configuration saved.",
        assistScope: "ASSIST scope",
        effectsFailed: "Saved, but what the change sets off (vehicles, address geocoding, ASSIST) failed. Please report it.",
        errors: {
          CHANGED_MEANWHILE: "The system configuration was changed in the meantime. The view has been reloaded.",
          INVALID_CLIENT: "This client cannot have a system configuration.",
          INVALID: "Invalid choice. “Tracking” needs “Map”, and “Show device management in cockpit” needs “Manage all devices”.",
          NO_CLIENT: "This client no longer exists.",
          DELETED_CLIENT: "The system configuration of a deleted client cannot be changed.",
          FOLLOWS_MASTER: "This client uses its MASTER client's system configuration. Change it there.",
          SHARED_LOGIN: "Nothing can be changed with the shared IRES admin login. Sign in with your own user.",
          FAILED: "The system configuration could not be saved.",
        },
      },
      setup: {
        title: "New client",
        loadFailed: "The setup could not be loaded.",
        externalSystems: {
          explanation: "With API, the client can get an external system right away, such as its ERP. It receives nothing until IRES switches it on, and starts in Setup. Its password is shown once after creating. Contact people and more systems are added later on the system's page.",
          create: "Create an external system",
          memberExplanation: "A member uses the external systems of its MASTER client. A ticked system then reaches this client's projects.",
          masterHasNone: "The MASTER client has no external systems.",
          system: "External system",
          linked: "Linked systems",
          none: "None",
          sameAsClient: "The system needs its own address, not the client's.",
        },
        steps: {
          masterData: "Client",
          products: "Products",
          projectTypes: "Project types",
          projectOrganisation: "Project organisation",
          functions: "Features",
          licences: "Licences",
          contracts: "Contracts and devices",
          users: "Users",
          externalSystems: "External systems",
          summary: "Summary",
        },
        next: "Next",
        create: "Create",
        change: "Change",
        created: "Client created.",
        createWarning: "CREATE sets up the client with everything shown here. It can sign in straight away.",
        signInEmail: "Email address (sign-in)",
        signInPassword: "Password (sign-in)",
        passwordTooShort: "At least {0} characters",
        address: "Address",
        followsMaster: "as the MASTER client",
        followsMasterExplanation: "As a member, the client uses the settings of its MASTER client {0}.",
        noProjects: "Without IRES Project, IRES Work or IRES Office (GZ / GL) there is nothing to set here.",
        organisationRequired: "Choose at least one app.",
        group: {
          kinds: {
            STANDALONE: "Standalone",
            MEMBER: "Member of a MASTER client",
            MASTER: "New MASTER client",
          },
          master: "MASTER client",
          masterRequired: "Choose the MASTER client.",
          memberHint: "A member takes the project types, project organisation, features, contracts and devices of its MASTER client. Its licences are its own.",
          memberOf: "Member of {0}",
        },
        products: {
          officeAlways: "IRES Office with HyDry device management is always included.",
          officeOnly: "IRES Office only (HyDry devices)",
        },
        functions: {
          enabled: "Switched on",
          personalChat: "Personal chat",
          projectChat: "Project chat",
        },
        licences: {
          explanation: "The licences bought for the chosen products. You change them later in IRES Admin.",
          noneNeeded: "The chosen products need no licences.",
          invalid: "A whole number from 0 to {0}",
        },
        contracts: {
          devices: "Devices",
          updateFirmwareViaIot: "Firmware update IPU E-G via IOT",
          updateConfigViaIot: "Config update via IOT",
          conditions: {
            ALWAYS: "Always",
            NEVER: "Never",
            WHEN_IDLE_OR_AFTER_POWER_ON: "Panel idle / powered up",
          },
          yesSince: "Yes, since {0}",
          followsFleet: "as the fleet",
          followsFleetExplanation: "The client follows the fleet's target versions. You set its own target versions later in IRES Admin.",
        },
        users: {
          iresAdminExplanation: "The IRES admin user is always created: \"Sign in as client\" opens the client with it.",
          createFirstUser: "Create the client's first user",
          role: "Role: {0}",
          iresAdmin: "IRES admin user",
          iresAdminAlways: "Created",
          firstUser: "First user",
          noFirstUser: "None, later under Users",
        },
        errors: {
          INVALID: "Something entered is invalid. Check the steps.",
          NOT_A_MASTER: "The chosen client is not (or no longer) a MASTER client.",
          PROJECT_TYPES_EMPTY: "Choose at least one project type.",
          TRACKING_WITHOUT_MAP: "Tracking needs Map.",
          TILE_WITHOUT_ALL_DEVICES: "Showing device management in the cockpit needs Manage all devices.",
          NICKNAME_TAKEN: "This short name already exists.",
          STAFF_NUMBER_TAKEN: "This staff number already exists.",
          PREFIX_TAKEN: "Another client already has this client shorthand.",
          EMAIL_TAKEN: "Another client already signs in with this email address.",
          USER_EMAIL_TAKEN: "Another user already has this email address.",
          IRES_ADMIN_EMAIL_TAKEN: "No address is free for the IRES admin user with this client shorthand. Choose another shorthand.",
          EXTERNAL_SYSTEM_EMAIL_TAKEN: "An account already uses this address. Choose another one for the external system.",
          NOT_THE_MASTERS_SYSTEM: "A chosen system no longer belongs to the MASTER client. Choose the systems again.",
          SHARED_LOGIN: "The shared IRES admin login cannot change anything. Sign in with your own user.",
          FAILED: "The client could not be created.",
        },
      },
      partners: {
        title: "External systems",
        loadFailed: "The external systems could not be loaded.",
        none: "No external system connected.",
        viaMaster: "through the MASTER client",
        editOnOwner: "This external system belongs to the MASTER client and is changed there.",
        partner: "External system",
        saved: "Saved.",
        noAddress: "None (IRES sends nothing)",
        defaultEndpoint: "Default: {0}",
        endpointLabel: "{0} (empty: {1})",
        byRoute: "Only for calls through EasyTec",
        statuses: {
          SETUP: "Setup",
          TEST: "Test",
          LIVE: "Live",
          PAUSED: "Paused",
        },
        statusDescriptions: {
          SETUP: "The connection is being set up.",
          TEST: "The connection is being tested with the system.",
          LIVE: "Projects are exchanged with the system.",
          PAUSED: "IRES sends the system nothing; what comes up goes out when resumed. The system can still call IRES.",
        },
        systems: {
          EASY_TEC: "Complete steps list (EasyTec)",
          EXTERNAL: "One step at a time (IRES API)",
          NONE: "None (incoming only)",
        },
        signIn: {
          API_KEY: "API key",
          SIGN_IN: "Email address and password",
          EASY_TEC: "EasyTec sign-in (client and password)",
          NONE: "None (IRES sends nothing)",
        },
        fields: {
          integrationStatus: "Status",
          baseUrl: "Base URL",
          signIn: "IRES signs in with",
          system: "Step transfer",
        },
        endpoints: {
          createProject: "New project",
          projectData: "Project data",
          projectStatus: "Status",
          noteUpdate: "Notes",
        },
        accepts: {
          acceptsNewProjects: "New projects",
          acceptsProjectDataUpdates: "Project data",
          acceptsProjectStatusUpdates: "Status",
          acceptsNotes: "Notes",
          includeProjectOwnersInfo: "Project owners",
          sendsExtraPhaseData: "Extra phase data",
        },
        behaviour: {
          appointmentFieldSwap: "Apply appointment / started mapping",
          incomingContactPerson0: "Enforce contact person 0",
          sendsLatestProjectStatus: "Send latest project status",
          isTestSystem: "Test system (project numbers swapped)",
        },
        cards: {
          status: "Status",
          connection: "Connection",
          accepts: "What {0} gets",
          behaviour: "Behaviour",
        },
        changeGroups: {
          created: "External system created",
          password: "New password",
          accepts: "What the system gets",
          credentials: "Sign-in data",
        },
        contacts: {
          title: "Contact people",
          none: "No contact person yet.",
          name: "Name",
          role: "Role",
          email: "Email address",
          phone: "Phone",
          add: "Add contact person",
          remove: "Remove contact person",
          roles: {
            TECHNICAL: "Technical",
            BUSINESS: "Business",
          },
          invalid: {
            email: "Not a valid email address.",
            phone: "Only digits, spaces and + ( ) / - .",
          },
        },
        goLive: {
          title: "Go-live",
          description: "Checked automatically when the page opens. None of it holds Live back.",
          checks: {
            CONTACT: "Contact person recorded",
            SIGNED_IN: "Signed in to IRES",
            CONNECTION: "Connection complete (base URL and credentials)",
            PROJECT: "First project exchanged",
          },
          lastSignIn: "{0}, last on {1}",
          openWarning: "Still open for go-live: {0}. Live can be set anyway.",
        },
        packages: {
          title: "Packages",
          description: "What you give the partner for the connection: the IRES REST API description cut down to its endpoints, as YAML and as a page for the browser, and an overview of the exchange as PDF. Every package is recorded with date, author, version and recipient.",
          none: "No package created yet.",
          notAvailable: "EasyTec systems have no packages yet: they use their own interface.",
          loadFailed: "The packages could not be loaded.",
          create: "New package",
          createTitle: "New package for {0}",
          createButton: "Create",
          created: "Package created.",
          changeGroup: "Package created",
          version: "API {0}",
          by: "by {0}",
          for: "for {0}",
          apiVersion: "API version",
          groups: "Endpoints",
          recipient: "Recipient",
          otherRecipient: "Someone else",
          recipientName: "Name",
          recipientEmail: "Email address (optional)",
          noCredentials: "It never contains credentials: you hand over the system's password separately.",
          describes: "The package describes the IRES REST API {0}.",
          groupNames: {
            SIGN_IN: "Sign-in",
            PROJECTS: "Projects",
            STATUS: "Status and steps",
            NOTES: "Notes",
            REPORTS: "Reports",
            DEVICES: "Devices and assignments",
            DEVICE_CATEGORIES: "Device categories and types",
            USERS: "Users and roles",
          },
          states: {
            CURRENT: "Current",
            OUTDATED: "Out of date",
            SUPERSEDED: "Superseded",
            UNCHECKED: "Not checkable",
          },
          unchecked: "The description in the package could not be read, so whether the API changed is not checked.",
          operations: {
            added: "New endpoints: {0}",
            removed: "Removed endpoints: {0}",
            changed: "Changed endpoints: {0}",
          },
          general: "Changed: {0}",
          generalParts: {
            SERVERS: "Base URL of the API",
            SECURITY: "Sign-in to the API",
          },
          settingsNotChecked: "The settings are not checked: the package is older than this check.",
          changelogLine: "API {0}: {1}",
          notSent: "not sent",
          settingNames: {
            name: "Name",
            accessEmail: "The system's sign-in address",
            ownerIsGroup: "Client group (regionId)",
            sends: "IRES sends to the system",
          },
          files: {
            yaml: "Download description (YAML)",
            html: "Download description (HTML)",
            overview: "Download overview (PDF)",
          },
        },
        editTitles: {
          PARTNER_STATUS: "Edit status",
          PARTNER_CONNECTION: "Edit connection",
          PARTNER_ACCEPTS: "Edit what {0} gets",
          PARTNER_BEHAVIOUR: "Edit behaviour",
          PARTNER_CREDENTIALS: "Edit sign-in data",
          PARTNER_CONTACTS: "Edit contact people",
        },
        warnings: {
          pause: "IRES sends this system nothing until you resume it. It can still call IRES.",
          resume: "On resuming, IRES sends everything that waited during the pause.",
          swapOff: "Without the mapping, appointment and start go to the system separately. Every appointment step of an open project is sent again on its next change. Agree this with its operator first.",
          noStatus: "The system then gets no status changes.",
        },
        fieldErrors: {
          baseUrl: "A URL starting with https:// or http://",
          endpoint: "Only letters, digits and _ - . ~ /",
        },
        credentials: {
          button: "Change sign-in data",
          apiKey: "API key",
          password: "Password",
          email: "Email address",
          clientId: "Client (EasyTec)",
          authUrl: "Sign-in address",
          tokenUrl: "Token address",
          set: "set",
          missing: "missing",
          secretSetLabel: "{0} (set; leave empty to keep)",
          secretMissingLabel: "{0} (missing)",
          saved: "Sign-in data saved.",
          replaced: "replaced",
        },
        errors: {
          NOT_AVAILABLE: "EasyTec systems have no packages yet.",
          NO_PACKAGE: "This package does not exist.",
          NOT_A_MEMBER: "Only members of the owner's group can be linked.",
          NO_CHANGES: "Nothing changed.",
          EMAIL_TAKEN: "Someone already signs in with this address.",
          MEMBER_CLIENT: "A member uses the external systems of its MASTER client.",
          CHANGED_MEANWHILE: "Someone changed this meanwhile. The page was reloaded.",
          NOT_EDITABLE_HERE: "This external system is changed on the MASTER client.",
          NEEDS_ERP_SIMULATOR: "Test system only for a client with the ERP simulator.",
          NO_PARTNER: "This external system does not exist for this client.",
          INVALID: "An entry is invalid.",
          SHARED_LOGIN: "Nothing can be changed with the shared IRES admin login. Sign in with your own user.",
          FAILED: "The external system could not be saved.",
        },
        access: {
          title: "Access",
          description: "The system signs in to IRES with this address and its password. The password is shown only once, when the system is created and on New password.",
          email: "The system's sign-in to IRES",
          password: "Password",
          newPassword: "New password",
          newPasswordTitle: "Generate a new password",
          newPasswordMessage: "The current password of {0} stops working at once. The system can only sign in again once it has the new one.",
          passwordTitle: "Password for {0}",
          onceWarning: "The password is shown only now and stored nowhere. Copy it and pass it on to the system's operator.",
          copy: "Copy",
          copied: "Password copied.",
          copyFailed: "Copying did not work. Select the password and copy it by hand.",
          done: "Done",
        },
        create: {
          open: "New",
          title: "New external system",
          name: "Name",
          baseUrlOptional: "Base URL (optional, also later)",
          button: "Create",
          created: "External system created.",
          emailInvalid: "An email address, e.g. prefix-system@ires.de",
        },
        links: {
          title: "Linked clients",
          description: "The system reaches these clients: it can create and edit their projects, and their new projects are exchanged with it. Members of the group are linked here.",
          none: "No client linked.",
          owner: "Owner",
          link: "Link",
          linkTitle: "Link a client to {0}",
          member: "Client",
          linkWarning: "{0} can then create and edit this client's projects, and the client's new projects are exchanged with {0}.",
          linked: "Linked.",
          unlink: "Remove link",
          unlinkTitle: "Remove link",
          unlinkMessage: "{1} can no longer reach {0}: its calls for this client are refused.",
          unlinked: "Link removed.",
          linkedClient: "Linked client",
        },
      },
      clientLogin: {
        button: "Sign in as client",
        noTab: "The new tab did not respond. Allow pop-ups for IRES Office and try again.",
        failed: "The client could not be opened.",
        refusals: {
          SHARED_LOGIN: "A client cannot be opened with the shared IRES admin login. Sign in with your own user.",
          NO_CLIENT: "This client no longer exists.",
          PORTAL_CLIENT: "The IRES Admin Client's own client cannot be opened this way.",
          ADMIN_APP_CLIENT: "IRES Admin app accounts cannot be opened this way.",
          NO_IRES_ADMIN_USER: "This client has no IRES admin user.",
        },
      },
      status: {
        blocked: {
          title: "Edit block",
          no: "Not blocked",
          yes: "Blocked",
          consequence: "Nobody can sign in to this client any more, except the IRES admin account. Devices and ERP connections keep working.",
          saved: "Block saved.",
        },
        active: {
          title: "Edit active / inactive",
          yes: "Active",
          no: "Inactive",
          consequence: "Users can no longer sign in with their email address, and the client disappears from its group's lists.",
          unmet: "The client cannot be set inactive yet:",
          saved: "Saved.",
        },
        delete: {
          title: "Delete client",
          consequence: "The client disappears from every list, and nobody can sign in any more. All data is kept; restoring undoes the deletion.",
          unmet: "The client cannot be deleted yet:",
          saved: "Client deleted.",
        },
        restore: {
          title: "Restore client",
          message: "The client appears in the lists again, and signing in works again unless it is blocked.",
          button: "Restore",
          saved: "Client restored.",
        },
        deleteReason: "Reason",
        deleteReasons: {
          CUSTOMER_LEFT: "Customer left",
          DUPLICATE: "Duplicate",
          TEST_ACCOUNT: "Test account",
          OTHER: "Other",
        },
        note: "Note (optional)",
        noteRequired: "Note",
        noteTooLong: "At most 200 characters",
        conditions: {
          DEVICES_ASSIGNED: "Devices are still assigned.",
          RUNNING_PROJECTS: "Projects are still running.",
          SHARED_USERS_AT_HOME: "Shared users of the group have this as their home client.",
          MASTER_WITH_MEMBERS: "The client is the master of a group with members.",
          ERP_CONNECTED: "An ERP connection is active.",
        },
        changedMeanwhile: "The status was changed meanwhile. The view has been reloaded.",
        saveFailed: "The status could not be saved.",
      },
      liveOperation: {
        live: "Live operation",
        notLive: "Not live",
        notLiveWithReason: "Not live ({0})",
        reasons: {
          TEST: "Test",
          DEMO: "Demo",
          WAREHOUSE: "Warehouse",
        },
        reason: "Reason",
        change: "change",
        changedAt: "changed on {0}",
        changedAtBy: "changed on {0} by {1}",
        editTitle: "Edit operation",
        consequence: "From the next night on, Mira leaves clients that are not live out of all figures and comparisons. Set back to live operation, they count again from then on.",
        saved: "Operation saved.",
        saveFailed: "The operation could not be saved.",
      },
      miraAllClients: {
        on: "Yes: Mira shows all clients added up",
        off: "No",
        editTitle: "Edit Mira: All clients",
        consequence: "From the next night, Mira then shows the figures of all clients added up. Every user of this client sees them.",
        savedOn: "Mira shows all clients from the next night.",
        savedOff: "Mira no longer shows the figures of all clients.",
        saveFailed: "The setting could not be saved.",
        notIresAccount: "Only an IRES client can show all clients.",
      },
      columns: {
        name: "Name",
        currentProjects: "Current",
        oldProjects: "Old",
        deletedProjects: "Deleted",
        reports: "Reports",
        panels: "Panels",
        comBoxes: "Boxes",
        minis: "Minis",
        number: "Number",
        shorthand: "Short",
        users: "Users",
      },
      // The Mandanten list's sort (2026-11-02): the name, or a figure, either way round.
      sorts: {
        NAME: "Name",
        numProjects: "Current projects",
        numOldProjects: "Old projects",
        numDeletedProjects: "Deleted projects",
        numReports: "Reports",
        numCurrentPanels: "Panels",
        numCurrentComBoxes: "Boxes",
        numCurrentMinis: "Minis",
        numUsers: "Users",
      },
      sortedBy: {
        mostFirst: "Sorted by: {0}, most first",
        fewestFirst: "Sorted by: {0}, fewest first",
        nameDescending: "Sorted by: name, Z to A",
      },
      columnGroups: {
        projects: "Projects",
        devices: "Devices",
      },
      filters: {
        ALL: "All",
        IRES: "IRES",
        CLIENT: "Customers",
        SERVICE_CONTRACT: "Service contract",
        CONTRACT_PURCHASE: "Purchase",
        CONTRACT_PERMANENT_RENT: "Permanent rent",
        CONTRACT_TESTING: "Test phase",
        HAS_APP: "Has app",
        MASTER: "Master",
        LIVE: "Live operation",
        NOT_LIVE: "Not live",
        BLOCKED: "Blocked",
        DELETED: "Deleted",
        ACTIVE: "Active",
        INACTIVE: "Inactive",
      },
      filterGroups: {
        TYPE: "Type",
        CONTRACT: "Contract",
        APP: "App",
        GROUP: "Group",
        OPERATION: "Operation",
        ACCESS: "Access",
        STATUS: "Status",
      },
      serviceContractSince: "since {0}",
      noneMatching: "No clients match the search and filter.",
      loadFailed: "The clients could not be loaded.",
      figuresUpdatedAt: "As of {0}",
      detail: {
        loadFailed: "The client could not be loaded.",
        notFound: "This client does not exist (any more).",
        licences: {
          title: "Licences",
          modelV2: "Licence model 2 · limits",
          modelV3: "Licence model 3 · used of purchased",
          exceeded: "More licences are used than purchased.",
        },
        devices: {
          title: "Devices",
          loadFailed: "The device counts could not be loaded.",
          hint: "Panels without an open assignment count as former. The panel totals include HyDry Panel, HyDry Slim and HyDry Edge only.",
          columns: {
            type: "Assignment",
            panels: "Panels",
            comBoxes: "Boxes",
            minis: "Minis",
          },
          assignmentTypes: {
            SOLD: "Purchase",
            PERMANENT_RENT: "Permanent rent",
            DAILY_RENT: "Daily rent",
            CONSIGNMENT_STOCK: "Consignment stock",
            TESTING: "Test",
            OTHER: "Other",
            AVAILABLE: "Available",
          },
          former: "Former panels",
          total: "Total",
        },
        sections: {
          masterData: "Master data",
          products: "Products",
          projectTypes: "Project types",
          projectOrganisation: "Project organisation",
          systemConfiguration: "System configuration",
          group: "Group",
          contracts: "Contracts",
          targetVersions: "Target versions",
          testSettings: "Test",
          status: "Status",
          helperFunctions: "Helper functions",
        },
        fields: {
          isMaster: "MASTER client",
          groupMembers: "Members",
          settingsSource: "Settings taken from",
          masterClient: "Member of",
          clientNumber: "Customer number",
          companyName: "Company",
          zip: "Postcode",
          city: "City",
          street: "Street",
          clientType: "Customer type",
          email: "Email address",
          clientShorthand: "Client shorthand",
          officeDeviceAssignment: "IRES Office (GZ / GL)",
          project: "IRES Project",
          work: "IRES Work",
          interface: "API",
          productChoice: "Product choice (old)",
          contracts: "Contracts",
          warrantyExtensionForPanels: "Warranty extension panels",
          serviceContract: "Service contract FW / config",
          hasApp: "Has app",
          blocked: "Blocked",
          isActive: "Active",
          deleted: "Deleted",
          liveOperation: "Operation",
          miraAllClients: "Mira: All clients",
          isTestSystem: "ERP simulator",
          testAppVersion: "Test target app version",
          testRoomInfoConfigVersion: "Test target description version",
          testUsers: "Test users",
          numUsers: "Users",
          numProjects: "Projects",
          numArchivedProjects: "Old projects",
          numDeletedProjects: "Deleted projects",
          figuresUpdatedAt: "Figures as of",
          numReports: "Reports",
        },
        clientTypes: {
          IRES: "IRES",
          CLIENT: "Customer",
          OTHER: "Other",
        },
        contractTypes: {
          PURCHASE: "Purchase",
          PERMANENT_RENT: "Permanent rent",
          TESTING: "Test phase",
        },
        testSettings: {
          unknownUser: "Unknown user",
          inactiveUser: "(deleted)",
          reachesNobody: "The test reaches nobody while no test user is chosen.",
        },
        targetVersions: {
          targetFirmwareName: "Target firmware A, B, C",
          targetIotFirmwareName: "Target firmware D+",
          targetConfigName: "Target configuration",
          targetAppApk: "App version",
          targetLeakDetectionInfoConfigVersion: "Leak detection",
          targetRoomInfoConfigVersion: "Drying",
          targetHtmlTipsAndTricksFile: "Tips and tricks",
          targetHtmlHistoryFile: "Version history",
        },
      },
    },
    cockpit: {
      contractsAndApp: "Contracts and app",
      tasks: "Tasks",
      totalsTitle: "Totals",
      totalsScope: "Customers in live operation",
      totals: {
        projects: "Projects",
        oldProjects: "Old projects",
      },
      exceptionSuggestions: "Suggestions for Mira exceptions",
      externalSystemsInStatus: "External systems: {0}",
      waitingDeviceReports: "Test reports not assigned",
      ownTargets: "Clients with their own target",
      testTargets: "Clients with a test target",
      loadFailed: "Not all figures could be loaded.",
    },
    clientSensorDataExport: {
      title: "Sensor Data Export",
      description: "The recorded sensor data of the selected HyDry Boxes and Panels as an Excel file, one worksheet per device. A device only contributes the runs in which it was assigned to this client.",
      startDate: "Start date",
      endDate: "End date",
      selected: "{0} selected",
      selectAll: "Select all",
      selectNone: "Clear selection",
      none: "This client has no HyDry Boxes or Panels.",
      progress: "{0} of {1} devices processed",
      exportSuccess: "Export created successfully.",
      exportError: "An error occurred during export.",
      noData: "No readings available for the selected devices in the selected period.",
    },
    clientDevices: {
      title: "Devices",
      allDevices: "All devices",
      search: "Serial number",
      count: "Devices",
      kinds: {
        PANELS: "HyDry Panels",
        BOXES: "HyDry Boxes",
        MINIS: "HyDry Minis",
      },
      scopes: {
        CURRENT: "Currently assigned",
        FORMER: "Former",
      },
      filterGroups: {
        KIND: "Device type",
        PANEL_TYPE: "Panel type",
        PERIOD: "Period",
        ASSIGNMENT: "Assignment",
      },
      sorts: {
        SERIAL_NUMBER: "Serial number",
        ASSIGNMENT_TYPE: "Assignment",
        ASSIGNMENT_DATE: "Assignment date",
      },
      columns: {
        serialNumber: "Serial number",
        type: "Device type",
        assignment: "Assignment",
        firmware: "Firmware",
        lastContact: "Last contact",
      },
      since: "since {0}",
      open: "open",
      history: "All assignments",
      noHistory: "No assignments",
      build: "Build {0}",
      config: "Config {0}",
      ipu: "IPU {0}",
      display: "Display {0}",
      noneMatching: "No devices match these filters.",
      loadFailed: "The devices could not be loaded.",
    },
    clientProjects: {
      title: "Projects",
      search: "Name / number",
      count: "Projects",
      filterGroups: {
        STATUS: "Status",
        KIND: "Project type",
      },
      columns: {
        period: "Period",
        devices: "Devices",
        steps: "Steps",
      },
      since: "since {0}",
      officeNumber: "Office: {0}",
      erpNumber: "Group number: {0}",
      showMore: "Show more ({0} of {1})",
      noneMatching: "No projects match these filters.",
      loadFailed: "The projects could not be loaded.",
      archiveLoading: "{0} % loaded",
      archiveLoadFailed: "The old projects could not be loaded.",
    },
    clientReports: {
      title: "Reports",
      count: "Reports",
      columns: {
        report: "Report",
        project: "Project",
        date: "Date",
        size: "Size",
      },
      outdated: "outdated",
      sizeMb: "{0} MB",
      showMore: "Show more ({0} of {1})",
      none: "No reports yet.",
      loadFailed: "The reports could not be loaded.",
      loadMoreFailed: "More reports could not be loaded.",
      openFailed: "The report could not be opened.",
      fileMissing: "This report's file is missing.",
      noFile: "This report has no file.",
      popupBlocked: "Your browser blocked the new window. Allow pop-ups for IRES Office.",
    },
    clientUsers: {
      title: "Users",
      search: "Nickname / name",
      count: "Users",
      status: "Status",
      filterGroups: {
        STATUS: "Status",
        ROLE: "Role",
      },
      statuses: {
        ACTIVE: "Active",
        BLOCKED: "Blocked",
        DELETED: "Deleted",
      },
      noneMatching: "No users match these filters.",
      loadFailed: "The users could not be loaded.",
    },
    userSearch: {
      title: "Find users",
      search: "Email / Name / Short name / Staff number",
      count: "Users",
      capped: "the first {0} of {1}",
      client: "Client",
      hint: "Enter at least three characters: email address, name, short name or staff number.",
      none: "No user matches this search.",
      loadFailed: "The search failed.",
      nickname: "Short name {0}",
      staffNumber: "Staff number {0}",
      sharedEmailAddress: "Shared email",
      groupUser: "Group",
    },
    sharedUsers: {
      title: "Shared users",
      search: "Email / Name / Client",
      tabs: {
        emailAddresses: "Share email address",
        emailAddressesShort: "Email",
        group: "Group",
      },
      emailAddressCount: "Shared email addresses",
      groupUserCount: "Shared users",
      homeClient: "Home client",
      group: "Group",
      userCount: "1 user | {count} users",
      clientCount: "1 client | {count} clients",
      migrated: "Migrated",
      cleanUp: "Clean up",
      cleanUpAll: "Clean up all ({0})",
      cleaningUp: "Cleaning up {0} of {1} …",
      filters: {
        ALL: "All",
        CLEAN_UP: "To clean up",
        OK: "In order",
        MIGRATED: "Migrated",
      },
      states: {
        OK: "In order",
        STALE: "{0} no longer there",
        EMPTY: "Nobody left",
      },
      userStates: {
        LIVE: "Active",
        DELETED: "Deleted",
        MISSING: "No longer there",
        ADDRESS_CHANGED: "Other email address",
      },
      confirm: {
        title: "Clean up?",
        message: "These users no longer have {0} and will be removed from the shared email address:",
        entryDeleted: "Nobody is left afterwards: the entry is deleted, and the address is free again.",
        othersStay: "The other users keep the shared sign-in.",
        allMessage: "{0} shared email addresses have users who no longer exist. Do you want to clean up all of them?",
      },
      cleanedUp: "{0} cleaned up.",
      cleanedUpAll: "{0} shared email addresses cleaned up.",
      cleanUpFailed: "The clean-up failed.",
      refusals: {
        SHARED_LOGIN: "Nothing can be changed with the shared IRES admin login. Sign in with your own user.",
        NO_ENTRY: "This entry no longer exists.",
      },
      loadFailed: "The shared users could not be loaded.",
      none: "No entries match these filters.",
    },
    pdfTemplates: {
      loading: "Loading template …",
      title: "PDF templates",
      sharedTitle: "Shared PDF templates",
      search: "Name or file",
      count: "PDF templates",
      sharedCount: "Shared PDF templates",
      openShared: "Shared templates",
      sharedHint: "Shared templates can be taken over by every client. The HyDry certificate only uses a client's own templates.",
      columns: {
        name: "Template",
        fields: "Fields",
        problems: "Problems",
        lastSaved: "Last saved",
      },
      hyDryCertificate: "HyDry certificate",
      ignoredCertificate: "-HyDry, not used",
      problemValues: "1 value stays blank | {count} values stay blank",
      noProblems: "All values are filled",
      none: "No PDF templates yet.",
      noFields: "This template has no fields.",
      loadFailed: "The PDF templates could not be loaded.",
      notFound: "This PDF template does not exist.",
      download: "Download",
      downloadFailed: "The template could not be downloaded.",
      fileMissing: "This template's file is missing.",
      detail: {
        field: "Field",
        category: "Category",
        values: "Values",
        texts: "Text before / after",
        prefix: "before: “{0}” ({1})",
        suffix: "after: “{0}” ({1})",
      },
      statuses: {
        UNKNOWN_TO_CLOUD: "stays blank: IRES Cloud does not know this value",
        NOT_IMPLEMENTED: "stays blank: not implemented in IRES Cloud",
        CHECKBOX_ALWAYS_OFF: "checkbox always stays empty",
      },
      fieldTypes: {
        TEXT: "Text field",
        CHECK_BOX: "Checkbox",
        SIGNATURE: "Signature field",
        DROPDOWN: "Dropdown",
      },
      edit: {
        dialogTitle: "Edit {0}",
        filters: {
          ALL: "All fields",
          LINKED: "Linked",
          UNLINKED: "Not linked",
        },
        linkedCount: "{0} of {1} fields linked",
        notLinked: "not linked",
        notInPdf: "No longer in the PDF",
        childFields: "Group of {count} field | Group of {count} fields",
        noneMatching: "No fields match this filter.",
        unavailable: {
          NO_FILE: "This template has no file.",
          FILE_MISSING: "This template's file is missing.",
          ENCRYPTED: "The PDF is encrypted, so its fields cannot be read.",
          UNREADABLE: "The PDF cannot be read.",
        },
        onlyLinkedShown: "Only the linked fields are shown.",
        selection: "Selection",
        noValue: "No value linked yet.",
        addValue: "Add value",
        replaceValue: "Replace value",
        prefix: "Text before",
        suffix: "Text after",
        preview: "Preview",
        unlink: "Remove link",
        changedMeanwhile: "The template was saved in the meantime, for example in IRES Admin. Reload the page and make your changes again.",
        saveRefused: "Not saved: the link of “{0}” does not fit the PDF or the values of its category.",
        saveFailed: "The links could not be saved.",
        scopeClient: "Template of {0}: saved changes apply to every new PDF IRES Project creates for this client.",
        scopeCertificate: "This template also fills this client's HyDry certificate.",
        scopeShared: "Shared template: saved changes only apply to future take-overs. Clients that have already taken it over keep their copy unchanged.",
        confirmTitle: "Save links?",
        confirmClient: "You are saving the template “{0}” of {1}. New PDFs IRES Project creates for this client will then use the changed links.",
        confirmShared: "You are saving the shared template “{0}”. This only affects future take-overs; existing copies at clients stay unchanged.",
        changesAdded: "Newly linked: {0}",
        changesChanged: "Changed: {0}",
        changesRemoved: "Link removed: {0}",
      },
      files: {
        upload: "New template",
        uploadTitle: "New PDF template",
        replace: "Replace PDF",
        rename: "Rename",
        copyToShared: "Copy to shared templates",
        copyFromShared: "Take over from shared",
        delete: "Delete",
        deleteTitle: "Delete template?",
        preview: "Preview",
        previewFailed: "The preview could not be created.",
        popupBlocked: "The browser blocked the new window. Allow pop-ups for this page.",
        importMappings: "Take over links",
        fileLabel: "PDF file",
        nameLabel: "File name",
        sourceLabel: "Shared template",
        actions: {
          upload: "Upload",
          replace: "Replace",
          rename: "Rename",
          copy: "Copy",
        },
        problems: {
          EMPTY: "Enter a name.",
          TOO_LONG: "The name is too long.",
          INVALID_CHARACTERS: "The name must not contain / or \\ or ..",
          TAKEN: "A template here already has this name. Tablets keep a template under its name, so every PDF needs a new one.",
        },
        switches: {
          title: "How IRES Project reads the name:",
          hidden: "hidden in the picker; IRES Cloud may use it for the HyDry certificate",
          always: "offered in every phase and for every insurer",
          phase: "phase {0}",
          noPhase: "no phase",
          insurer: "only for insurer “{0}”",
          images: "with images (+Bild)",
          phases: {
            LEAK_DETECTION: "leak detection",
            DAMAGE_ASSESSMENT: "damage assessment",
            DRYING_CONCLUSION: "drying conclusion",
            REPAIR: "repair",
          },
        },
        consequences: {
          uploadClient: "The template becomes selectable in IRES Project for {0}.",
          uploadShared: "The template becomes available for every client to take over. It appears in IRES Project only after a take-over.",
          replaceClient: "New PDFs IRES Project creates for {0} use the new file.",
          replaceShared: "This only affects future take-overs; clients that took the template over keep their copy.",
          replaceFile: "The new file needs a new name because tablets keep a template under its name. The old file is kept and the links stay; fields the new PDF lacks are marked afterwards.",
          renameClient: "New PDFs IRES Project creates for {0} carry the new name, and its switches (phase, insurer, +Bild) apply from then on. Existing documents stay unchanged.",
          renameShared: "This only affects future take-overs; existing copies at clients keep their name.",
          copyToShared: "The copy becomes available for every client to take over. It is independent of {0}'s template: changes to one do not reach the other.",
          copyFromShared: "The copy belongs to {0} and becomes selectable there in IRES Project. It is independent of the shared template: changes to one do not reach the other.",
          deleteClient: "“{0}” of {1} will be deleted. IRES Project no longer offers it; existing documents stay unchanged.",
          deleteShared: "The shared template “{0}” will be deleted. Clients that took it over keep their copy.",
          deleteKeepsFile: "The file stays stored at IRES and can be restored.",
          certificateReplace: "This template fills this client's HyDry certificate. Keep -HyDry at the start of the name, or IRES Cloud no longer uses it for that.",
          certificateRename: "This template fills this client's HyDry certificate. Without -HyDry at the start of the name, IRES Cloud no longer uses it for that.",
          certificateLOST: "This client then has no template for the HyDry certificate; IRES Cloud creates no certificates then.",
          certificateCHANGED: "This client's HyDry certificate then uses another template.",
        },
        success: {
          created: "Template created. Now link its fields.",
          replaced: "PDF replaced.",
          renamed: "Template renamed.",
          copied: "Template copied to the shared templates.",
          deleted: "Template deleted.",
        },
        errors: {
          FILE_NAME_TAKEN: "This file name already exists here, also with a deleted or replaced template. Choose another.",
          FILE_TOO_LARGE: "The PDF is larger than 6 MB.",
          NOT_A_PDF: "The file is not a readable PDF.",
          ENCRYPTED: "The PDF is encrypted; its fields cannot be read.",
          NO_FILE: "This template's file is missing.",
          FILE_NAME_EMPTY: "Enter a name.",
          FILE_NAME_TOO_LONG: "The name is too long.",
          FILE_NAME_INVALID_CHARACTERS: "The name must not contain / or \\ or ..",
          FAILED: "That did not work. Try again.",
        },
        import: {
          title: "Take over links",
          sourceLabel: "From template",
          groups: {
            own: "Templates of this scope",
            shared: "Shared templates",
          },
          fresh: "{count} field without a link gets the template's link: | {count} fields without a link get the template's link:",
          conflicting: "These fields are linked differently here. Tick what should be overwritten:",
          nothing: "This template has no links for fields of this PDF that could be taken over.",
          missing: "{count} field of the template does not exist in this PDF; it is skipped. | {count} fields of the template do not exist in this PDF; they are skipped.",
          savedLater: "Taken over into your changes; saved only with SAVE.",
        },
      },
    },
    infoConfig: {
      title: "Descriptions",
      globalTarget: "Global target: {0}",
      newVersion: "New version",
      columns: {
        version: "Version",
        state: "Status",
        uploaded: "Uploaded",
      },
      filters: {
        CURRENT: "Current versions",
        TARGETS: "Targets",
        RETIRED: "Retired",
        LEGACY: "Leak detection (legacy)",
      },
      legacyHint: "These files belong to the standalone leak detection projects, which have not been created since 2021. They are read-only.",
      retiredHint: "Retired versions are no longer offered as a target. Projects that use them stay unchanged.",
      loadFailed: "The Descriptions could not be loaded.",
      none: "No versions.",
      badges: {
        globalTarget: "Global target",
        clientTargets: "Target of {count} client | Target of {count} clients",
        testTargets: "Test target at {count} client | Test target at {count} clients",
        retired: "Retired",
        unlisted: "Not listed",
        noFile: "File missing",
      },
      publish: {
        title: "New description version",
        file: "CSV file",
        version: "Version number",
        permanent: "A published version can no longer be changed or deleted, so check it first.",
        facts: "Encoding {0} · separator {1} · header {2} · {3} rows",
        noProblems: "No problems found.",
        acknowledge: "I have read the notes and want to publish anyway.",
        differences: "Differences from version {0}",
        noBase: "No global target to compare with.",
        check: "Check",
        publish: "Publish",
        published: "Version {0} published.",
        versionProblems: {
          FORMAT: "Digits, a dot and two decimals, e.g. 5.58.",
          TAKEN: "This version already exists.",
          NOT_NEWER: "The version must be higher than the newest.",
        },
      },
      problems: {
        line: "Line {0}:",
        NOT_UTF8: "The file is not UTF-8. Save it as “CSV UTF-8”, or the umlauts get lost on the tablets.",
        EMPTY_FILE: "The file is empty.",
        FIRST_LINE_WITHOUT_SEPARATOR: "The first line does not end with the separator; IRES Project detects the separator from it.",
        VERSION_HEADER_MISSING: "The first line must start with #Version.",
        VERSION_HEADER_MISMATCH: "The header names version {0}, but the file is to be published under another number.",
        VERSION_FORMAT: "“{0}” is not a valid version number (digits, a dot, two decimals).",
        ROW_TOO_SHORT: "Row {0} has too few columns; IRES Project could not read the whole file.",
        ROW_BEFORE_SECTION: "Row {0} stands before the first section and is skipped.",
        COMMA_SEPARATOR: "The file is separated by commas instead of semicolons.",
        VERSION_TAKEN: "Version {0} already exists.",
        VERSION_NOT_NEWER: "The version is not higher than the newest ({0}).",
      },
      differences: {
        none: "No differences.",
        optionChangesHint: "{count} option now stands at a position that meant something else before. | {count} options now stand at positions that meant something else before.",
        SECTION_ADDED: "Section added",
        SECTION_REMOVED: "Section removed",
        ROW_ADDED: "{0}: new",
        ROW_REMOVED: "{0}: removed",
        ROW_CHANGED: "{0}: label “{2}” → “{3}”",
        TYPE_CHANGED: "{0}: type {2} → {3}",
        OPTION_ADDED: "{0}, option {1}: new “{3}”",
        OPTION_REMOVED: "{0}, option {1}: “{2}” removed",
        OPTION_CHANGED: "{0}, option {1}: “{2}” → “{3}”",
      },
      detail: {
        loading: "Loading version {0} …",
        newFromThis: "New version from this",
        legacy: "Leak detection (legacy)",
        rowCount: "{count} row | {count} rows",
        notFound: "This version does not exist.",
        setGlobalTarget: "Make global target",
        setGlobalTargetTitle: "Change the global target?",
        setGlobalTargetMessage: "New projects of every client without its own target then use version {0}. Existing projects keep their version.",
        globalTargetSet: "Version {0} is now the global target.",
        retire: "Retire",
        retireTitle: "Retire this version?",
        retireMessage: "Version {0} is no longer offered in the lists or as a target. Projects that use it stay unchanged, and the file is kept.",
        retired: "Version {0} is retired.",
      },
      target: {
        editTitle: "Edit client's description",
        version: "Version",
        consequence: "New projects of this client then use this version. Existing projects keep theirs.",
        followGlobal: "Use the global target ({0})",
        saved: "Target saved.",
        change: "change",
      },
      errors: {
        CHECK_FAILED: "The file has errors; check it again.",
        WARNINGS_NOT_ACKNOWLEDGED: "Acknowledge the notes first.",
        VERSION_TAKEN: "This version exists by now.",
        VERSION_RETIRED: "This version is retired.",
        VERSION_IS_TARGET: "This version is still a target and cannot be retired.",
        NEEDS_SYSADMIN: "Only a SysAdmin of the portal may do this.",
        NO_FILE: "This version's file is missing.",
        FILE_TOO_LARGE: "The file is larger than 2 MB.",
        FAILED: "That did not work. Try again.",
      },
      sections: {
        search: "Key or text",
        noneMatching: "No row matches the search.",
        columns: {
          key: "Key",
          category: "Category",
          group: "Group",
          entry: "Entry",
          trade: "Trade",
          type: "Type",
          values: "Values",
        },
      },
      draft: {
        rowDialogTitle: "Edit {0}",
        title: "Draft {0} (from {1})",
        savedHere: "Saved in this browser",
        none: "No draft. Open a version and choose “New version from this”.",
        notSaved: "The browser does not keep the draft (private window or full storage). Reloading discards it.",
        discard: "Discard",
        discardTitle: "Discard the draft?",
        discardMessage: "All changes of this draft are lost. Published versions stay unchanged.",
        checkAndPublish: "Check and publish",
        changeVersion: "Change version number",
        insertRow: "Insert row after",
        insertRowMessage: "New row after {0}, same section.",
        removeRow: "Remove row",
        removeRowMessage: "Remove row {0} from the draft?",
        keyRequired: "Enter a key.",
        keyTaken: "This key already exists.",
        rowHint: "Changes apply to this draft only.",
        valuesHint: "The number on the left is the one the description refers to the value by (Boden0010-3 is the third value of Boden0010). In a row with a type a / and empty values do not count; in a row without a type (Def…) every cell counts.",
        addValue: "Add value",
        referencesShifted: "These references will then point at another value and are not adjusted:",
        referenceShift: "{0}: “{1}” → “{2}”, used in {3}",
        referenceGone: "{0}: “{1}” → no value, used in {2}",
        referencedByMore: "{0} and {1} more",
        replaceTitle: "Replace the open draft?",
        replaceMessage: "This browser already holds draft {0} (from {1}). A new draft replaces it.",
        replace: "Replace",
        openExisting: "Open it",
        open: "Open draft {0} (from {1})",
        continue: "Continue",
      },
    },
    deviceReports: {
      resultsTitle: "Results",
      matchingReports: "Matching test reports",
      filters: "Filters",
      device: "Device",
      anyDevice: "All devices",
      deviceCategory: "Device type",
      allCategories: "All",
      categoryComBox: "ComBox",
      categorySensor: "Sensor",
      categoryPanel: "Panel",
      allReportTypes: "All",
      period: "Period",
      noPeriodLimit: "No limit",
      maxAgeMonths: "Last",
      fromDate: "From date",
      monthsSuffix: "months",
      outcomeAll: "All",
      outcomePassed: "Passed",
      outcomeFailed: "Failed",
      assignment: "Assignment",
      assignmentAll: "All",
      assignmentAssigned: "Assigned",
      assignmentUnassigned: "Unassigned",
      categoryExcludesUnassigned: "Unassigned reports have no device yet, and therefore no device type. They are hidden while you filter by device type.",
      showReports: "Show reports",
      noneMatching: "No test reports match these filters.",
      countNone: "none",
      countApprox: "approx. {0}",
      pageLimited: "Showing the newest {0} assigned reports. Narrow the period to see older ones.",
      waitingBySerialNumber: "Device not created yet",
      waitingByMacAddress: "No serial number yet",
      title: "Test reports",
      serialNumber: "Serial number",
      searchHint: "Enter a serial number to see the device's test reports.",
      noneForDevice: "There are no test reports for this device.",
      loadFailed: "The test reports could not be loaded.",
      capturedAt: "Tested on",
      reportType: "Type",
      result: "Result",
      uploadedBy: "Uploaded by",
      initial: "Initial test",
      viewer: {
        title: "Test report",
        loadFailed: "The test report could not be loaded.",
        unknownDevice: "Unknown device",
        steps: "Test steps",
        step: "Step",
        comment: "Description",
        status: "Status",
        detail: "Detail",
        duration: "Duration",
        rawData: "Full report",
        formatPdf: "PDF",
        formatJson: "JSON",
        downloadFailed: "The test report could not be downloaded.",
      },
    },
  },
  administratorClient: {
    clientOptionsDialog: {
      message:
        "Multiple registration for HyDry Portal. Please select the desired client.",
      title: "Multiple registration for HyDry Portal",
      titleForSwitchingClient: "Select client",
    },
  },
  allDevices: {
    acquisitionDate: "Acquisition date",
    addNewCategory: "Create new category",
    addNewCategoryDesc: "Please enter name of new category",
    allDevicesOverview: "Devices overview",
    availability: "Availability",
    available: "Available",
    categoryNotSaved: "Category not saved",
    categorySaved: "Category successfully saved",
    createDeviceDialogTitle: "Create new device of type {0}",
    currentProject: "Current project",
    currentProjectStartedAt: "Project {0}, since {1}",
    deleteCategoryConfirmMessage:
      "Are you sure you want to delete category {0}?",
    deleteCategoryConfirmTitle: "Delete device category",
    deleteTemplateConfirmMessage:
      "Are you sure that device type {0} should be deleted?",
    deleteTemplateConfirmTitle: "Delete device type",
    deleted: "Deleted",
    deletionConfirmationDialog: {
      errorMessage: "Error when deleting devices",
      message: "Are you sure you want to delete all selected devices?",
      successMessage: "Devices successfully deleted",
      title: "Delete devices",
    },
    description:
      "Manage all devices: 1 device | Manage all devices: {count} device",
    descriptionAlt:
      "Select All Devices: 1 Device | Select All Devices: {count} devices",
    deviceCategoryDeleted: "Category successfully deleted",
    deviceCode: "Code",
    deviceCreated: "Device successfully added",
    deviceNotCreated: "Creation failed! Device could not be added.",
    deviceTemplateDeleted: "Device type successfully deleted",
    deviceTemplateNotSaved: "Device type not saved",
    deviceTemplateSaved: "Device type successfully saved",
    editCategory: "Rename device category",
    editCategoryDesc: "Please enter new name for category {0}",
    editDeviceType: "Edit device type",
    electricityMeter: "Power",
    electricityMeterForOtherDevices: "Power extern",
    electricityMeterManufacturer: "Meter manufacturer",
    electricityMeterManufacturerFull: "Electricity meter manufacturer",
    electricityMeterNumber: "Meter number",
    electricityMeterNumberAndManufacturer: "Meter number / manufacturer",
    electricityMeterNumberFull: "Electricity meter number",
    emptyDeviceCategoriesTemplatesHint:
      "No device categories created yet.\nCreate a new device category with +.",
    emptyDeviceCategory:
      "Category is still empty. You can create new device types in device administration.",
    emptyDeviceTemplatesHint:
      "No device types created yet. Create a new device type with +.",
    emptyDeviceTemplatesHintWithoutCreateOption: "No device types created yet.",
    emptyDevicesHint: "No devices found.\nCreate new device with +.",
    emptyPanelTypes: "No {0} found.",
    errorCategoryNotFound: "Category not found",
    errorDeviceNameEmpty: "Device type is empty.",
    errorDevicePowerUsageTypeEmpty: "Device usage type is empty.",
    errorDeviceTemplateHasDevices:
      "Device type that contains devices cannot be deleted",
    errorExistingCategoryName: "There is already a category with this name",
    errorExistingDeviceName: "Device type with this name already exists.",
    errorInvalidElectricityMeterManufacturer: "Meter manufacturer invalid",
    errorInvalidElectricityMeterNumber: "Meter number is invalid",
    errorInvalidManufacturer: "Manufacturer is invalid",
    errorInvalidNote: "Remark is invalid",
    errorInvalidQrCode: "QR/NFC code is invalid",
    errorInvalidSerialNumber: "Serial number is invalid",
    errorInventoryNumber: "Please enter inventory number",
    errorInventoryNumberAlreadyExists: "Inventory number is already in use",
    errorInventoryNumberInvalid: "Inventory number is invalid.",
    errorPowerConsumptionPerHourError: "Please enter typical power",
    errorQrCodeAlreadyExists: "QR code is already taken",
    errorQrCodeTooLong: "QR/NFC code exceeds maximum character limit of 30.",
    filterAllDevices: "All",
    filterAvailableDevices: "Available",
    filterDevicesInUsage: "in use",
    filterUnavailableDevices: "Not available",
    formatLastProjectTimeInfo: "{0} - {1}",
    inventoryNumber: "Inventory number",
    lastCheck: "last check",
    lastProject: "Last project",
    manageAllDevices: "Select devices",
    manufacturer: "Manufacturer",
    meterInfoStart: "Meter reading start: {0}",
    meterInfoStartEnd: "Meter reading {0} - {1}",
    multiDevicesEditDialog: {
      title: "Edit devices",
    },
    nextCheck: "next check",
    noDevicePowerUsage: "None",
    noDevicesFound: "No devices found",
    noMatchingDevicesFound: "No suitable devices found",
    noQrCode: "No code",
    notAvailable: "Not available",
    note: "Remark",
    operatingHours: "Operating hours",
    operatingHoursFromAssignment: "Assignment",
    powerConsumptionPerHour: "Typical power (W)",
    powerUsageType: "Meter",
    qrCodeNotStored: "None",
    qrCodeStored: "Stored",
    recentlyClosedProject: "Project {0}, from {1} to {2}",
    recentlyClosedProjectAlt: "Project {0}, {1}",
    serialNumber: "Serial number",
    title: "Manage all devices",
  },
  appointmentType: {
    damageAssessment: "Damage assessment",
    dryingConclusion: "Drying pack up",
    dryingSetup: "Drying set-up",
    followUpInspection: "Resubmission",
    leakDetection: "Leak detection",
    measurement: "Measurement",
    repair: "Restoration",
  },
  archivedProjectList: {
    activeFilters: "--- active filters: {0} ---",
    deletionConfirmationDialog: {
      errorMessage: "Selected projects could not be deleted",
      errorMessageAlt: "Selected projects could not be removed",
      message: "Are you sure you want to delete these projects?",
      messageAlt: "Are you sure you want to remove these projects irrevocably?",
      successMessage: "1 project deleted | {count} projects deleted",
      successMessageAlt: "1 project removed | {count} projects removed",
      title: "Delete 1 project | Delete {count} projects",
      titleAlt: "Remove 1 project | Remove {count} projects",
    },
    deletedProjectsOverview: "Deleted projects overview",
    description:
      "Manage old projects: 1 project | Manage old projects: {count} projects",
    descriptionAllProjects:
      "Global project search: 1 project found | Global project search: {count} projects found",
    descriptionAlt:
      "Manage deleted projects: 1 project | Manage deleted projects: {count} projects",
    descriptionSelectionMode:
      "Selection of old projects: 1 project | Selection of old projects: {count} projects",
    descriptionSelectionModeAlt:
      "Selection of deleted projects: 1 project | Selection of deleted projects: {count} projects",
    filterArchivedProjects: "archived",
    filterDeletedProjects: "deleted",
    hint: "Click to {0} project",
    manageDeletedProjects: "Select deleted projects",
    manageOldProjects: "Select old projects",
    loadingArchive: "{0} % loaded",
    noArchivedProjectsFound: "--- no old projects found ---",
    noProjectsFound: "--- no projects found ---",
    oldProjectsOverview: "Old projects overview",
    title: "Old projects",
    titleAllProjects: "All projects",
    delete: "Delete",
    permanentlyDelete: "Remove",
    projectsBeingLoaded: "... one moment, list is being created ...",
    restorationConfirmationDialog: {
      errorMessage: "Selected projects could not be restored",
      message: "Are you sure you want to restore the selected projects?",
      successMessage:
        "1 project restored and moved to FINISHED PROJECTS | {count} projects restored and moved to FINISHED PROJECTS",
      title: "Restoration of 1 project | Restoration of {count} projects",
    },
    restore: "restore",
    restoreAndDelete: "restore / delete",
    restoreAndPermanentDelete: "restore / remove",
    maximumProjectsSelectionLimitWarning:
      "A maximum of 100 projects can be selected",
  },
  archivedProjects: {
    deletionConfirmationDialog: {
      errorMessage: "Error when deleting project {0}. Project not deleted.",
      errorMessageAlt: "Error when removing project {0}. Project not removed.",
      message: "Are you sure you want to delete this project?",
      messageAlt: "Are you sure you want to remove this project irrevocably?",
      successMessage: "Project {0} deleted",
      successMessageAlt: "Project {0} removed",
      title: "Delete project {0}",
      titleAlt: "Remove project {0}",
    },
    restorationConfirmationDialog: {
      errorMessage:
        "Error during restoration of project {0}. Project not restored.",
      message: "Are you sure you want to restore this project?",
      messageAlt: "This project is archived. Restore project?",
      successMessage: "Project {0} restored and moved to FINISHED PROJECTS",
      title: "Restore project {0}",
      titleAlt: "Restore project",
    },
    restorationAndDeletionDialog: {
      message: "",
      title: "Restore / delete project {0}?",
      titleAlt: "Restore / remove project {0}?",
    },
  },
  assignDevice: {
    addAssignmentHint: "New assignment with +",
    addHyDryAssignmentHint: "Assign new Hydry devices with +",
    assignHyDryDevice: "Assign HyDry device",
    assignPanel: "Assign panel",
    assignToday: "Assign today",
    assignmentFrom: "Assignment from",
    assignmentHintTitle: "Assignment of HyDry Devices",
    assignmentUntil: "Assignment until",
    billingViaDevice: "Billing via: {0}",
    externalCountingStartDateError:
      "Assignment not possible. Start date must be on or after {0}.",
    externalCountingOpenAssignmentError:
      "Assignment not possible. Open assignment is not allowed because the billing device is assigned until {0}.",
    externalCountingEndDateError:
      "Assignment not possible. End date must be on or before {0}.",
    countingDeviceHasActiveDependentsError:
      "Release not possible. There are active assignments billed via this device. Please release those devices first.",
    countingDeviceWindowBeforeMinDate:
      "Assignment not possible. The assignment of device {0} ends before the earliest possible start date of this device.",
    countingDeviceEndDateTooEarlyError:
      "Release not possible. The end date must be on or after {0} because there are dependent devices with a later end date.",
    externalCountingStartDateAdjustedTitle: "Note",
    externalCountingStartDateAdjustedMessage:
      "The assignment start date was adjusted to match the assignment of device {0}.",
    collidingAssignment:
      "There is a different assignment on {0} (from {1}).\nAssignment not possible.",
    correct: "Update",
    correctedBy: "corrected {0} {1}",
    countedViaExternalDevice: "Electricity billing via another device?",
    deleteAssignmentMessage: "Are you sure you want to delete the assignment?",
    deleteAssignmentTitle: "Delete device assignment",
    deviceAlreadyAssigned:
      "HyDry device {0} is already assigned to project {1}.",
    genericDeviceAlreadyAssignedMessage:
      "Device {0} is already assigned to project {1}.",
    deviceAlreadyAssignedMessage:
      "There is a different assignment on {0} (up to {1}).\nAssignment cannot be created.",
    deviceAlreadyAssignedTitle: "HyDry device already assigned",
    genericDeviceAlreadyAssignedTitle: "Device already assigned",
    deviceBranchError: "Assignment not possible. HyDry Device is at site {0}.",
    dryingNoStartedWarning: "Drying not yet started",
    errorEndDateTitle: "Check date for end of assignment",
    errorMeterReadingEnd: "Value must be >= meter reading start",
    errorMeterReadingStart: "Value must be >= 0",
    errorStartDateTitle: "Check date for start of assignment",
    formatAssignComBox: "Assign HyDry Box {0}",
    formatAssignPanel: "Assign HyDry Panel {0}",
    formatCalculatedPowerConsumption: "Calculated power consumption:",
    assignmentHoursPrompt: "Please enter the assignment time in hours.",
    operationTimeHint: "{0} hours (calculated from {1} 12:00 to {2} 12:00)",
    formatHyDryInApartment: "HyDry devices flat {0}",
    formatHyDryInElectricitySupply: "HyDry devices electricity supply {0}",
    roomLevelAssignToRoomHint: "In this project, devices are assigned to a room. Use the plus next to the room.",
    roomLevelNoRoomsHint: "This flat has no rooms yet. Add a room first to assign devices.",
    formatPowerConsumption: "Power consumption: {0}",
    formatSignOffComBox: "Release HyDry Box {0}",
    formatSignOffPanel: "Release HyDry Panel {0}",
    genericAssignmentHintTitle: "Assignment of devices",
    meterReadingEnd: "Meter reading end:",
    meterReadingEndChanged: "Meter reading modified",
    meterReadingEndChangedMessage: "Meter reading modified. Save anyway?",
    meterReadingFromAssignment: "Project {0}: {1}",
    meterReadingFromIot: "read out: {0}",
    meterReadingStart: "Meter reading Start:",
    meterReadingsForPowerConsumption: "Meter readings for power consumption",
    selectNoCountingDevice: "Select none",
    selectCountingDeviceTitle: "Select device for electricity billing",
    useForElectricityBilling: "Use for electricity billing?",
    noAvailableHyDryDevices: "No available HyDry devices found",
    noAvailableDevices: "No available devices found",
    deviceAssignedToOtherProject: "This device is already assigned to project \"{0}\".",
    deviceInOtherBranch:
      "This device belongs to the site \"{0}\". Change its site to assign it to this project.",
    noMatchingDeviceFound: "No matching HyDry devices found",
    noProgramChainsInAssignmentWarning:
      "No drying found.\nPlease check time period.",
    note: "Remark: {0}",
    noUnassignedProgramChainFoundMessage:
      "No assignable dryings were found in assignment period.\nCreate assignment anyway?",
    powerConsumption: "Power consumption",
    powerConsumptionKWh: "Power consumption (kWh)",
    powerConsumptionRemote: "Power consumption (please check remote readings)",
    signOff: "Release",
    signOffToday: "Release today",
    releaseDependantDevicesFirst: "Dependent devices must be released first.",
    assignmentSavedSuccess: "Assignment saved successfully.",
    assignmentSavedError: "An error occurred while saving the assignment.",
    assignmentReleasedSuccess: "Assignment released successfully.",
    assignmentReleasedError: "An error occurred while releasing the assignment.",
    assignmentCorrectedSuccess: "Assignment corrected successfully.",
    assignmentCorrectedError: "An error occurred while correcting the assignment.",
    assignmentDeletedSuccess: "Assignment deleted successfully.",
    assignmentDeletedError: "An error occurred while deleting the assignment.",
    releaseDevices: "Release devices",
    devicesAssignedCount: "1 device assigned | {n} devices assigned",
  },
  assignDeviceToProjectBranchDialog: {
    changeBranch: "Get device",
    message:
      "Device {0} is available at site {1}.\nShould device be moved to current site {2}?",
    title: "Device at site",
  },
  assignIresDevice: {
    assignAnyway: "Assign on this day anyway",
    assignAnywayMessage:
      "Assignment is made from {0}.\nDrying {1} cannot be assigned.",
    chainWillBeAssignedMessage:
      "Release of device on {0}.\nDrying {1} is assigned.",
    dialogIncludeOverlappingProgramChainFinishedMessage:
      "A drying is running on {0} (drying {1}, started on {2}, finished on {3}). This drying is assigned. If possible, select a different day.",
    dialogOverlappingProgramChainFinishedMessage:
      "Drying is running on {0} (drying {1}, started on {2}, completed on {3}).\nThis drying is not assigned.\nIf possible, select a different day.",
    dialogOverlappingProgramChainMessage:
      "Drying is running on {0} (drying {1}, started on {2}).\nThis drying is not assigned.\nIf possible, select a different day.",
    releaseAnyway: "Release on this day anyway",
  },
  assignLicences: {
    basic: "Base",
    basicLicences: "Licences Basis",
    damageAssessmentAndLeakDetection: "Assessment",
    damageAssessmentAndLeakDetectionLicences: "Licences Assessment",
    drying: "Drying",
    dryingLicences: "Licences Drying",
    dryingAndRepair: "Drying",
    dryingAndRepairLicences: "Licences Drying",
    errorLicencesV3LimitExceeded: "Permitted licences exceeded. Not saved.",
    errorMissingLicences: "All licences of type {0} are already in use",
    formatUsage: "{0} from {1}",
    formatUsageMemberClients: "{0}",
    numMemberClients: "Branch offices (without Master)",
    leakDetection: "Leak detection",
    overviewLicences: "Overview licences",
    overviewUsedLicences: "Overview of licences used",
    selectLicences: "Select licences",
  },
  assignmentDetails: {
    titleComBox: "HyDry Box {0}",
    titlePanel: "HyDry Panel {0}",
  },
  changeEmailAndPassword: {
    changeEmailAndPasswordTitle: "Edit database email address and password",
    emailAddress: "Email address",
    emailAddressAlreadyUsed: "Email address is already in use",
    firstSignInMessage: "Please fill in the following fields",
    firstSignInTitle: "First registration",
    newEmailAddress: "New database mail address",
    oldPassword: "Current password",
    password: "Password",
    passwordError: "Password is incorrect",
  },
  chartData: {
    ground: "Floor",
    groundTemp: "Floor temperature",
    humidity: "Humidity",
    intensity: "Intensity",
    temp: "Temperature",
    wall: "Wall",
    wallTemp: "Wall temperature",
  },
  clientData: {
    addContactPerson: "Contact person +",
    addDevices: "Add devices",
    additionalInsuranceInfo: "Insurance detail",
    apartment: "Flat",
    apartmentNumber: "W{0}",
    appointmentAgreement: "Appointment",
    approveProject: "Confirm project",
    approvedBy: "Project confirmed: {0} by {1}",
    changeProjectOwner: "Change worker",
    changingProjectTypeToPortalMessage:
      "Are you sure that the Project Manager project should be changed to a Portal project?",
    changingProjectTypeToPortalTitle: "Change project type",
    changingProjectTypeToProjectmanagerMessage:
      "Are you sure that the Portal project should be changed to a Project Manager project?",
    changingProjectTypeToProjectmanagerTitle: "Change project type",
    client: "Orderer",
    confirmProject: "Confirm project",
    confirmProjectTitle: "Confirm project?",
    contact: "General contact",
    contactBy: "Contact through",
    contactPerson: "Contact flat",
    contract: "Order",
    contractCreatedBy: "Executed by",
    contractType: "Order type",
    copyClient: "Like orderer",
    copyPolicyHolder: "Like policyholder",
    createProject: "New project",
    createdAt: "Order recorded: {0} through {1}",
    createdWithAppVersion: "Project App Version",
    damage: "Damage",
    damageAssessment: "Damage assessment",
    damageDay: "Date of damage",
    damageId: "Damage reference",
    damageLocation: "Damage location",
    damageNumber: "Claim number",
    damageNumberShort: "Claim no.",
    damageType: "Damage type",
    datePlanned: "Date planned",
    deleteContactPartnerConfirmationMessage:
      "Really delete contact person {0}?",
    deleteContactPartnerConfirmationTitle: "Delete contact person",
    deleteContactPerson: "Contact person -",
    deleteContactPersonBlockedByDevices:
      "Apartment {0} cannot be deleted because devices are assigned.",
    contactPersonAddedSuccess: "Apartment {0} added",
    contactPersonDeletedSuccess: "Apartment {0} deleted",
    deleteProject: "Delete project",
    deleteProjectMessage: "Are you sure you want to delete this project?",
    deleteProjectErrorMessage:
      "Error when deleting project {0}. Project not deleted.",
    deleteProjectSuccessMessage: "Project {0} deleted",
    deleteProjectTitle: "Delete project {0}",
    directOrder: "Direct order",
    doNotApproveProject: "Do not confirm project",
    firstContact: "First contact",
    saveProjectErrorMessage: "Error saving project",
    formatApartment: "Flat {0}",
    formatElectricitySupply: "Electricity supply {0}",
    formatBranch: "Site: {0}",
    formatContactPerson: "Contact person {0}",
    formatNote: "Note: {0}",
    formatProjectNumberIres: "IRES project number: {0}",
    formatProjectNumberOffice: "Project number Office: {0}",
    formatProjectNumberOfficeForSantec: "Office project number: {0} / {1}",
    formatProjectOwner: "Worker: {0}",
    formatProjectStart: "Project start: {0}",
    formatProjectSupervisor: "Project manager: {0}",
    insurance: "Insurance",
    insuranceCase: "Insurance claim",
    insuranceContactName: "Name",
    insuranceName: "Insurance name",
    lossAdjuster: "Damage handler",
    mainContractNumber: "Main order number: {0}",
    missingProjectNumberOfficeMessage:
      "Project number “Office” not specified. Confirm project anyway?",
    missingProjectNumberOfficeTitle: "Office project number",
    mobilePhone: "Mobile {0}",
    moveProjectToFinishedDialog: {
      errorMessage: "Project {0} has not been moved to FINISHED PROJECTS",
      message:
        "Are you sure you want to move this project to FINISHED PROJECTS?",
      successMessage: "Project {0} has been moved to FINISHED PROJECTS",
      title: "Move project {0}",
    },
    moveProjectToRunningDialog: {
      acceptButtonText: "Reopen",
      acceptButtonTextAlt: "Reactivate",
      errorMessage: "Project {0} not reopened",
      errorMessageAlt: "Project {0} not reactivated",
      message: "Really reopen project?",
      messageAlt: "Really reactivate the project?",
      messageForRestoredProjects:
        "This project has been restored. Reopen project?",
      messageForRestoredProjectsAlt:
        "This project has been restored. Reactivate project?",
      successMessage: "Project {0} reopened and moved to CURRENT PROJECTS",
      successMessageAlt:
        "Project {0} reactivated and moved to CURRENT PROJECTS",
      title: "Reopen project {0}",
      titleAlt: "Reactivate project {0}",
    },
    newOrder: "New order",
    note: "Note",
    pdfDocument: "Add PDF 1",
    pdfDocument2: "Add PDF 2",
    pdfDocumentInfo: "Further information in PDF",
    phone: "Phone {0}",
    policy: "Police",
    policyHolder: "Policyholder",
    policyNumber: "Policy number",
    process: "Case",
    processNumber: "Case number",
    projectControl: "Project control",
    projectControlHint: "Enter and edit by clicking coloured fields",
    projectData: "Project data",
    projectHint: "Enter and edit by clicking coloured fields",
    projectName: "Project name",
    projectNameErp: "Group number",
    projectNumber: "Project number",
    projectNumberIres: "IRES project number",
    projectNumberOffice: "Office project number",
    projectOwner: "Worker",
    projectStartDate: "Project start",
    projectSupervisor: "Project manager",
    regulation: "Settlement",
    regulationBy: "Settlement by",
    rejectProject: "Reject project",
    rejectedBy: "Project rejected: {0} by {1}",
    runningTasksSuspensionDeleteQuestion: "Really delete?",
    runningTasksSuspensionMoveToFinishedQuestion:
      "Really move to FINISHED PROJECTS?",
    runningTasksSuspensionWarning:
      "Work is still running on this project ({0}). The task is suspended. | Work is still running on this project ({0}). The tasks are suspended.",
    setProjectOwner: "Set worker",
    setProjectSupervisor: "Set project manager",
    timePlanned: "Duration planned",
    title: "Salutation",
    uploadDocument: "Upload document",
  },
  clientSelector: {
    client: "Which branch office(s)?",
  },
  cockpit: {
    allDevices: "Device Management",
    allHyDryDevices: "All HyDry Devices",
    allProjects: "All Projects",
    appointmentManagement: "Appointment",
    appointments: {
      later: "Later",
      overdue: "Overdue",
      today: "Today",
      tomorrow: "Tomorrow",
    },
    createNewProject: "Create new project",
    dummyCardTitle: "Nothing to do!",
    extras: "Extras",
    formatCompany: "Branch office: {0}",
    iresExtra: {
      backToUser: "Back to {0}",
      selectClient: "Select client",
      selectSharedUser: "Select shared user",
      selectUser: "Select user",
    },
    iresExtras: "IRES Extras",
    myAppointments: "My Appointments",
    myHyDryDevices: "My HyDry devices",
    myMessages: "My Messages",
    myProjects: "My Projects",
    projectOrganisation: "Project organisation",
    projects: "Projects",
    relevantProjects: "Relevant Projects",
  },
  comBox: {
    deviceList: {
      formatSensorValuesFloor: "Floor: {0}, humidity: {1}",
      formatSensorValuesRoom: "Room: {0}, humidity: {1}",
    },
    deviceState: {
      active: "Drying in progress",
      dryRunEnded: "Drying finished",
      idle: "Start drying",
      lidClosed: "Lid closed",
      lidOpen: "Lid open",
      malfunction: "Error",
      paused: "Paused",
      powerFail: "Plug pulled",
      standBy: "Off",
      suspended: "suspended",
      transition: "Transition",
      waiting: "on hold",
      warning: "Warning",
    },
    dryingPauseType: {
      humidityThresholdReached: "Dehumidification pause active",
      manual: "Manual pause active",
      powerOverload: "Overload pause active",
      program: "Program pause active",
      temperatureTooHigh: "Overtemperature pause active",
    },
    errors: {
      error0: "Real-time clock defective",
      error1: "Invalid time",
      error2: "Memory defective (EEPROM)",
      error3: "Memory defective (SPI Flash)",
      error4: "Display timeout",
      error5: "Energy meter does not respond",
      error6: "No control sensor",
      error7: "Sensor temperature too high",
      error8: "Ambient temperature too high",
      error9: "Power consumption too high",
      error10: "Short circuit on one of the sensors",
      error11: "Sensor 1 does not respond",
      error11New: "At least one sensor does not respond",
      error12: "Sensor 2 does not respond",
      error13: "Sensor 3 does not respond",
      error14: "Sensor 4 does not respond",
      error15: "Ambient sensor does not respond",
      error15New: "Room sensor malfunction",
      error16: "Relay defective",
      error17: "BLE modem does not respond",
      error18: "NB1 modem does not boot",
      error19: "SIM card not recognised",
      error20: "Box reset to factory settings",
      error21: "Device config reset",
      error22: "Client config reset",
      error23: "Drying config reset",
      error24: "Watchdog reset",
      error25: "Overrun UART 1",
      error26: "Overrun UART 2",
      error27: "Overrun UART 3",
      error28: "Overrun UART 4",
      error29: "Overrun UART 5",
    },
    events: {
      event: "Event {0}",
      event1: "Box connected to power",
      event2: "Box switched on, drying interrupted",
      event3: "Box switched on, drying continued",
      event6: "Box switched on",
      event7: "Drying process started",
      event8: "New run started",
      event9: "Drying suspended",
      event10: "Drying resumed",
      event11: "Drying resumed",
      event12: "Drying finished",
      event13: "Start drying",
      event14: "Box switched off",
      event15: "Step completed",
      event16: "End of program",
      event17: "New run started (max. running time)",
      event18: "New run started (max. number of samples)",
      event20: "Night pause started",
      event21: "Night pause ended",
      event22: "Monitor sample",
      event23: "Monitor interval ended",
      event24: "Drying pause started",
      event25: "Drying pause ended",
      event26: "Extension phase",
      event28: "Warning",
      event29: "Malfunction",
      event30: "Restart (boot)",
      event31: "Box disconnected from power supply",
      event32: "BLE connection established",
      event33: "BLE connection removed",
      event34: "Start of program",
      event36: "Lid open",
      event37: "Lid closed",
      event40: "NB1 connection to network established",
      event41: "NB1 connection to network failed",
      event42: "NB1 connection with server established",
      event43: "NB1 connection to server failed",
      event44: "NB1 connection timeout",
      event45: "NB1 connection closed",
      event46: "NB1 network disconnected",
      event47: "NB1 deactivated",
      event48: "NB1 Connection terminated (0) (Log out)",
      event49: "NB1 connection terminated (1) (re-establish)",
      event50: "NB1 connection terminated (2)",
      event53: "NB1 update signal quality",
      event54: "NB1 modem switched on",
      event55: "NB1 modem switched off",
      event56: "NB1 Session Retry",
      event59: "Summer / winter time",
      event60: "Time updated",
      event61: "Restart (command)",
      event62: "Restart (new configuration)",
      event64: "Reset (device configuration)",
      event65: "Restart (new firmware)",
      event66: "Restart (new firmware display)",
      event67: "Update (configuration)",
      event68: "Update (firmware IPU)",
      event69: "Update (firmware display)",
      event70: "Battery voltage measurement",
      event71: "Depassivation battery started",
      event72: "Depassivation battery finished",
      event75: "128 errors on I2C2",
      event76: "NB1 status with powerfail",
      event77: "Sensor configuration changed",
      event80: "Room temperature too high",
      event81: "Room temperature okay",
      event82: "Room air sufficiently dehumidified",
      event83: "Room air dehumidified again",
      event84: "Room temperature very low",
      event86: "Room humidity very high",
      event88: "Overload pause",
      event125: "Socket was switched on with a delay",
      warningFixed: "Warning fixed",
    },
    formatComBox: "Box {0}",
    formatComBoxError: "Error {0}",
    formatComBoxInfo: "Info:\n{0}",
    formatComBoxWarning: "Warning:\n{0}",
    humidityUnit: {
      absoluteHumidity: "Abs. humidity",
      absoluteHumidityAll: "Abs. humidity/rain/pressure/power",
      absoluteHumidityAllWithoutPower: "Abs. humidity/rain/pressure",
      absoluteHumidityAndPower: "Abs. humidity/power",
      absoluteHumidityAndPressure: "Abs. humidity/pressure",
      formatAbsoluteHumidity: "{0} g/m³",
      formatAbsoluteHumidityAll: "{0} g/m³ / {1}mm / {2}hPa / {3}W",
      formatAbsoluteHumidityAllWithoutPower: "{0} g/m³ / {1}mm / {2}hPa",
      formatAbsoluteHumidityAndPower: "{0} g/m³ / {1}W",
      formatAbsoluteHumidityAndPressure: "{0} g/m³ / {1}hPa",
      formatMixingRatio: "{0} g/kg",
      formatMixingRatioAll: "{0} g/kg / {1}mm / {2}hPa / {3}W",
      formatMixingRatioAllWithoutPower: "{0} g/kg / {1}mm / {2}hPa",
      formatMixingRatioAndPower: "{0} g/kg / {1}W",
      formatMixingRatioAndPressure: "{0} g/kg / {1}hPa",
      formatPercent: "{0}%",
      formatPercentAll: "{0}% / {1}W / {2}hPa",
      formatPercentAndPressure: "{0}% / {1}hPa",
      formatPercentAndPowerConsumption: "{0}% / {1}W",
      formatPercentAndPowerConsumptionAndPressure: "{0}% / {1}W / {2}hPa",
      formatRelativeHumidity: "{0} %rF",
      mixingRatio: "Mixing ratio",
      mixingRatioAll: "Mix ratio/rain/pressure/power",
      mixingRatioAllWithoutPower: "Mix ratio/rain/pressure",
      mixingRatioAndPower: "Mix ratio/power",
      mixingRatioAndPressure: "Mix ratio/pressure",
      powerConsumption: "Power",
      relativeHumidity: "Rel. humidity",
      relativeHumidityAll: "Rel. humidity/rain/pressure/power",
      relativeHumidityAndPressure: "Rel. humidity/rain/pressure",
      relativeHumidityAndPowerConsumption: "Rel. humidity/power",
      relativeHumidityAndPowerConsumptionAndPressure:
        "Rel. humidity/power/pressure",
    },
    nightModeActive: "Night mode active",
    relativeHumidity: "Rel. humidity",
    sensorType: {
      bluetoothType3: "BLE type 3",
      bluetoothType1: "BLE type 1",
      bluetoothType5: "BLE type 5",
      empty: "No sensor",
      radon: "Radon",
      sht3x: "SHT3X",
      telaire: "Telaire",
      unknow: "Unknown",
    },
    temperature: "Temperature",
  },
  comBoxClientConfig: {
    clientConfig: "HyDry Control client configuration",
    createClientConfig: "Create HyDry Control client configuration",
    displayMessage: "Display text",
    expertMode: "Expert mode",
    formatSensorProgram: "S{0}",
    name: "Name",
    programmSensors: "Program sensors",
    selectableDryingPrograms: "Selectable drying programs",
    selectableDryingProgramsBox: "Selectable drying programs (Box)",
    selectableDryingProgramsMini: "Selectable drying programs (Mini)",
    defaultProgramMini: "Standard program (Mini)",
    selectableSensorPrograms: "Selectable sensor programs",
    sensor: "Sensor {0}",
    version: "Version",
  },
  sensorInfo: {
    title: "SENSOR INFO ({0})",
    titleRoom: "SENSOR INFO (ROOM)",
    serialNumber: "Serial number",
    type: "Type",
    status: "Status",
    statusOk: "OK",
    statusBatteryLow: "Battery low",
    statusPoorLink: "Poor link quality",
    statusSensorLost: "Sensor lost",
    statusTurnedOff: "Sensor was turned off manually",
    typeTempHumidity: "Temp / humidity sensor",
    typePressure: "Pressure sensor",
    typeHammerElectrode: "Hammer electrode",
    typeRadon: "Radon sensor",
    typeInternalSensor: "Internal box sensor",
    connection: "Connection",
    wired: "Wired",
    wireless: "Wireless",
    integrated: "Integrated",
    signalStrength: "Signal strength",
    batteryStatus: "Battery status",
    firmware: "Firmware",
    noData: "No sensor data available",
  },
  dryingGraph: {
    temperatureAxisLabel: "Temp",
    absoluteHumidityAxisLabel: "Abs. humidity",
    relativeHumidityAxisLabel: "Rel. humidity",
    mixingRatioAxisLabel: "Mix ratio",
    resistanceDigitsAxisLabel: "Digits",
    formatResistanceDigits: "{0}",
    tooltipSensorHumidity: "Humidity",
    tooltipSensorResistance: "Digits",
    tooltipSensorTemperature: "Temperature",
    tooltipWeather: "Weather",
    tooltipPower: "Power",
    tooltipIntensity: "Intensity",
    weatherDataUnavailable: "Weather data could not be loaded. Please try again later.",
  },
  comBoxDetail: {
    confirmMeterReadingPowerUpTitle: "HyDry Box is switched on",
    confirmMeterReadingUpMessage:
      "Please confirm current electricity meter reading",
    control: {
      change: "CHANGE",
      confirmPowerOn: {
        messageBox:
          "Are you sure you want to switch on the box?\nWhen lid is open, sockets are activated.",
        messageMini:
          "Are you sure you want to switch on the MINI?\nSockets are activated when the MINI is switched on.",
        title: "Switch on HyDry Box from standby",
      },
      formatPowerOnTitle: "Switch on Box {0}",
      iotMeterReadingHint:
        "Instruction is executed with next IoT connection. Meter reading is read and accepted via IoT. ",
      pause: "Pause",
      powerOff: "Switch off",
      powerOn: "Switch on",
      relays: "Relay",
      resume: "Resume",
      start: "Start",
      terminate: "Terminate",
    },
    controlConfig: {
      changeDryRun: "Box {0}: change drying",
      currentConfigUnknown:
        "This box's current settings are not known. The default settings are filled in: check them before you save.",
      defaultDryingMode: "Standard procedure",
      defaultNightMode: "Standard configuration night mode",
      defaultProgram: "Standard program",
      defaultProgramBox: "Standard program (Box)",
      defaultSocketAB: "Standard configuration sockets A+B",
      defaultSocketCD: "Standard configuration sockets C+D",
      dryRunParameters: "OPERATING PARAMETERS",
      dryingMode: "Procedure",
      dryingModeChangeDisabledDialogMessage:
        "Operating mode cannot be changed while drying is running. Finish drying first.",
      dryingModeChangeDisabledDialogTitle: "Change operating mode",
      dryingModeOptions: {
        monitor: "Monitor",
        negativePressure: "Underpressure",
        positivePressure: "Overpressure",
        pushPull: "Push-pull",
        roomDrying: "Room drying",
        tentDrying: "Target drying",
      },
      formatNightModeParameters: "from {0} to {1}\n{2} {3}",
      formatNightModeParametersAlternate: "{0}-{1}, {2}, {3}",
      formatNightModeParametersNoDaysAlternate: "{0}-{1}, {2}",
      missingFloorSensorWarningMessageForBoxDefault:
        "Drying program without floor sensors selected:\nProgram is controlled purely by time up to maximum program duration.",
      missingFloorSensorWarningMessageForBoxSupportingRoomDrying:
        "Drying program without floor sensors selected:\nProgram is controlled purely by time up to maximum program duration.\n\nWe recommend drying with the ROOM DRYING program.",
      missingFloorSensorWarningStartAnyway: "Start anyway",
      missingFloorSensorWarningTitle: "Check drying program",
      nightMode: "Night mode",
      nightModeDays: "Days for night mode",
      nightModeEnd: "End night mode",
      nightModeOff: "Night mode off",
      nightModeOn: "Night mode on",
      nightModeSockets: "Night mode sockets",
      nightModeSocketsOptions: {
        allSockets: "All sockets",
        allSocketsAlternate: "All",
        allSocketsShort: "All",
        allSocketsShortAlternate: "All",
        programSockets: "Program sockets",
        programSocketsAlternate: "Prog",
        programSocketsShort: "Prog",
        programSocketsShortAlternate: "Prog",
      },
      nightModeStart: "Start night mode",
      program: "Program",
      roomDryingHintMessageBox:
        "The following settings are recommended:\n\nSockets A+B PROG: Dehumidifier\nSockets C+D ON: Fan and/or devices for wall drying",
      roomDryingHintMessageMini:
        "The following settings are recommended:\n\nSocket A PROG: Dehumidifier\nSocket B ON: Fan and/or devices for wall drying",
      roomDryingHintTitle: "Room drying",
      sensors: "SENSORS",
      socketA: "Socket A",
      socketAB: "Sockets A+B",
      socketB: "Socket B",
      socketCD: "Sockets C+D",
      socketModeOptions: {
        off: "Off",
        on: "On",
        program: "Prog",
      },
      start: "Start",
      startDryRun: "Box {0}: Start drying",
    },
    floorTempHumidity: "Floor temp / humidity",
    tempHumidity: "Temp / humidity",
    formatEndOfPhase: "P{0} End",
    formatEndOfPhases: {
      boost: "Boost End",
      comfort: "Comfort End",
      eco: "Eco End",
      smart: "Smart End",
    },
    formatPhase: "Phase {0}",
    formatProgram: "P{0}",
    formatSensor: "Sensor {0}",
    monitor: "Monitor",
    nightModeParameters: {
      title: "Settings night mode",
    },
    pause: {
      confirm: "Confirm Pause",
      hint: "Pause (min)",
      message: "Please enter length of break (min)",
      title: "Pause Box {0}",
    },
    phases: "Phases",
    postDryingRun: "Post-run",
    program: "Program",
    programDryingSensor: "Drying sensor",
    programDryingTime: "Drying duration",
    roomTempHumidity: "Room temp / humidity",
    sensorData: {
      roomSensor: "Room",
      sensor: "Sensor",
    },
    sensorUsage: {
      measurement: "Measurement",
      measurementShort: "MEASURE",
      program: "Program",
      programShort: "PRG",
      reference: "Reference",
      referenceShort: "REF",
      usage: "Usage",
    },
    sensorUsageRecommendation: {
      dryingMode: "Operating mode",
      hint1: "The following sensor settings are recommended:",
      hint2: "See also operating instructions.",
      referenceSensor: "Reference sensor",
      roomSensor: "Room sensor",
      roomSensorOrSensor1: "Room sensor or sensor 1",
      sensor1: "Sensor 1",
      title: "Drying program with sensor control selected",
    },
    terminateDryRun: {
      dryRunKeyValues: "DRYING DATA",
      keyValueCurrent: "Current",
      keyValueDuration: "Duration",
      keyValueHumidity: "Humidity",
      keyValueMeter: "Meter",
      keyValueStart: "Start",
      terminateDryRun: "Finish drying",
    },
    testRelays: {
      numCycles: "Switching cycles",
      onOffDuration: "Switch-on and switch-off time (1/10 sec)",
      relay1Active: "Relay 1 active",
      relay2Active: "Relay 2 active",
      title: "Relay test {0}",
    },
    title: "Details Box {0}",
  },
  comBoxSampleIotInfo: {
    batteryVoltageToLow: "Battery voltage too low",
    disconnectFailure: "Error when sending NB1 disconnect",
    formatIotInfo:
      "Powerfail message: {0} ({1}), BC66: {2}, NB1: {3}, meter: {4}",
    iotConnectonDisabled: "NB1 connection deactivated",
    iotServerConnectionFailure: "IoT server not accessible",
    noIpAddress: "No IP address",
    noNetwork: "Login failed",
    reserved: "Reserved",
    socketFailure: "Error when opening the socket",
    success: "Successfully sent",
    timeoutIotServerConnect: "Timeout when connecting to IoT server",
    unexpectedModemReset: "Unexpected modem reset",
  },
  comBoxSettings: {
    battery: "Battery",
    electricityMeter: "Electricity meter",
    factoryReset: {
      action: "Factory reset",
      confirm: "Reset",
      consequences: {
        datalog: "All runs on the box are deleted. Runs the box has already sent stay in the portal.",
        queued: "The commands are queued via IoT and run at the box's next contact.",
        reboot: "The box restarts afterwards.",
        terminate: "If a drying is running on the box, it is ended first.",
      },
      flags: {
        bConfig: "Base config",
        cConfig: "Client config",
        counters: "Operating hours and power-up counter",
        datalog: "Datalog: delete all runs on the box",
        dConfig: "Drying and sensor programs",
        fileInfo: "Files: logo and firmware images",
      },
      queueFailed: "The reset could not be queued.",
      reboots: "Restarts the box",
      title: "Reset box {0}",
    },
    firmwareDisplay: "Firmware display",
    firmwareIPU: "Firmware IPU",
    mcuResetSource: "MCU Reset Source",
    mcuResetSourceValues: {
      independentWatchdog: "Independent watchdog",
      lowPower: "Low power",
      powerOn: "Power-On",
      resetPin: "Reset pin",
      software: "Software",
      windowWatchdog: "Window watchdog",
    },
    restartConfirmMessage: "The restart is queued via IoT.",
    restartConfirmTitle: "Restart box {0}?",
    title: "Settings Box {0}",
  },
  common: {
    abort: "CANCEL",
    apply: "APPLY",
    refresh: "Refresh",
    download: "Download",
    address: "Address",
    all: "All",
    allDevices: "All devices",
    activeDevices: "Active devices",
    activeHydryDevices: "Active HyDry devices",
    and: "and",
    api: "API",
    appointment: "Appointment",
    appUpdate: {
      message: "A new version is available.",
      refresh: "Reload",
      later: "Later",
    },
    archived: "Archived",
    areYouSure: "Are you sure?",
    assign: "Assign",
    back: "BACK",
    barcode: "BARCODE",
    both: "Both",
    box: "Box",
    branch: "Site",
    branchDeleted: "Site deleted",
    branches: "Sites",
    build: "Build {0} ({1})",
    change: "EDIT",
    changesNotSaved: "Changes not saved",
    changesSaved: "Changes saved",
    close: "CLOSE",
    concluded: "Finished",
    confirm: "Confirm",
    confirmationDialog: {
      cancelMessage:
        "You have already made changes. Would you like to discard these changes?",
      cancelTitle: "Discard changes?",
      unsavedChangesMessage: "Do you really want to cancel?",
      unsavedChangesTitle: "Caution: data loss",
    },
    confirmSignOutMessage: "Do you really want to log out?",
    confirmSignOutTitle: "Log out",
    country: "Country",
    currentProject: "Current project: {0}",
    dataComplete: "Data complete",
    dataSaved: "Data saved",
    date: "date",
    dayOfTheWeek: {
      friday: "Fri",
      monday: "Mon",
      saturday: "Sat",
      sunday: "Sun",
      thursday: "Thu",
      tuesday: "Tue",
      wednesday: "Wed",
    },
    delete: "Delete",
    deleted: "Deleted",
    details: "Details",
    development: "Development V{0}",
    device: "Device",
    deviceManager: "IRES Work",
    devices: "Devices",
    drying: "Drying",
    duration: {
      formatDays: "1 day | {count} days",
      formatDaysOpenEnded: "1 day | {count} days",
      formatHours: "1 hour | {count} hours",
      formatMinutes: "1 minute | {count} minutes",
      now: "Now",
    },
    edit: "Edit",
    electricityMeter: "Electricity meter",
    electricityMeterKwh: "Electricity meter (kWh):",
    email: "Email address",
    emailShort: "Email",
    invalidEmailAddress: "Invalid email address",
    end: "End",
    endViewAs: "End view as",
    execute: "Execute",
    executionBy: "Execution by",
    additionalUser: "Additional employee",
    additionalUsers: "Additional employees",
    addAdditionalUser: "Add additional employee",
    export: "Export",
    externalSystem: "External system",
    filter: "Filter",
    finished: "Finished",
    firstName: "First name",
    floor: "Address suffix",
    formatKWh: "{0} kWh",
    formatPercent: "{0} %",
    formatRelativeHumidity: "{0} %rF",
    formatRun: "Run {0}",
    formatRuns: "1 run | {count} runs",
    formatTemperature: "{0} °C",
    formatTemperatureCompact: "{0} °C",
    from: "from {0}",
    fromAlt: "off",
    fromUntil: "from {0} to {1}",
    fromUntilAlt: "from {0} to {1}",
    homeLocation: "Home location",
    houseNumber: "House number",
    hydryDevices: "HyDry devices",
    usedDevices: "Used devices",
    ires: "IRES",
    iresFunctionsHint: "Customer view",
    isAdmin: "YES",
    kwh: "kWh",
    lastName: "Last name",
    lastNameOrCompanyName: "Surname/Company",
    lastProject: "Last project: {0}",
    leakDetection: "Leak detection",
    load: "Loading",
    location: "Location",
    mobilePhone: "Mobile",
    moveToFinished: "Move",
    movedToFinished: "Moved",
    name: "Name",
    new: "New",
    never: "Never",
    nfc: "NFC",
    no: "No",
    noMatchFound: "No match found",
    none: "None",
    noUsersToShow: "No suitable user was found for this task.",
    notAvailable: "not available",
    numPanels: "{0} HyDry",
    off: "Off",
    ok: "OK",
    on: "On",
    onDate: "on {0}",
    open: "Open",
    otherDevices: "Other Devices",
    pageNotAvailable: "This page is not available to you.",
    panel: "Panel",
    phone: "Phone",
    portal: "IRES Office",
    production: "Production V{0}",
    project: "Project",
    projectAppVersion: "IRES Project {0}",
    projectType: "Project type",
    projectManager: "IRES Project",
    projects: "Projects",
    qrCode: "QR",
    roomInfoConfigVersion: "Description {0}",
    restore: "restore",
    restored: "Restored",
    save: "SAVE",
    saveData: "Save data",
    search: "Search",
    select: "Select",
    serialNumber: "Serial number",
    signOut: "Log out",
    more: "More",
    moreActions: "More actions",
    toggleTheme: "Toggle theme",
    signedInAs: "Logged in as {0}",
    since: "since {0}",
    sinceUntil: "from {0} to {1}",
    sort: "Sort",
    start: "start",
    startingAt: "from {0}",
    street: "Street",
    submit: "Apply",
    testProjectAppVersion: "[TEST] IRES Project {0}",
    testRoomInfoConfigVersion: "[TEST] Description {0}",
    time: "Time",
    timeOfDay: "Time",
    todo: "TODO",
    unknown: "Unknown",
    unsavedChangesDialog: {
      doNotSave: "DO NOT SAVE",
      message: "There are unsaved changes. Do you want to save them?",
      title: "Unsaved changes",
    },
    until: "to {0}",
    user: "User",
    userProjects: "View {0}",
    version: "Version: {0}",
    viewAsEndedNoRight: "View as has ended because you no longer have the right to use it.",
    viewAsEndedUserUnavailable: "View as has ended because the user is no longer available.",
    viewAsReadOnly: "Nothing can be changed while viewing as another user.",
    viewOf: "View on {0}",
    viewOfProjects: "View {0}",
    web: "Web",
    yes: "Yes",
    zipCode: "Postcode",
  },
  dataViewer: {
    rows: "Rows",
    columns: "Columns",
    search: "Search...",
    noResults: "No results found",
    noData: "No data available",
    noSections: "No sections available",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    editModeOn: "Edit",
    editModeOff: "Stop editing",
  },
  pdeViewer: {
    title: "Project Data Exchange (PDE)",
    loading: "Loading PDE...",
    loadError: "Failed to load PDE data",
    noStorageLocation: "No PDE file path available",
    download: "Download",
    noSelection: "None selected",
    saveSuccess: "PDE data saved",
    saveError: "Failed to save PDE data",
    sections: {
      projectInfo: "Project Info",
      apartments: "Apartments",
      rooms: "Rooms",
      consolidatedWorkItems: "Work Items (CWI)",
      materials: "Materials",
      timeEstimate: "Time Estimate",
      timeTracking: "Time Tracking",
      deviceAssignments: "Device Assignments",
      workItems: "Work Items",
      affectedComponents: "Affected Components",
    },
    fields: {
      projectIdIres: "Project ID IRES",
      projectIdErp: "Project ID ERP",
      projectTypeId: "Project Type",
      creationTimestamp: "Created",
      pdeSchemaVersion: "Schema Version",
      infoConfigVersion: "Description Version",
      erpBoQVersion: "BoQ Version",
      senderId: "Sender",
      projectStatus: "Status",
      apartmentNumber: "Apartment",
      lastName: "Last Name",
      firstName: "First Name",
      floor: "Floor",
      roomNumber: "Room No.",
      roomName: "Room Name",
      note: "Note",
      numberOfAffectedWalls: "Affected Walls",
      numberOfWalls: "Number of Walls",
      roomWidth: "Width",
      roomLength: "Length",
      roomHeight: "Height",
      roomArea: "Area",
      component: "Component",
      workItemId: "Work Item",
      billingItemId: "Billing Item",
      billingItemId2: "Billing Item 2",
      workItemText: "Description",
      billingItemTextErp: "ERP Text",
      quantityIres: "Qty IRES",
      quantityErp: "Qty ERP",
      quantityCompleted: "Qty Completed",
      unit: "Unit",
      phase: "Phase",
      trade: "Trade",
      serviceProviderIres: "Service Provider IRES",
      serviceProviderErp: "Service Provider ERP",
      chapter: "Chapter",
      section: "Section",
      paragraph: "Paragraph",
      asset: "Material",
      quantity: "Quantity",
      technicianId: "Technician",
      protectionHours: "Protection (hrs)",
      dismantlingHours: "Dismantling (hrs)",
      setupDryingHours: "Drying Setup (hrs)",
      measurementHours: "Measurement (hrs)",
      packupDryingHours: "Drying Packup (hrs)",
      restorationHours: "Restoration (hrs)",
      entryNumber: "No.",
      date: "Date",
      startOfWork: "Start",
      endOfWork: "End",
      travelTimeHours: "Travel Time (hrs)",
      leakDetectionHours: "Leak Detection (hrs)",
      damageAssessmentHours: "Damage Assessment (hrs)",
      userNumber: "Worker No.",
      workDone: "Work Done",
      materialUsed: "Material Used",
      deviceAssignmentNumber: "Assignment No.",
      deviceType: "Device Type",
      deviceId: "Device ID",
      countingDeviceId: "Counting Device ID",
      electricityMeterType: "Meter Type",
      meterStart: "Meter Start",
      meterEnd: "Meter End",
      consumption: "Consumption",
      fromDate: "From",
      toDate: "To",
      wallNumber: "Wall No.",
      componentWidth: "Component Width",
      componentLength: "Component Length",
      componentHeight: "Component Height",
      componentArea: "Component Area",
      damageWidth: "Damage Width",
      damageLength: "Damage Length",
      damageHeight: "Damage Height",
      damageArea: "Damage Area",
    },
    biInfo: {
      notFound: "No billing item found in the billing catalog.",
      noCatalogReference: "The PDE names no billing catalog, so no LV texts are available.",
      catalogNotFound: "No active billing catalog matches “{0}”, so no LV texts are available.",
      catalogAmbiguous: "Careful: {0} billing catalogs match “{1}”. The texts shown are from “{2}”. Please check that this is correct.",
      catalogLoadFailed: "The LV texts could not be loaded.",
    },
  },
  beschreibungViewer: {
    title: "Description (Tasks)",
    loading: "Loading description...",
    loadError: "Failed to load description data",
    noStorageLocation: "No file path available",
    download: "Download",
    sections: {
      projectInfo: "Project Info",
      apartments: "Apartments",
      rooms: "Rooms",
      workItems: "Work Items",
      materials: "Materials",
      timeEstimate: "Time Estimate",
      timeTracking: "Time Tracking",
      buildingStructure: "Building Structure",
      workItemChanges: "Work Item Changes",
      tasks: "Tasks",
    },
    fields: {
      projectId: "Project No.",
      address: "Address",
      dateTime: "Date/Time",
      lastName: "Last Name",
      firstName: "First Name",
    },
  },
  deviceDetailsDialog: {
    deviceInVehicle: "Device in vehicle {0}",
    deviceLastMovedInfo: "Loaded from {0} on {1}",
    openProject: "Open project",
    openVehicle: "Open vehicle",
  },
  deviceFilter: {
    active: "active",
    available: "available",
    finished: "finished",
    inUsage: "in use",
    noAssignedToProject: "without project",
    notAvailable: "not available",
    overall: "total",
    overdue: "overdue",
  },
  deviceHistory: {
    externalMeterUsed: "External counting",
    headerLabel: "Assignment {0}",
  },
  dryingHistory: {
    dryingHistoryDevice: "History device {0}",
    formatDryingHistoryBox: "History Box {0}",
    formatDryingHistoryPanel: "History Panel {0}",
    formatDryingHistoryWithChainNumber: "{0} Drying {1}",
    notAvailable: "--- history not available ---",
  },
  dryingInfo: {
    assigned: "Assigned",
    createDryingReport: "Drying report",
    day: "Day",
    devicesAssinged: "Assignment",
    drying: "Drying",
    endValue: "End",
    formatDurationClosedAssignment: "from {0} to {1} ({2})",
    formatDurationCompletedChain: "from {0} to {1} ({2})",
    formatDurationOpenAssignment: "since {0} ({1})",
    formatDurationOpenChain: "since {0} ({1})",
    formatMeterReading: "Start {0}, end {1}, consumption {2}",
    formatMeterReadingActiveProject: "Start {0}",
    formatMeterReadingActiveRun: "Start {0}, Current {1}, Consumption {2}",
    formatMeterReadingConsumed: "Consumption {0}",
    formatMeterReadingEnd: "End {0}",
    formatMeterReadingStart: "Start {0}",
    formatPercentageDryingPause: "{0}, of which {1} % drying pauses",
    formatRelativeAndAbsoluteChainNumber: "drying {0} ({1})",
    formatRelativeChainNumber: "Drying {0}",
    groundTemp: "Floor temperature °C",
    heatRatioWall: "Intensity wall %",
    humidity: "Humidity",
    latestValue: "Current",
    maxValue: "max",
    measurements: "Measured values",
    minValue: "min",
    noProject: "No project",
    program: "Program",
    project: "Project {0}",
    resistanceDigits: "Digits",
    startValue: "Start",
    temp: "Temp",
    wallTemp: "Temperature wall °C",
  },
  dryingProjectOverview: {
    apartments: "1 flat | {count} flats",
    damagePatternCompletedItem: "{0} {1} ({2})",
    damagePatternConclusionStates: {
      carryOutDrying: "Carry out drying",
      carryOutRestoration: "Perform restoration",
      noContract: "No order",
      noDryingNecessary: "No drying necessary",
      noRestorationNecessary: "No restoration necessary",
      onHold: "Project on hold",
      yesOffer: "Yes, make offer",
    },
    damagePatternProjectStates: {
      finished: "Project finished",
    },
    damagePatternItem: "{0} Damage pattern ({1})",
    devices: "1 device | {count} devices",
    dryingStartItem: "Start of drying",
    plannedDamageAssessmentItem: "{0} Damage assessment planned ({1})",
    projectItemFinished: "Project finished",
    projectNoContract: "Project finished, no order",
    projectNoDryingNecessary: "Project finished, no drying necessary",
    projectNumberItem: "{0} Project {1} ({2})",
    projectOnHold: "Project on hold",
    projectTitle: "Drying {0}",
    rooms: "1 room | {count} rooms",
  },
  hyDryEventLog: {
    date: "date",
    deleteNote: "Delete note",
    event: "Event",
    formatCycle: "Z{0}",
    formatPhase: "P{0}",
    formatStep: "S{0}",
    lid: "Lid",
    log: "Log",
    logbook: "Logbook",
    noLogs: "LOG is not yet available for this drying.",
    note: "Note",
    pause: "Pause",
    program: "Program",
    sortAscending: "Sort ascending",
    sortDescending: "Sort descending",
    step: "Step",
  },
  hyDryEvents: {
    categories: {
      longDescription: {
        alert: "Alert",
        drying: "Drying",
        ires: "IRES",
        lid: "Lid",
        note: "Note",
        organisation: "Organisation",
        other: "Others",
        pause: "Pause",
        sensor: "Sensor",
      },
      shortDescription: {
        alert: "Alert",
        drying: "Drying",
        ires: "IRES",
        lid: "Lid",
        note: "Note",
        organisation: "Orga",
        other: "Others",
        pause: "Pause",
        sensor: "Sensor",
      },
    },
    longDescription: {
      battery: "Battery {0}%",
      checkDryingProgress: "Check drying progress",
      comBoxDryingCompleted: "Drying finished",
      deviceOverdue: "IoT overdue",
      dryingEnded: "Drying finished",
      dryingParametersChanged: "Drying settings changed",
      dryingPausedAfterPowerOn: "Power back on, drying interrupted",
      dryingProgramDone: "Drying program finished",
      dryingProgramStarted: "Drying program started",
      dryingProgramTerminated: "Drying program finished",
      dryingProgressNotPlausible: "Drying process not plausible",
      dryingQualityAssessment: "Drying quality assessment",
      dryingResumed: "Drying resumed",
      dryingResumedAfterPowerOn: "Power back on, drying continues",
      dryingStartNotPlausible: "Start of drying not plausible",
      dryingStarted: "New drying started",
      dryingSucceed: "Drying finished",
      dryingSuspended: "Drying suspended",
      errorWhileDrying: "Device error during drying",
      firmware: "FW {0}",
      formatPowerFailWhileDrying: "Power loss during drying (more than {0} h)",
      interruptedDryingEnded: "interrupted drying completed",
      interruptedDryingResumed: "Suspended drying resumed",
      lidClosed: "Lid closed",
      lidOpened: "Lid open",
      malfunction: "Error {0}, no drying active",
      malfunctionWhileDrying: "Error {0}, drying in progress",
      manualPauseEnded: "Manual pause ended",
      manualPauseStarted: "Manual pause started",
      newDrying: "Start drying",
      note: "Note",
      pauseEnded: "Pause ended",
      pauseStarted: "Pause in drying",
      powerFailWhileDrying: "Power loss during drying",
      poweredOff: "Unplugged, no drying active",
      poweredOffWhileDrying: "Unplugged during drying",
      poweredOn: "Plugged in",
      programCompleted: "Drying program finished",
      programPauseEnded: "Program pause ended",
      programPauseStarted: "Program pause started",
      programPhaseEnded: "Phase {0} started",
      programStepCompleted: "Drying phase {0} started",
      prolongedPowerFail: "long power loss",
      roomDryingHumidityVeryHigh: "Room humidity very high",
      roomDryingPauseEndendHumidityTargetReached:
        "Room is dehumidified, pause Terminated",
      roomDryingPauseEndendTemperatureTooHigh:
        "Temperature okay, pause finished",
      roomDryingPauseStartedHumidityTargetReached:
        "Sufficiently dehumidified, pause started",
      roomDryingPauseStartedTemperatureTooHigh:
        "Temperature too high, pause started",
      roomDryingTemperatureVeryLow: "Room temperature very low",
      rssi: "RSSI {0}",
      sensorBackInRange: "Sensor (slot {0}) within range again",
      sensorBatteryWeak: "Sensor in slot {0}: Battery low",
      sensorButtonPressed: "Sensor in slot {0}: Button pressed",
      sensorConfigurationChanged: "Sensor configuration modified: {0}",
      sensorConfigurationChangedWithEventNo:
        "Sensor configuration changed (event {0}):\n{1}",
      sensorConfigurationSnapshot:
        "Drying started with sensor configuration {0}",
      sensorOutOfRange: "Sensor (slot {0}) out of range",
      sensorLinkGood: "Sensor in slot {0}: Connection ok",
      sensorLinkTimeout: "Sensor in slot {0}: Communication timeout",
      sensorLinkTimeoutResolved:
        "Sensor in slot {0}: Communication re-established",
      sensorLinkWeak: "Sensor in slot {0}: Connection weak",
      sensorTurnedOff: "Sensor (slot {0}) switched off",
      successfulDryingEndend: "Finished drying finalised",
      timerPauseEnded: "Night pause ended",
      timerPauseStarted: "Night pause started",
      turnedOff: "Switched off",
      turnedOn: "Switched on",
      unknownEvent: "Unknown",
      warning: "Warning: {0}, no drying active",
      warningWhileDrying: "Warning: {0}, drying in progress",
    },
    shortDescription: {
      battery: "Battery {0}%",
      checkDryingProgress: "Check drying progress",
      comBoxDryingCompleted: "Drying finished",
      deviceOverdue: "IoT overdue",
      dryingEnded: "Drying finished",
      dryingParametersChanged: "Drying settings changed",
      dryingPausedAfterPowerOn: "Drying suspended",
      dryingProgramDone: "Drying program",
      dryingProgramStarted: "Drying program started",
      dryingProgramTerminated: "Drying program finished",
      dryingProgressNotPlausible: "Check drying progress",
      dryingQualityAssessment: "Drying quality assessment",
      dryingResumed: "Drying resumed",
      dryingResumedAfterPowerOn: "Drying resumed",
      dryingStartNotPlausible: "Check drying progress",
      dryingStarted: "Drying started",
      dryingSucceed: "Drying finished",
      dryingSuspended: "Drying suspended",
      errorWhileDrying: "Device error",
      firmware: "FW {0}",
      formatPowerFailWhileDrying: "Power loss (> {0} h)",
      interruptedDryingEnded: "Drying finished",
      interruptedDryingResumed: "Drying resumed",
      lidClosed: "Lid closed",
      lidOpened: "Lid open",
      malfunction: "Error {0}, no drying active",
      malfunctionWhileDrying: "Error {0}, drying in progress",
      manualPauseEnded: "Manual pause ended",
      manualPauseStarted: "Manual pause started",
      newDrying: "Start drying",
      note: "Note",
      pauseEnded: "Pause ended",
      pauseStarted: "Pause started",
      powerFailWhileDrying: "Power loss",
      poweredOff: "Unplugged, no drying active",
      poweredOffWhileDrying: "Unplugged during drying",
      poweredOn: "Plugged in",
      programCompleted: "Drying program finished",
      programPauseEnded: "Program pause ended",
      programPauseStarted: "Program pause started",
      programPhaseEnded: "Program step {0} completed",
      programStepCompleted: "Drying has completed program step",
      prolongedPowerFail: "long power loss",
      roomDryingHumidityVeryHigh: "Room humidity very high",
      roomDryingPauseEndendHumidityTargetReached:
        "Room is dehumidified, pause Terminated",
      roomDryingPauseEndendTemperatureTooHigh:
        "Temperature okay, pause finished",
      roomDryingPauseStartedHumidityTargetReached:
        "Sufficiently dehumidified, pause started",
      roomDryingPauseStartedTemperatureTooHigh:
        "Temperature too high, pause started",
      roomDryingTemperatureVeryLow: "Room temperature very low",
      rssi: "RSSI {0}",
      sensorBackInRange: "Sensor (slot {0}) within range again",
      sensorBatteryWeak: "Sensor in slot {0}: Battery low",
      sensorButtonPressed: "Sensor in slot {0}: Button pressed",
      sensorConfigurationChanged: "Sensor configuration modified: {0}",
      sensorConfigurationChangedWithEventNo:
        "Sensor configuration changed (event {0}):\n{1}",
      sensorConfigurationSnapshot:
        "Drying started with sensor configuration {0}",
      sensorOutOfRange: "Sensor (slot {0}) out of range",
      sensorLinkGood: "Sensor in slot {0}: Connection good",
      sensorLinkTimeout: "Sensor in slot {0}: Communication timeout",
      sensorLinkTimeoutResolved:
        "Sensor in slot {0}: Communication re-established",
      sensorLinkWeak: "Sensor in slot {0}: Connection weak",
      sensorTurnedOff: "Sensor (slot {0}) switched off",
      successfulDryingEndend: "Drying finished",
      timerPauseEnded: "Night pause ended",
      timerPauseStarted: "Night pause started",
      turnedOff: "Switched off",
      turnedOn: "Switched on",
      unknownEvent: "Unknown",
      warning: "Warning: {0}, no drying active",
      warningWhileDrying: "Warning: {0}, drying in progress",
    },
  },
  iresDevice: {
    deviceAssignedToProject: "Device assigned to a project",
    deviceInUsage: "Device is in use",
    deviceNotAvailable: "Device is assigned to another branch",
    formatBatteryStatus: "{0} V, grade {1}",
    moveDevicesButtonText: "Move devices",
    moveDevicesDialog: {
      assignmentStartDate: "from date",
      branch: "Site",
      client: "Which branch office(s)?",
      errorMessage: "Devices could not be moved",
      successMessage: "1 device moved | {count} devices moved",
      title: "Move devices",
    },
    notAvailable: "--- Device not available ---",
  },
  iresDeviceDetail: {
    comBoxDoesNotExist: "There is no HyDry Box with the serial number {0}.",
    panelDoesNotExist: "There is no HyDry Panel with the serial number {0}.",
    neverReportedSince: "{0} was created on {1} but has never reported in.",
    neverReported: "{0} has been created but has never reported in.",
    warningCheckProjectAssignment: "Check project assignment period",
    warningNoProgramChainsInClosedAssignment:
      "Assignment does not include a drying",
  },
  iresDeviceSensor: {
    floorSensor1: "Sensor1",
    floorSensor2: "Sensor2",
    floorSensor3: "Sensor3",
    floorSensor4: "Sensor4",
    floorSensor5: "Sensor5",
    floorSensor6: "Sensor6",
    floorSensor7: "Sensor7",
    floorSensor8: "Sensor8",
    ground: "Floor",
    guideSensor: "Control",
    humidity: "Humidity",
    resistanceDigits: "Digits",
    intensity: "Intensity",
    intensityAll: "Intensity/Rain/Pressure",
    intensityAndRelativeHumidityAndPressure: "Intensity/rel. humidity/pressure",
    roomSensor: "Room",
    temperature: "Temperature",
    wall: "Wall",
  },
  iresDeviceType: {
    box: "HyDry Box",
    edge: "HyDry Edge",
    formatHyDryBox: "HyDry Box {0}",
    formatHyDryMini: "HyDry Mini {0}",
    formatHyDryPanel: "HyDry Panel {0}",
    mini: "HyDry Mini",
    panel: "HyDry Panel",
    slim: "HyDry Slim",
  },
  joinSharedEmailAddress: {
    errorWrongPassword: "Password invalid",
    formatMessage:
      "Email address {0} is shared by another user.\nPlease enter password of shared email address.",
    title: "Shared email address",
  },
  language: {
    de: "German",
    en: "English",
    fr: "French",
    it: "Italian",
    pl: "Polish",
  },
  leakDetectionProjectOverview: {
    conclusion: "Finalisation",
    leakDetection: "Leak detection",
    projectCreation: "New project",
    projectItemFinished: "Project finished",
    projectTitle: "Leak detection: {0}",
  },
  location: {
    addressEdited: "Address changed. Click to look the position up again.",
    ambiguous:
      "This address matches {0} possible places. Pick the right one from the suggestion list, or place the point yourself.",
    backfilled: "Postcode and city taken from the address found: {0}",
    confidence: {
      CONFIRMED: "Address confirmed",
      GOOD: "Located automatically, good quality",
      POOR: "Located automatically, poor quality",
      UNRELIABLE: "No usable position",
    },
    crossCheckMismatch:
      "The position found belongs to a different address than the one you entered. Please check it on the map.",
    geocodingFailed: "Address could not be found. Please place the pin yourself on the map.",
    legend: {
      CONFIRMED: "confirmed",
      GOOD: "good",
      POOR: "imprecise",
      UNRELIABLE: "unusable",
      title: "Colours",
    },
    lookingUp: "Looking up the position …",
    mapLoadFailed: "The map could not be loaded.",
    noAddress: "Please enter at least a city, street or postal code.",
    pickerHint:
      "Drag the point or click the map to set the position exactly. The position is saved for the travel features; the address you entered stays unchanged.",
    pickerHintReadonly: "Position of the address.",
    pickerTitle: "Position",
    quality: {
      APPROXIMATE: "Show on map (approximate area)",
      GEOMETRIC_CENTER: "Show on map (centre of the street or locality)",
      MANUAL: "Show on map (placed by hand)",
      RANGE_INTERPOLATED: "Show on map (house number estimated)",
      ROOFTOP: "Show on map (exact building)",
      none: "Not located yet. Show on map",
      unknown: "Show on map (precision unknown)",
    },
    search: {
      hint: "Type the address and pick the matching suggestion.",
      label: "Search address",
      noResults: "No suggestions found.",
    },
  },
  login: {
    clientHandover: {
      opening: "Opening as the client …",
      failed: "Signing in as the client failed. Close this tab and try again in the IRES Admin Client.",
      refused: "Signing in as the client was refused: {0} Close this tab.",
    },
    backToLogin: "Back to login",
    clientPortal: "HyDry client portal",
    clientPortalEmail: "Mail address Portal",
    emailAddress: "Email address",
    forgotPassword: "Forgot password?",
    forgotUserPassword: "Forgot user password?",
    forgotUserPasswordMessage:
      "Please contact your administrator or contact IRES at support@hydry.de",
    login: "Log in",
    loginContactEmail: "Mail support@hydry.de",
    loginContactText:
      "If you as our partner are not registered for use, please let us know by email.",
    loginFailed: "Login failed. Please check your email address and password.",
    loginFailedBlocked: "Log in failed. User with mail address {0} is blocked.",
    signInRefused: {
      CLIENT_BLOCKED: "Sign-in not possible. Your company's access is blocked. Please contact IRES.",
      USER_BLOCKED: "Sign-in not possible. Your user is blocked. Please contact an administrator.",
    },
    loginWelcomeText: "Please log in",
    loginWelcomeTitle: "HyDry Device Management and Remote Control",
    networkBlocked:
      "Connection blocked. Please check your proxy or VPN settings and try again.",
    noInternetAvailable:
      "No Internet connection. Please check your network connection and try again.",
    password: "Password",
    passowrdEmailSharing: "Password",
    passwordResetEmailAlreadySent:
      "An email to reset your password has already been sent. Please check your inbox and, if necessary, your spam folder.",
    passwordResetEmailError:
      "An error occurred while sending the email to reset your password. Please try again.",
    passwordResetEmailSent:
      "The email to reset your password has been sent successfully.",
    passwordResetSharedEmailError:
      "The password for a shared user cannot be reset. Please contact the system administrator.",
    pleaseSignIn: "Please enter user ID and password",
    pleaseSignInWithEmail: "Please enter email address",
    resetPassword: "RESET PASSWORD",
    sessionEnd: "You have logged in on another device",
    unknownEmailAddress:
      "HyDry portal login for {0}: Email address {1} could not be found. Has the user been created correctly?",
    userIdentification: "User ID",
  },
  messageSettings: {
    erp: "ERP",
    erpConnection: "ERP connection",
    filterAll: "Filter total",
    filterMyProject: "Messages from projects",
    filterNoProject: "Filter project",
    logCategories: "Log classes",
    logCategoriesTotal: "Log classes total",
    mailboxes: "Mailboxes",
    messages: "Messages",
    organisationCapability: "Orga role",
    organisationRole: "Orga role",
    projectRole: "Project role",
    selectLogCategories: "Select Log classes",
    showMessagesToProjectOwners: "To project owner",
    showMessagesToProjectSupervisors: "To project manager",
  },
  messages: {
    details: {
      currentProject: "Current project",
      device: "Device",
    },
    formatDrying: "Drying {0}",
    formatMessagesTitle: "New messages ({0})",
    formatMoreMessages: "+{0}",
    formatNewMessages: "{0} total",
    formatNewMessagesForCapability: "{0} to {1}",
    formatNewMessagesForMailbox: "{0} new to mailbox {1}",
    formatNewMessagesForMe: "{0} to me",
    formatNewMessagesForRole: "{0} to {1}",
    formatNumNewMesssages: "1 new message | {count} new messages",
    markAsRead: "Read",
    message: "Message",
    messages: "Messages",
    newMessages: "total",
    newMessagesForCapability: "to {0}",
    newMessagesForMailbox: "to mailbox {0}",
    newMessagesForMe: "to me",
    newMessagesForRole: "to {0}",
    noMessagesFound: "--- no messages found ---",
    sortBy: {
      messageDate: "Latest",
      projectNumber: "Project number",
      serialNumber: "Serial number",
    },
    yesterday: "Yesterday",
  },
  openProgramChainDecision: {
    confirmReleaseMessage:
      "The release takes place on {0}.\nDrying {1} is assigned.\nIf necessary, correct the end meter reading.",
    decide: "Please decide",
    deleteAssignment: "Delete assignment",
    message:
      "Drying is in progress on {0} (drying {1}, started on {2}).\n\nShould the assignment really be cancelled at {3}? The drying in progress is then terminated and the meter reading can be adjusted if necessary.",
    noProgramChainsFoundInAssignmentRange:
      "No assignable dryings were found during assignment period. Cancel assignment anyway?",
    openProgramChain: "Drying ongoing",
    recentlyActiveDeviceWarning:
      "Alternatively, you should CANCEL and select a different release date.",
    release: "Log out",
    releaseDescription: "Log out anyway",
    stop: "Stop",
    stopBoxMessage: "Would you like to terminate drying with box {0}?",
    stopCommandQueuedMessage:
      "STOP command via IoT queued. Would you like to wait or log out now anyway?",
    stopDescription: "Terminate drying now?",
    stopDrying: "Terminate drying",
    stopPanelMessage: "Would you like to terminate drying with panel {0}?",
    wait: "Waiting",
    waitDescription: "Wait for end of drying",
  },
  notFound: {
    message: "This page does not exist (any more).",
    toCockpit: "To the Cockpit",
  },
  overview: {
    active: "active",
    activeProjects: "Active projects",
    availableIresDevices: "Available HyDry devices",
    default: "HyDry Project Manager",
    deviceTypeHyDryComBoxes: "HyDry boxes",
    deviceTypeHyDryPanels: "HyDry Panels",
    deviceTypes: "1 Device type | {count} Device types",
    devices: "1 device | {count} devices",
    devicesOnlyWebsite: "HyDry",
    error: "Error",
    finished: "finished",
    inUsage: "in use",
    iotClientPortal: "HyDry client portal",
    manageDevices: "Manage devices",
    manageProjects: "Manage projects",
    office: "Office",
    overall: "total",
    overdue: "overdue",
    projectManagement: "Project administration",
    projectOption: "HyDry Project Option",
    recentlyFinished: "finished",
    warning: "Warning",
    website: "HyDry Project Portal",
    withDevice: "of which with HyDry devices",
  },
  pages: {
    allDevices: "All devices",
    archivedProjects: "Old projects",
    cockpit: "Cockpit",
    createProject: "New project",
    devices: "HyDry Devices",
    help: "About",
    maps: "Maps",
    mira: "Mira",
    messages: "Messages",
    notFound: "Page not found",
    overview: "Overview",
    panelDetails: "Panel details",
    projectDetails: "Project details",
    projects: "Projects",
    aiPredictions: "RENO",
    scheduling: "Scheduling",
    settings: "Settings",
    users: "User",
    vehicles: "Vehicle loading",
    timeTrackingHistory: "Time Tracking",
  },
  panel: {
    events: {
      event: "Event {0}",
      event0: "Data Sample every minute",
      event1: "Switched on",
      event10: "Program end (last stage)",
      event11: "Program end (maximum duration)",
      event12: "Program end (heating share)",
      event13: "Program end (manual)",
      event13Log: "Drying finished manually",
      event14: "Cooling phase cancelled",
      event15: "Drying continues",
      event16: "Max. drying duration reached",
      event18: "Step completed",
      event19: "Manual restart",
      event1Log: "Panel switched on",
      event2: "Plug pulled",
      event20: "Maximum heating duration exceeded",
      event20Warning: "Warning: Maximum heating time exceeded",
      event21: "Warning: Position sensor triggered",
      event22: "Max. floor temperature reached",
      event24: "Temperature exceeded (85 °C)",
      event24Log: "Temperature exceeded on wall and / or floor",
      event25: "Housing temperature too high",
      event255: "Unknown",
      event25Log: "Exceeded temperature in the panel housing",
      event26: "Max. sensor chip temperature reached",
      event27: "Max. sensor chip temperature for Edge reached",
      event28: "Heating panel switched on",
      event28Log: "Heating panel (wall) active again after overtemperature",
      event29: "Floor heating panel switched on",
      event29Log: "Heating panel (floor) active again after overheating",
      event2Log: "Unplugged during drying",
      event3: "Restart after mains interruption / reset",
      event30: "NB1 connection to network failed",
      event31: "NB1 connection to network established",
      event32: "NB1 connection to server failed",
      event33: "NB1 connection with server established",
      event34: "NB1 connection timeout",
      event35: "NB1 Connection terminated (0) (Log out)",
      event36: "NB1 connection terminated (1) (re-establish)",
      event37: "NB1 connection ended (2) (timeout)",
      event39: "NB1 not available",
      event39Log: "NB1 modem switched off",
      event4: "Automatic start",
      event48: "DATALOG_EVT_MIN_MALFUNCTION",
      event49: "DATALOG_EVT_POSITION",
      event5: "Manual start",
      event50: "Error: EEPROM cannot be initialised.",
      event51: "Error: Device configuration incorrect.",
      event52: "Error: SPI flash cannot be initialised.",
      event53: "Error: Datalog not consistent (file system defective?)",
      event54: "Error: RTCC cannot be initialised.",
      event55: "Error: Time on device is incorrect or clock is not set.",
      event56:
        "Error: ADC converter of the MCU is defective or supplies incorrect values.",
      event57: "Error: IR sensor defective.",
      event59: "Error: Energy meter is defective or provides incorrect values.",
      event5Log: "Manual start of drying",
      event6: "Start after switch-on delay",
      event60: "Error: Power usage does not match the operating status.",
      event61: "Error: Program table is invalid.",
      event62:
        "Safety shutdown (hardware temperature alarm) has been triggered.",
      event63:
        "Error: Acceleration sensor for position detection is defective.",
      event64: "Error: BLE module",
      event65: "Error: NB1 module",
      event66: "DATALOG_OUT_OF_TIME",
      event68: "Firmware update started",
      event69: "Firmware update successful",
      event6Log: "Program start after WAIT",
      event7: "Start after reaching base temperature",
      event70: "Measurement battery",
      event71: "Heating off",
      event71Log: "Power monitoring active: Please check power supply!",
      event72: "Heating on",
      event72Log: "Power monitoring ended: Power supply OK.",
      event73: "Power reduction due to fluctuations in supply voltage.",
      event74: "Fluctuations in supply voltage",
      event75: "Supply voltage stable",
      event76: "NB1 status with powerfail",
      event8: "Step event",
      event80: "Reboot for config update",
      event81: "Reboot for firmware update",
      event82: "Time set",
      event9: "Start follow-up program",
      event90: "Depassivation start",
      event91: "Depassivation end",
    },
  },
  panelControl: {
    command: "Command",
    commandFlag: "Command flag",
    confirmCancelQueuedRequestMessage: "Are you sure?",
    confirmCancelQueuedRequestTitle: "Stop queued action",
    executingCommandImmediatly: "Communication via IoT will takes a moment.",
    executingCommandNextIotConnection:
      "Instruction is executed with next IoT connection.",
    loadRunsQueued: "Loading run data queued",
    programSelection: "Program selection",
    queuedRequestFactoryReset: "Reset via IoT queued",
    queuedRequestLoadRuns: "Loading run data via IoT queued",
    queuedRequestPause: "Pause via IoT queued",
    queuedRequestPowerChangeDryRun: "Change via IoT queued",
    queuedRequestPowerOffComBox: "Switch off via IoT queued",
    queuedRequestPowerOnComBox: "Switch on via IoT queued",
    queuedRequestPowerStartDryRun: "Start via IoT queued",
    queuedRequestRelayTest: "Relay test via IoT queued",
    queuedRequestRestartPanel: "Restart via IoT queued",
    queuedRequestResume: "Resume via IoT queued",
    queuedRequestSelectProgram: "Program start {0} via IoT queued",
    queuedRequestStartPanel: "Start via IoT queued",
    queuedRequestStopPanel: "Stop via IoT queued",
    queuedRequestTerminate: "Terminate drying queued via IoT",
    queuedRequestUpdateIotConfig: "Update IoT Config via IoT queued",
    runId: "Run ID",
    runIdError: "Please enter a number between 0 and 255.",
    start: "Start",
    startPanelTitle: "Start panel {0} with P {1} {2}",
    startQueued: "Start queued",
    stopPanelTitle: "Stop panel {0}",
    stopQueued: "Stop noted",
  },
  panelDetail: {
    actions: {
      closeProgramChainText: "Drying from {0} to",
      endDrying: "Terminate drying",
      history: "History",
      loadRuns: "Load runs",
      notes: "Notes",
      programChooser: "Program selection",
      progress: "Progress",
      restart: "Restart",
      graph: "Graph",
      runs: "Runs",
      setComBoxOffline: "Release box",
      setHyDryDeviceOffline: "Release HyDry device",
      setPanelOffline: "Release Panel",
      setPanelOfflineMessage: "Enter date on which panel was switched off",
      startPanel: "Start",
      stopPanel: "Stop",
    },
    connectReason: "Connect reason",
    connectReasonDescriptions: {
      0: "UNKNOWN",
      1: "Power on",
      2: "periodically",
      3: "New run",
      4: "Step completed",
      5: "Power off",
      6: "Warning",
      7: "Error",
      8: "BLE disconnected",
      9: "Session retry",
      10: "Reconnect",
    },
    coooling: "Cool down",
    disconnected: "Disconnected",
    drying: "Drying",
    dryingPhaseInfo: {
      error: "Error",
      program0: "Post-run",
      program1ToProgram7: "Drying active",
      warning: "Warning",
    },
    dryingProgram: "Drying program",
    dryingProgressGraph: {
      formatTemperature: "{0} °C",
      temperature: "Temperature",
    },
    dryingProgressGraphControl: {
      formatDrying: "Drying {0}",
      groundTemp: "Floor temperature",
      log: "Log",
      new: "New",
      next: "Drying >",
      nextShort: ">",
      overview: "Total",
      previous: "< drying",
      previousShort: "<",
      rateDrying: "Quality",
      single: "Single",
      wallTemp: "Wall temperature",
    },
    event: "Event",
    externalCountingMeter: "Electricity billing: {0}",
    formatChainAndProgram: "Drying {0} / Program {1}",
    formatDryingProgram: "P{0}",
    formatDryingProgramWithName: "P{0}: {1}",
    formatHeatRatio: "{0}%",
    formatHeatRatioAll: "{0}% / {1}hPa",
    formatHeatRatioAndRelativeHumidityAndPressure: "{0}% / {1}% / {2}hPa",
    formatHeatRatioWithLabel: "Intensity: {0}%",
    formatTemperatureGround: "Floor: {0} °C",
    formatTemperatureWall: "Wall: {0} °C",
    formatTemperatureWallAndGround: "Wall: {0} °C / floor: {1} °C",
    formatTemperatureWallAndGroundMax: "Wall max {0} °C / floor max {1} °C",
    formatTemperatureWallMax: "Wall max {0} °C",
    heatRatio: "Intensity",
    heating: "Warm up",
    heatingInfo: "FirstTime/FHR/HR/CR/HRatio",
    idle: "Temperature control",
    lastEvent: "Last event",
    lastInfo: {
      current: "Current",
      days: "1 day ago | {count} days ago",
      hours: "{0} h ago",
      lastPing: "PING {0}",
      lastPingCurrent: "PING current",
      minutes: "{0} min ago",
    },
    lastInformation: "Latest information",
    lastMeterReading: "last reading {0}",
    loadRunsOptions: {
      startFromBeginning: "From the start",
      startFromRunId: "From run ID",
    },
    malfunction: "Error",
    maxTemperature: "max temperature",
    meterReading: "Meter reading",
    meterReadingByUser: "Read electricity consumption (kWh)",
    metereReadingStartEnd: "Start {0} End {1}",
    noActiveProgramChainWarning: "No drying active",
    noData: "No data",
    noInfoAvailable: "no information available",
    noProgramChainFound: "No drying found in assignment period.",
    numDryings: "1 drying | {count} drying",
    numRuns: "Runs",
    operatingStatus: "Operating status",
    powerConsumption: "Power consumption",
    powerFail: "Plug pulled",
    powerUp: "Powered up",
    progStepCycle: "Prog/Step/Cycle",
    runInfo: {
      duration: "Duration: {0}",
      durationActiveRun: "Data: {0} from {1}",
      formatRunProgramInfo: "T {0} / Run {1} / {2}",
      heatingPercentageAndPowerConsumption: "{0}% Heating, {1} kWh",
      programDescription: "T {0} / P {1}",
      programDescriptionIdle: "T {0} / P 0 Temperature control",
      programMonitor: "Monitor",
      programP0: "Temperature control",
      programPX: "P{0}",
      runAssigned: "{0} from {1} - {2}",
      runAssignedOpenEnded: "{0} since {1}",
      runDescription: "Run {0} from {1} to {2}",
      runDescriptionActive: "Run {0} since {1} {2}",
      runDescriptionAdjusted: "Run {0} from {1} to {2}*",
      runDescriptionSingleDay: "Run {0} on {1} to {2}",
      runDescriptionSingleDayAdjusted: "Run {0} on {1} to {2}*",
      runNoProject: "No project",
      runNotAssigned: "Not assigned",
      stepsAndCycles: "Steps/cycles: {0}/{1}",
      t0: "T0: {0}m",
      temperatureGroundAndWall: "Wall: {0}-{1} °C / floor: {2}-{3} °C",
      temperatureWall: "Wall: {0}-{1} °C",
    },
    runTime: "Duration",
    runningSince: "Drying in progress",
    source: {
      ble: "BLE",
      iot: "IoT",
    },
    step: "Steps",
    temperature: "Temperature",
    title: "Details panel {0}",
    waiting: "Waiting",
    warning: "Warning",
  },
  panelList: {
    activeFilters: "--- active filters: {0} ---",
    description:
      "Manage HyDry devices: 1 device | Manage HyDry device: {count} devices",
    descriptionAlt:
      "HyDry device selection: 1 device | HyDry device selection: {count} device",
    devicesOfProject: "'Device status project \"{0}\"'",
    filterActiveDevices: "active devices",
    filterAllDevices: "all devices",
    filterDevicesOverdueDevices: "overdue devices",
    filterDevicesWithWarningOrError: "devices with warning / error",
    filterFinishedDevices: "Finished devices",
    filterInUsage: "devices in use",
    filterNotAssignedToProject: "devices without project",
    hint: "Select device with click",
    hyDryDevicesOverview: "Devices overview",
    manageHyDryDevices: "Select devices",
    noDevicesFound: "--- no devices found ---",
    ownComBoxes: "Show own devices",
    sortByDryingStart: "Start of drying",
    sortByInventoryNumber: "Inventory number",
    sortByProject: "Project",
    sortBySerialnumber: "Serial number",
    sortByStatus: "Status",
    testBoxes: "Boxes test display",
  },
  panelSettings: {
    configName: "Configuration",
    firmwareIPU: "Firmware IPU",
    restartConfirmMessage: "The restart is queued via IoT.",
    restartConfirmTitle: "Restart panel {0}?",
    title: "Settings Panel {0}",
  },
  pdfReport: {
    device: "Device",
    deviceNumber: "No",
    end: "End",
    finalReport: "Technical drying: final report",
    formatPowerConsumption: "Power consumption {0}",
    formatProjectName: "Project {0}",
    from: "from",
    hyDryDevicesUsgae: "HyDry device usage",
    hyDryDryingInfo: "HyDry drying data",
    intermediateReport: "Technical drying:\nProgress report",
    meterNumber: "Meter number.",
    noHyDryDevicesUsed: "No HyDry Devices were assigned to this project.",
    powerConsumption: "Consumption",
    start: "Start",
    sumPowerConsumption: "Total power consumption",
    until: "to",
  },
  pickerDialog: {
    noSelection: "None selected",
  },
  programChainNote: {
    createNoteTitle: "Create comment",
    deleteNoteConfirmationDialogMessage:
      "Do you really want to delete the comment?",
    deleteNoteConfirmationDialogTitle: "Delete comment",
    note: "Comment +",
    notePlus: "Comment +",
    noteSaved: "Comment saved",
  },
  projectConclusion: {
    concludeProject: "Finalise project",
    concludeProjectDialogMessage:
      "Do you want to finalise project {0}?",
    concludeProjectMessage:
      "Do you want to finalise project {0} and create a final report?",
    createFinalReport: "Create progress report",
    createFinalReportButton: "Create final report",
    createInterimReport: "Create progress report",
    createReport: "Create report",
    description: "Release HyDry devices and finalise project",
    formatProjectFinished: "Completed on {0} of {1}",
    projectConcluded: "Project finalised",
    projectDuration: "Project duration",
    releaseFinalReport: "Release final report",
    reopenProjectButtonText: "Reopen project",
    sendFinalReport: "Release final report",
    signOffAllDevices: "Release all devices",
    signOffAllHyDryDevices: "Release all HyDry devices",
    signOffAllDevicesMessage: "Release all HyDry devices from project?",
    signOffAllDevicesSuccess: "All HyDry devices released",
    withReport: "With report",
    withoutReport: "Without report",
  },
  projectDetails: {
    createNote: "New note",
    documents: "Documents",
    erp: "ERP",
    logBook: "Logbook",
    meterReadingStart: "Electricity meter start: {0}",
    noDevicesAssigned: "--- no devices assigned ---",
    notAvailable: "--- Project not available ---",
    note: "Note",
    notes: "Notes",
    powerConsumption: "Power consumption: {0}",
    project: "Project",
    projectConclusion: "Project completion",
    projectConclusionShort: "Completion",
    projectNameAlreadyExistsMessage:
      "A project already exists with the project name you have selected. Save it anyway?",
    projectNameAlreadyExistsTitle: "Project name already exists",
    projectNumberAlreadyExists: "Project number already exists",
    projectScope: {
      damageAssessment: "Damage assessment",
      deviceAssignment: "Device assignment",
      drying: "Drying",
      leakDetection: "Leak detection",
      devicesRental: "Rental devices",
      restoration: "Restoration",
    },
    projectTypeCodes: {
      0: "",
      1: "LE",
      2: "DR",
      3: "DR",
      4: "LD",
      5: "LR",
      6: "RE",
      7: "FD",
      8: "DA",
      9: "DL",
    },
    projectTypeDefault: "Project type {0}",
    projectTypeDefaultLables: {
      0: "",
      1: "Leak detection",
      2: "Drying",
      3: "Drying and Restoration",
      4: "Leak detection and drying",
      5: "Leak detection to restoration",
      6: "Restoration after drying",
      7: "Fire damage",
      8: "Device assignment",
      9: "Device lending",
    },
    reports: "Reports",
    timeLine: "Timeline",
    updateNote: "Edit note",
  },
  projectList: {
    activeFilters: "--- active filters: {0} ---",
    description:
      "Manage drying projects: 1 project | Manage drying projects: {count} projects",
    filterAllProjects: "all projects",
    filterOverdue: "overdue",
    filterProjectsWithOngoingDrying: "drying active",
    filterRecentlyFinished: "finished",
    filterRestoredProjects: "restored",
    filterWithDevices: "with HyDry devices",
    finishedProjects: "Finished projects",
    filterProjectsMovedToFinished: "moved",
    hint: "Select project with click, new project with +",
    hintWithoutOptionToCreate: "Select project with click",
    newestProjets: "Latest projects",
    noProjectsFound: "--- no projects found ---",
    numAllDevices: "{0}/{1} devices active",
    numAllDevicesAllActive: "1 device active | {count} devices active",
    numAllDevicesNoneActive: "1 device | {count} devices",
    numApartments: "1 flat | {count} flats",
    numRooms: "1 room | {count} rooms",
    oldestProjects: "Oldest projects",
    overdueProjects: "Overdue projects",
    projectFinished: "Project finished",
    projectNumber: "Project number",
    projectProgress: "Project progress",
    recentProjects: "Current projects",
    relevantProjectsTitle: "Relevant projects",
    showFinishedProjects: "Show finished projects",
    showFinishedProjectsShort: "Finished",
    showRecentProjects: "Show current projects",
    showRecentProjectsShort: "Current",
    title: "All projects",
    types: {
      archived: "Old",
      deleted: "Deleted",
      finished: "Finished",
      running: "Current",
    },
    urgency: "Urgency",
  },
  projectLogs: {
    activeFilters: "--- active filters: {0} ---",
    eventLogs: {
      appointmentDamageAssessment: "Appointment damage assessment",
      appointmentDryingConclusion: "Appointment drying pack up",
      appointmentDryingConclusionPortalProject: "Start drying pack up",
      appointmentDryingPreparation: "Appointment drying set up",
      appointmentDryingPreparationPortalProject: "Start drying set-up",
      appointmentFollowUpInspection: "Resubmission",
      appointmentIntermediate: "Appointment measurement",
      appointmentLeakDetection: "appointment leak detection ",
      appointmentRepair: "Appointment restoration",
      autoTimeTracking: "",
      clientDataCompleted: "K1: Project data complete",
      damageAssessmentCompleteFinished:
        "K3: Complete damage assessment completed",
      damageAssessmentEasyFinished: "K3: Simple Damage assessment finished",
      damageAssessmentFinished: "K3: Damage assessment completed",
      damageAssessmentPlanned: "K1: Damage recording planned {0}",
      damageAssessmentRoomAdded: "{0}: {1}, {2} added",
      damageAssessmentRoomDeleted: "{0}: {1}, {2} deleted",
      contactPersonAdded: "Apartment {0} added",
      contactPersonDeleted: "Apartment {0} deleted",
      damageAssessmentStarted: "K3: Damage assessment started",
      damagePatternConclusion: "K4: Damage pattern finished",
      damagePatternFinished: "K3: Damage assessment completed",
      damagePatternReopened: "K4: Damage pattern reopened",
      damagePatternStarted: "K4: Damage pattern started",
      damageReportSent: "K4: Damage report sent",
      devicesSetupCompleted: "K7: Device assignment complete",
      documentationAndLeakDetectionFinished: "K2: Leak detection executed",
      documentationAndLeakDetectionSectionFinished: "K2: Project data entered",
      dryingCompleted: "K8: Drying completed",
      dryingFinished: "K7: Drying completed, devices released",
      dryingNecessary: "Drying required",
      dryingNotNecessary: "Drying not required",
      dryingNotSuccessful: "Drying not successful",
      dryingProgressCompletedFollowUp: "K6: Resubmission completed",
      dryingProgressCompletedMeasurement: "K6: Measurement completed",
      dryingProgressStarted: "K6: Measurement started",
      dryingProjectFinished: "K4: Project completed",
      dryingRunning: "Drying active",
      dryingSetupFinished: "K5: Drying set-up completed",
      dryingSetupStarted: "K5: Drying set-up started",
      dryingSuccessful: "Drying successful",
      finished: "Finished",
      followUpInspectionDate: "Resubmission {0}",
      interimReportSent: "K8: Interim report sent",
      leakDetectionExecutionCompleted: "K2: Leak detection complete",
      leakDetectionExecutionStarted: "K2: Leak detection started",
      leakDetectionPreparationCompleted:
        "K2: Leak detection preparation completed",
      leakDetectionPreparationFinished: "K2: Preparation ready",
      leakDetectionPreparationStarted: "K2: Preparation started",
      leakDetectionProjectConclusionStarted: "K4: Project completion started",
      leakDetectionProjectFinished: "K4: Project completed",
      leakDetectionProjectReopened: "K4: Project reopened",
      leakDetectionReportSent: "K4: Leak detection report sent",
      leakDetectionStarted: "K2: Leak detection started",
      measurementCreated: "K6: Measurement finished (measurement series {0})",
      measurementSeriesChangedK2WithDescription:
        "K6: Measurement series {0} changed",
      measurementSeriesChangedK2WithDescriptionWithoutTile:
        "Measurement series {0} changed",
      measurementSeriesCreatedK2WithDescription:
        "K6: Measurement series {0} created",
      measurementSeriesCreatedK2WithDescriptionWithoutTile:
        "Measurement series {0} created",
      mergedDevicesSetup: "K7: Device assignment started",
      note: "",
      packupDevicesFinished: "K7: Devices packed up",
      packupDevicesStarted: "K7: Drying pack up started",
      portalProjectCreation: "New project",
      projectAssigned: "Project assigned",
      projectAssignedWithUserInfo: "Project assigned to user {0}",
      projectCompletedFinalTile: "K8: Project completed",
      projectConclusionCompleted: "K8: Finalisation",
      projectConclusionStarted: "K8: Project completion started",
      projectCreation: "K1: New project",
      projectCreationWithDamageDay: "K1: New project, damage day {0}",
      projectDeleted: "Project deleted",
      projectDeletedInApp: "Project deleted in Project App",
      projectFinished: "K8: Project finished",
      projectMovedToArchived: "Project archived",
      projectMovedToFinished: "Project moved",
      projectReactivated: "Project reactivated",
      projectReopened: "K8: Project reopened",
      projectReopenedFromPortal: "Project reopened",
      projectReportSent: "K8: Project report sent",
      projectRestored: "Project restored",
      projectResult: "",
      projectWorkStarted: "K2: Project processing started",
      repairCompleted: "K8: Restoration finished",
      repairStarted: "K8: Restoration started",
      restorationNecessary: "Restoration required",
      restorationNotNecessary: "Restoration not required",
      restorationNotSuccessful: "Restoration not successful",
      restorationSuccessful: "Restoration not successful",
      startedCachedProjectEdit: "",
      stepDamageAssessmentAppointment: "",
      stepDamageAssessmentComplete: "K4: Damage assessment completed",
      stepDamageAssessmentResult: "",
      stepDryingConclusionAppointments: "",
      stepDryingConclusionResults: "K7: Drying completed",
      stepDryingSetUpAppointments: "",
      stepDryingSetUpCompletions: "Drying in progress",
      stepFirstContact: "K1: Contact established",
      stepIntermediateMeasurementAppointments: "",
      stepIntermediateMeasurementCompletions: "K6: Measurement completed",
      stepLeakDetectionAppointment: "",
      stepLeakDetectionResult: "K4: Leak detection complete",
      stepOfferResultDryingApproved: "K4: Drying released",
      stepOfferResultDryingNotApproved: "K4: Project completed",
      stepOfferResulRestorationApproved: "K4: Restoration released",
      stepOfferSendToInsurance: "K4: Offer sent to insurance company",
      stepProjectAccepted: "K1: Order entered",
      stepProjectApprovedProjectFinished: "K8: Project finished",
      stepProjectApprovedProjectSaved: "K1: Project confirmed",
      stepProjectResult: "K8: Project finished",
      stepRepairAppointments: "",
      stepRepairStart: "",
      tile1: "K1",
      tile2: "K2",
      tile3: "K3",
      tile4: "K4",
      tile5: "K5",
      tile6: "K6",
      tile7: "K7",
      tile8: "K8",
      timeTracking: "",
      timeTrackingReportSent: "Time entry sent",
    },
    eventLogFilter: {
      allLogs: "All entries",
      autoTimeTracking: "Automatic entries",
      notes: "Notes",
      noteAndStatus: "Status + notes",
      timeTracking: "Manual entries",
    },
    eventLogSortOrder: {
      newestFirst: "Newest",
      oldestFirst: "oldest",
    },
    noLogs: "--- no logs found ---",
    noteLogs: {
      apartment: "Flat",
      defaultApartmentName: "Flat",
      dialog: {
        createErrorMessage: "Error when adding note",
        createSuccessMessage: "Note successfully added",
        deletionConfirmationMessage:
          "Are you sure you want to delete the note?",
        deletionConfirmationTitle: "Delete note",
        deletionErrorMessage: "Error when deleting note",
        deletionSuccessMessage: "Note has been successfully deleted",
        editErrorMessage: "Error when editing note",
        editSuccessMessage: "Note successfully edited",
        titleCreate: "Create note",
        titleEdit: "Edit note",
        useForReport: "in external report",
      },
      note: "Note",
      noteTitle: "Note:",
      noteIn: "Note in {0}",
      room: "Room",
      roomName: "Room {0}",
    },
    numberOfLogsDisplayed: "1 log | {count} logs",
    projectState: {
      allApartments: " (All flats)",
      apartmentNumber: " (W{0})",
      approveProject: "Confirm project",
      damageAssessmentBegun: "Damage assessment started",
      damageAssessmentCompletedWithoutTile: "Damage assessment completed",
      damageAssessmentResumed: "Damage assessment resumed",
      damageAssessmentSuspended: "Damage assessment suspended",
      dryingConcluded: "Drying completed",
      dryingDuration: "Drying: 1 day | Drying: {count} days",
      dryingPackupBegun: "Drying pack up started",
      dryingPackupFinished: "Drying completed",
      dryingPackupResumed: "Drying pack-up resumed",
      dryingPackupSuspended: "Drying pack-up suspended",
      dryingRunning: "Drying active",
      dryingSetupBegun: "Drying set-up started",
      dryingSetupFinished: "Drying set up",
      dryingSetupResumed: "Drying build-up resumed",
      dryingSetupSuspended: "Drying build-up suspended",
      establishFirstContact: "Make Contact",
      firstContactEstablished: "Contact established",
      interimReportCreated: "Progress report created",
      intermediateMeasurementBegun: "Measurement started",
      intermediateMeasurementFinished: "Measurement finished",
      intermediateMeasurementResumed: "Measurement resumed",
      intermediateMeasurementSuspended: "Measurement suspended",
      leakDetectionBegun: "Leak detection started",
      leakDetectionFinished: "Leak detection finished",
      leakDetectionResumed: "Leak detection resumed",
      leakDetectionSuspended: "Leak detection suspended",
      makeAppointment: "Make appointment",
      noDrying: "No drying",
      noReport: "No report",
      offerSendToInsurance: "Offer sent to insurance company",
      orderRecorded: "Order entered",
      orderRejected: "Order rejected",
      projectApproved: "Project confirmed",
      projectItemFinished: "Project finished",
      projectOnHold: "Project on hold",
      reportCreated: "Report created",
      repairBegun: "Restoration started",
      repairFinished: "Restoration completed",
      repairResumed: "Restoration resumed",
      repairStarted: "Restoration running",
      repairSuspended: "Restoration suspended",
    },
  },
  projectOperationSource: {
    api: "API",
    cloudFunction: "IRES Cloud",
    deviceManagerApp: "IRES Work",
    portal: "IRES Office",
    projectManagerApp: "IRES Project",
    pythonScript: "Script",
  },
  projectOverview: {
    recordedByItem: "{0} {1} ({2})",
  },
  projectStateFilter: {
    allProjects: "Project | Projects",
    assignDevices: "assign devices",
    concludeProjekt: "Finalise project",
    damageAssessment: "damage assessment",
    drying: "drying in progress",
    dryingConclusion: "Drying pack up",
    dryingSetup: "Drying set-up",
    followUpInspection: "resubmission",
    insuranceOffer: "Offer to insurance company",
    intermediateMeasurement: "progress measurement",
    leakDetection: "leak detection",
    missingDryingApproval: "approve drying | approve dryings",
    missingFirstContact: "first contact | first contacts",
    missingProjectApproval: "Confirm project | Confirm projects",
    missingProjectConclusion: "project to finalise | projects to finalise",
    missingProjectOwner: "without worker",
    missingProjectSupervisor: "without project manager",
    missingReport: "without report",
    new: "new",
    overall: "total",
    overdue: "overdue",
    ownProjects: "own project | own projects",
    projectSupervisor: "project responsible | projects responsible",
    recentlyFinished: "recently finished",
    repair: "restoration",
    withHyDryDevices: "with HyDry devices",
  },
  projectStatus: {
    acceptOrder: "Confirm project?",
    actionAcceptOrder: "Confirm project",
    actionRejectOrder: "Reject project",
    allApartments: "All flats",
    appointmentStep4: "appointment leak detection ",
    appointmentStep6: "Appointment damage assessment",
    appointmentStep10: "Appointment drying set up",
    appointmentStep12: "Appointment measurement",
    appointmentStep14: "Appointment drying pack up",
    appointmentStep16: "Appointment restoration",
    approvalStatus: "Release status: {0}",
    approvalStatuses: {
      noDryingNecessary: "no drying necessary",
      noRestorationNecessary: "No restoration necessary",
      yesExecute: "Yes, proceed with drying",
      yesOffer: "Yes, make offer",
    },
    concludedStep5: "Leak detection finished",
    concludedStep7: "Damage assessment completed",
    concludedStep11: "Drying set up finished",
    concludedStep13: "Measurement finished",
    concludedStep15: "Drying pack up finished",
    concludedStep17: "Restoration finished",
    controlMeasurement: "Finalise progress measurement",
    csvTrades: "Trades",
    damageDescription: "Damage description: {0}",
    dateTime: "Date / Time",
    documentsFilename: "ALL_DOCUMENTS",
    downloadAll: "All documents",
    downloadExternalReport: "External report",
    downloadInternalReport: "Internal report",
    downloadReport: "Report",
    dryingAreaFloor: "Floor area (m²)",
    dryingAreaWallCeiling: "Wall / ceiling area (m²)",
    dryingDuration: "Drying time (days)",
    dryingPackupStarted: "Drying pack up started",
    dryingSetupStarted: "Drying set-up started",
    formatAppointment: "Appointment: {0}",
    formatDryingDuration: "Drying: 1 day | Drying: {count} days",
    formatEstimatedDryingDuration: "Drying duration 1 day | Drying duration {count} days",
    formatDryingAreaFloor: "Floor {0} m²",
    formatDryingAreaWallCeiling: "Wall / ceiling {0} m²",
    formatRestorationDuration: "Restoration: 1 day | Restoration: {count} days",
    hyDryCertificate: "HyDry certificate",
    note: "Remark: {0}",
    ongoingStep4: "Leak detection running",
    ongoingStep6: "Damage assessment in progress",
    ongoingStep10: "Drying set up in progress",
    ongoingStep12: "Measurement running",
    ongoingStep14: "Drying pack up running",
    ongoingStep16: "Restoration running",
    orderAccepted: "Project confirmed",
    orderRejected: "Project rejected",
    parameters: "Information",
    phaseInfo4: "Leak detection started",
    phaseInfo6: "Damage assessment started",
    phaseInfo10: "Drying set-up started",
    phaseInfo12: "Measurement started",
    phaseInfo14: "Drying pack up started",
    phaseInfo16: "Restoration started",
    projectEndDesc: "End of project: {0}",
    projectState: {
      archived: "Project was archived",
      deleted: "Project was deleted",
      finished: "Project was finished",
      movedToFinished: "Project was moved",
    },
    projectStepDescription: "Description",
    releaseDrying: "Release drying?",
    releaseRestoration: "Release restoration?",
    resumedStep5: "Leak detection resumed",
    resumedStep7: "Damage assessment resumed",
    resumedStep11: "Drying build-up resumed",
    resumedStep13: "Measurement resumed",
    resumedStep15: "Drying pack-up resumed",
    resumedStep17: "Restoration resumed",
    servicesCSV: "Task Table",
    step: "Step",
    step1: "Order entered",
    step10: "Start drying set-up",
    step11: "Finalise drying set up",
    step12: "Start measurement",
    step13: "Finalise measurement",
    step14: "Start drying pack up",
    step15: "Finalise drying",
    step16: "Start restoration",
    step17: "Finalisation restoration",
    step18: "Project finalised",
    step2: "Project confirmed?",
    step3: "First contact",
    step4: "Start leak detection",
    step5: "Finalise leak detection",
    step6: "Start damage assessment",
    step7: "Finalise damage assessment",
    step8: "Offer to insurance company",
    step9: "Release drying",
    step9Restoration: "Release restoration",
    stepDoneBy: "Executed by",
    suspendedStep5: "Leak detection suspended",
    suspendedStep7: "Damage assessment suspended",
    suspendedStep11: "Drying build-up suspended",
    suspendedStep13: "Measurement suspended",
    suspendedStep15: "Drying pack-up suspended",
    suspendedStep17: "Restoration susp.",
    appointmentAlreadyCompleted: "The appointment has already been completed and cannot be deleted.",
    appointmentDeleteError: "An error occurred while deleting the appointment.",
    appointmentDeleteSuccess: "Appointment deleted successfully.",
    appointmentSaveSuccess: "Appointment saved successfully.",
    user: "User",
  },
  projectStep: {
    acceptOrder: "Accept order?",
    appointmentDamageAssessment: "Damage assessment",
    appointmentDryingConclusion: "Drying pack up",
    appointmentDryingSetup: "Drying set-up",
    appointmentIntermediateMeasurement: "Measurement",
    appointmentLeakDetection: "Leak detection",
    appointmentMissingDate: "When???",
    appointmentMissingResponsibleUser: "Who???",
    appointmentNow: "immediately",
    appointmentOpenResposibleUser: "Worker: open",
    appointmentRestoration: "Restoration",
    approveDrying: "Release drying?",
    approveProject: "Confirm project",
    assignDevices: "Assign devices",
    concludeProject: "Finalise project",
    damageAssessmentFinished: "Damage assessment completed",
    damageAssessmentResumed: "Damage assessment resumed",
    damageAssessmentRunning: "Damage assessment in progress",
    damageAssessmentSuspended: "Damage assessment suspended",
    damageDescription: "Contact person / Description of damage",
    dryingApproved: "Drying approved",
    dryingCompleted: "Drying packed up",
    dryingConcluded: "Drying finished",
    dryingFinished: "Drying finished",
    dryingNecessary: "Drying required?",
    dryingPackupFinished: "Drying packed up",
    dryingPackupResumed: "Drying pack-up resumed",
    dryingPackupSuspended: "Drying pack-up suspended",
    dryingRunning: "Drying active",
    dryingSetupFinished: "Drying set up",
    dryingSetupResumed: "Drying build-up resumed",
    dryingSetupSuspended: "Drying build-up suspended",
    dryingSuccessful: "Drying successful?",
    establishFirstContact: "Make Contact",
    firstContactEstablished: "Contact established",
    followUpInspectionShorthand: "RS",
    formatDryingFinished: "{0}: Drying packed up",
    formatDryingResumed: "Drying resumed",
    formatDryingSuspended: "Drying suspended",
    formatDryingRunningSince: "Drying active\nsince {0}",
    formatDryingSetupFinished: "{0}: Drying set up",
    formatDryingSetupResumed: "{0}: Drying build-up resumed",
    formatDryingSetupSuspended: "{0}: Drying build-up suspended",
    formatIntermediateMeasurementFinished: "{0}: Measurement executed",
    formatIntermediateMeasurementResumed: "{0}: Measurement resumed",
    formatIntermediateMeasurementSuspended: "Measurement suspended",
    formatRepairFinished: "{0}: Restoration finished",
    formatRepairResumed: "{0}: Restoration resumed",
    formatRepairSuspended: "{0}: Restoration suspended",
    intermediateMeasurementFinished: "Measurement finished",
    intermediateMeasurementResumed: "Measurement resumed",
    intermediateMeasurementSuspended: "Measurement suspended",
    interimReportCreated: "Progress report created",
    leakDetectionFinished: "Leak detection finished",
    leakDetectionResumed: "Leak detection resumed",
    leakDetectionRunning: "Leak detection running",
    leakDetectionSuspended: "Leak detection suspended",
    makeAppointment: "Make appointment",
    noContract: "No order",
    noDrying: "No drying",
    noReport: "No report",
    noRestoration: "No restoration",
    note: "Remark",
    offerSend: "Offer sent to insurance company",
    orderRecorded: "Order entered",
    orderRejected: "Order rejected",
    projectApproved: "Project confirmed",
    projectEnd: "End of project",
    projectFinished: "Project finished",
    projectOnHold: "Project on hold",
    projectStepRepairFinished: "Restoration completed",
    projectStepRepairResumed: "Restoration resumed",
    projectStepRepairStarted: "Restoration running",
    projectStepRepairSuspended: "Drying build-up suspended",
    projectStepSetupDrying: "Drying set up in progress",
    projectStepSetupDryingResumed: "Drying build-up resumed",
    projectStepSetupDryingSuspended: "Drying build-up suspended",
    repairFinished: "Restoration completed",
    reportCreated: "Report created",
    restorationApproved: "Restoration released",
    restorationNecessary: "Restoration required",
    restorationNotNecessary: "Restoration not required",
    setProjectSupervisor: "Set project manager",
  },
  rateDrying: {
    dryingDuration: {
      formatShouldHaveStoppedAt: "J. would have packed up the drying on {0}.",
      shouldHaveRunLonger: "J. would have let the drying run even longer.",
      shouldHaveStoppedAt: "When would J. pack up?",
      title: "Drying time",
    },
    formatPhase: "Phase {0}",
    formatPhases: {
      boost: "Boost",
      comfort: "Comfort",
      eco: "Eco",
      smart: "Smart",
    },
    formatPhaseNew: "Phase",
    formatPhaseShort: "P{0}",
    formatPhaseShortNew: "P",
    formatRateHistoryBox: "Quality Box {0} drying {1}",
    formatRateHistoryPanel: "Quality panel {0} drying {1}",
    postDryingRun: "Post-run",
    quality: "Quality",
    qualityDrying: {
      bad: "satisfactory",
      dryingSpeed: "Speed",
      flow: "Flow",
      good: "good",
      long: "rather long",
      ok: "OK",
      roomHumidity: "Room humidity",
      roomTemperature: "Room temperature",
      short: "rather short",
      title: "Quality drying",
      tooLong: "too long",
      tooShort: "too short",
      veryBad: "bad",
      veryGood: "very good",
    },
    qualityNotes: {
      EDTGeneral: "EDT general",
      EDTPauses: "EDT pauses",
      EDTPhase4: "EDT Phase 4",
      anomalies: "Anomalies",
      dryingWithPreDriedAir: "warm pre-dried air",
      general: "General",
      gkgConstant: "g/kg constant",
      gkgConstantInPause: "g/kg constant in pause",
      gkgDecreasedInPause: "g/kg increasing during pause",
      gkgIncreasedAfterPause: "g/kg increasing after pause",
      gkgIncreasedInPause: "g/kg falling during pause",
      gkgOfProcessAirTooHigh: "g/kg of process air too high",
      gkgRoomTooHigh: "g/kg room too high",
      humidityOfProcessAirTooHigh: "rH of process air too high",
      insufficientAirFlow: "Flow too low",
      interruptionByCustomers: "Interruption by customers",
      moistureNearDrillHoles: "Moisture in periphery around holes",
      newMoistureAppeared: "new moisture input",
      noPlasticSheetingOnRawFloor: "without foil on unfinished floor",
      powerConsumptionTooLow: "Power consumption too low",
      relayMalfunction: "Relay defective",
      roomConditions: "Room conditions",
      roomHumidityTooHigh: "rH in room too high",
      roomTemperature: "Room temperature",
      stableAfterXDays: "stable after x days",
      title: "Notes",
      tooHigh: "too high",
      tooLow: "too low",
      underfloorHeating: "Underfloor heating",
    },
    qualityOverall: {
      dryingDuration: "Drying time",
      dryingProcess: "Drying progress",
      exemplaryFor: "Exemplary for",
      knowledgeGain: "Input for learning",
      labels: {
        dryingWithPreDriedAir: "Drying with pre-dried, warm air",
        insufficientAirFlow: "Flow too low",
        moistureNearDrillHoles: "Moisture in periphery around holes",
        newMoistureAppeared: "new moisture input",
        nightlyInterruptionByClient: "night time interruptions by customers",
        noPlasticSheetingOnRawFloor: "without foil on unfinished floor",
        relayMalfunction: "Relay defective",
        underfloorHeating: "Underfloor heating",
      },
      title: "Total rating",
    },
    qualityPhase: {
      days: "Days",
      delta: "Delta",
      duration: "Duration",
      maximumPowerConsumption: "Max power",
      minimumPowerConsumption: "Min power",
      mixingRatio: "Mixing ratio...",
      overall: "Total",
      progress: "Progress",
      progressMixingRatio: "MR/d",
      progressRelativeHumidity: "% RH/d",
      relativeHumidity: "% RH",
      title: "Quality phases",
      watt: "Watt",
    },
    qualityProgram: {
      activity: "Activity",
      ok: "OK",
      pauses: "Pause",
      phaseChange: "Phase change",
      title: "Quality Program",
      toFast: "too fast",
      toLong: "too long",
      toShort: "too short",
      toSlow: "too slow",
    },
    ratingSaved: "Rating saved",
    title: "Assess quality",
  },
  regulatorTypes: {
    agent: "Agent",
    externalRegulator: "External adjuster",
    vuAgency: "VU Agency",
    vuFieldSales: "IC field service",
    vuInternalSales: "IC internal service",
  },
  report: {
    completedPhaseReport: "Report",
    damageReport: "Damage assessment report",
    deleteReportMessage: "Do you really want to delete the report?",
    deleteReportTitle: "Delete report",
    finalReportDrying: "Final drying report",
    footer: {
      dryingReport: "HyDry Drying Report",
      finalReport: "HyDry Final Report",
      interimReport: "HyDry Progress Report",
      formatPageOfPages: "{0} of {1}",
    },
    formatReportDate: "created {0}",
    formatReportDateAndSendDate: "created and sent {0}",
    formatReportDateWithSendDate: "created {0}, sent {1}",
    interimPhaseReport: "Interim report",
    interimReportDrying: "Progress report on drying",
    interimReportRepair: "Progress report on repair",
    leakDetectionReport: "Leak detection report",
    reportName: {
      dryingReportFileNamePrefix: "HYDRY_DRYING",
      finalReportFileNamePrefix: "HYDRY_FINAL",
      hyDryCertificateFileNamePostfix: "HYDRY_CERTIFICATE",
      interimReport: "HyDry Progress Report",
      interimReportFileNamePrefix: "HYDRY_PROGRESS",
    },
    reportType: {
      damageReport: "DAMAGE PATTERN",
      finalReport: "FINALISATION",
      interim: "PROGRESS",
      leakDetection: "LEAK DETECTION",
    },
    reportUsage: {
      damageAssessment: "Damage assessment",
      documentDescription: "",
      drying: "Drying",
      external: "EXT",
      externalDescription: "external",
      externalImagesDescription: "Images",
      externalShortDescription: "Report",
      externalSingleTimeTrackingDescription: "time report",
      externalTimeTrackingDescription: "time report",
      hyDryCertificate: "HyDry certificate",
      internal: "INT",
      internalDescription: "internal",
      leakDetection: "Leak detection",
      measurementProtocol: "Measurement protocol",
      restoration: "Restoration",
      serviceDescription: "Trades",
      serviceJsonDescription: "PDE",
      svImage: "SV Bild Erstbericht",
    },
    subject: {
      damageAssessment: "Damage assessment",
      drying: "Drying",
      leakDetection: "Leak detection",
      repair: "Repair",
    },
    timeTracking: "Time recording report",
  },
  reportList: {
    hint: "Reports on device allocation and power consumption",
    noReportsFound: "--- no reports found ---",
  },
  resetPassword: {
    errorEmailSharingPasswordNoMatch: "Password does not match",
    errorMinEmailSharingPasswordLength:
      "Password must consist of at least 8 characters.",
    errorMinPasswordLength: "Password must consist of at least 8 characters.",
    errorPasswordNoMatch: "Passwords do not match",
    errorWrongEmailSharingPassword: "Password is incorrect",
    errorWrongPassword: "Password is incorrect",
    newEmailSharingPassword: "New password",
    newEmailSharingPasswordRepeated: "New password repeated",
    newPassword: "New password",
    newPasswordRepeated: "Repeat new password",
    oldPassword: "Current password",
    passwordResetFailed:
      "An error occurred while resetting your password. Please try again.",
    passwordResetSuccess: "Your password has been successfully reset.",
    setNewEmailSharingPassword: "Set new password",
    setNewPassword: "Set new password",
    tokenInvalid: "The link to reset your password is invalid or has expired.",
  },
  sampleList: {
    dryingPauseTypes: {
      humidityThresholdReached: "Moisture threshold reached",
      inactive: "Inactive",
      infinite: "Infinite",
      manual: "Manual",
      nightMode: "Night mode",
      powerOverload: "Power overload",
      program: "Program",
      suspend: "Pause",
      temperatureTooHigh: "Temperature too high",
    },
    filterAll: "All",
    filterBatteryEvent: "Battery events",
    filterDryingEvent: "Drying events",
    filterEndOfStep: "End Step",
    filterEvent: "Events",
    filterMonitor: "Monitor",
    filterPowerReduction: "Power reduction",
    formatDryingPauseState: "Pause before: {0}, Pause after: {1}",
    formatTitle: "Samples from {0} / T{1} / Run {2} / P{3} from {4}",
    formatVoltage: "{0} V",
    formatUartError: "Aggregated Counter: {0} / Error Counter: {1}",
    heatRatio: "Heat Ratio",
    samplesPerPage: "Samples per page:",
    sortAscending: "Sort ascending",
    sortDescending: "Sort descending",
    titleChipTemp1: "Chip1",
    titleChipTemp2: "Chip2",
    titleCycle: "Cycle",
    titleEvent: "Event",
    titleIndex: "Index",
    titlePower: "Power",
    titleStatus: "Status",
    titleStep: "Step",
    titleTime: "Time",
    titleWallChip1Max: "Chip1Max",
    titleWallTemp1: "Wall1",
    titleWallTemp1Max: "Wall1Max",
    titleWallTemp2: "Wall2",
    titleWallTemp2Max: "Wall2Max",
  },
  scheduling: {
    durationInMinutes: "Duration (min)",
    taskDetails: {
      addAppointment: "Appointment+",
      addNote: "Note+",
      appointmentConfirmed: "Appointment confirmed",
      dateSuggestions: "Possible dates",
      delete: {
        message: "Really delete confirmed appointment?",
        title: "Delete appointment?",
      },
      deleteNote: "Note-",
      fromDate: "from date",
      noSuggestionsFound: "No valid date found, please change objectives",
      note: "Note",
      parameterFixed: "fixed",
      parametersForPlanning: "Targets for scheduling",
      title: "Schedule appointment",
      undoConfirmation: {
        message: "Cancel confirmed appointment?",
        title: "Confirmation removed",
      },
      unsavedChagnes: {
        message: "Planning data has been changed. Cancel anyway?",
        title: "Planning data modified",
      },
    },
    taskType: {
      damageAssessment: "Damage assessment",
      dryingConclusion: "Drying pack up",
      dryingSetup: "Drying set-up",
      intermediateMeasurement: "progress measurement",
      leakDetection: "Leak detection",
      repair: "Restoration",
    },
    tasks: {
      confirmedTasks: "Confirmed tasks",
      filter: {
        all: "All",
        filterOff: "Filter off",
        lastFourWeek: "Last 4 weeks",
        lastWeek: "Last week",
        startingFromLastWeek: "From last week",
        startingFromToday: "From today",
      },
      formatStartingAt: "from {0}",
      openTasks: "Appointments",
      sortOrder: {
        appointmentDate: "Start time",
        earliestStartDate: "Urgency",
        projectNumber: "Project number",
        taskType: "Task",
        user: "Worker",
      },
    },
    timeline: {
      formatMinutes: "{0} min",
    },
    timelineControl: {
      formatCalendarWeek: "CW {0}",
      moveBackward: "<",
      moveForward: ">",
    },
    timelineSettings: {
      date: "from date",
      hideWeekends: "Hide Sat+Sun",
      onlyShowWorkingHours: "Work time only",
      today: "Today",
      visibleArea: {
        fourWeeks: "4 weeks",
        label: "Display",
        oneDay: "Day",
        oneWeek: "1 week",
        twoWeeks: "2 weeks",
      },
    },
    urgend: "Urgent",
  },
  searchIresDevice: {
    message: "Please enter serial number of device",
    title: "Seek HyDry device",
  },
  selectProjectType: {
    drying: "Drying",
    dryingDirectOrder: "Drying - Direct Order",
    dryingInsuranceCase: "Drying - Insurance claim",
    flexProject: "FlexOrder",
    formatProjectType: "Project type: {0}",
    formatProjectTypes: "Project type: {0} | Project types: {0}",
    leakDetection: "Leak detection",
    leakDetectionDirectOrder: "Leak detection / direct order",
    leakDetectionInsuranceCase: "Leak detection / insurance claim",
    websiteOnly: "Portal",
  },
  settings: {
    administration: {
      allDevicesSettings: {
        allowMemberClientsToDefineOwnSettings:
          "May members (branches) use their own DEVICE SETTINGS?",
        clients: "Which branch office(s)?",
        title: "Distribution settings ALL DEVICES",
      },
      companySettings: {
        allowMemberClientsToDefineOwnSettings:
          "May members (branches) use their own\nBRANCH OFFICE SETTINGS?",
        clients: "Which branch office(s)?",
        title: "Distribution settings Branch offices",
      },
      deviceSettings: {
        title: "Device Management",
      },
      hyDryDeviceSettings: {
        allowMemberClientsToDefineOwnSettings:
          "May members (branches) use their own\nHyDry DEVICE SETTINGS?",
        clients: "Which branch office(s)?",
        title: "Distribution settings HYDRY DEVICES",
      },
      hyDryMessagesSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Are members (branch offices) allowed to use their own MESSAGE SETTINGS?",
        clients: "Which branch office(s)?",
        title: "Distribution settings MESSAGES",
      },
      projectManagementSettings: {
        allowMemberClientsToDefineOwnSettings:
          "May members (branches) use their own settings for PROJECTS?",
        clients: "Which branch office(s)?",
        title: "Distribution settings PROJECTS",
      },
      reportSettings: {
        allowMemberClientsToDefineOwnSettings:
          "May members (branches) use their own REPORT SETTINGS?",
        clients: "Which branch office(s)?",
        title: "Distribution settings REPORTS",
      },
      roleSettings: {
        allowMemberClientsToDefineOwnSettings:
          "May members (branches) use their own ROLE SETTINGS?",
        clients: "Which branch office(s)?",
        enforcedMessage: "Role settings from the master client are automatically applied to all branch offices. Individual branches cannot define their own role settings.",
        title: "Distribution settings ROLES",
      },
      userSettings: {
        allowMemberClientsToDefineOwnSettings:
          "May members (branches) use their own\nUSER SETTINGS?",
        clients: "Which branch office(s)?",
        title: "Distribution settings USER",
      },
      sectionTitle: "Administration",
      systemConfiguration: {
        allowMemberClientsToDefineOwnSettings:
          "May members (branches) use their own\nSYSTEM CONFIGURATION?",
        clients: "Which branch office(s)?",
        title: "Distribution Settings SYSTEM CONFIGURATION",
      },
    },
    administrator: {
      memberClientDialog: {
        clientShorthand: "Client id",
        createClientErrorMessage: "Error when creating member client",
        createClientSuccessMessage: "Member client successfully created",
        editClientErrorMessage: "Error when editing member client",
        editClientSuccessMessage: "Member client successfully edited",
        errors: {
          duplicateClientName: "",
          duplicateEmail: "The email address is already in use",
          duplicateIresProjectNumberPrefix: "This client id is already used",
          emptyClientName: "Please enter a client name",
          emptyEmail: "Please enter a valid email address",
          emptyIresProjectNumberPrefix:
            "Please enter a client abbreviation (4 characters)",
          emptyPassword: "Please enter a password",
          invalidEmail: "Please enter a valid email address",
          invalidIresProjectNumberPrefix:
            "Please enter a client abbreviation (4 characters)",
          invalidPassword: "The password must have at least {0} characters ",
        },
        titleCreate: "Create member client",
        titleEdit: "Edit member client",
      },
      memberClientsManagement: {
        title: "Manage member clients",
      },
      title: "Master",
    },
    allDevices: {
      projectDevicesSettings: {
        enforceMeterReading: "Always enter and check meter reading?",
        standardIdentification: "Standard for device scan",
        title: "Device settings",
      },
      title: "All devices",
    },
    allDevicesManagement: {
      title: "Manage all devices",
    },
    branches: {
      branchNumber: "Site Id",
      branchSortValue: "Sort number",
      confirmDeleteBranchMessage:
        "Are you sure you want to permanently delete this site?",
      confirmDeleteBranchMessageAlt:
        "There is still 1 device assigned to this location. These device will lose the location binding. Would you like to continue? | There are still {count} devices assigned to this location. These devices will lose their location binding. Would you like to continue?",
      confirmDeleteBranchTitle: "Delete site",
      editTitle: "Edit site",
      viewTitle: "Site",
      errorDuplicateBranchNumber: "Number is already assigned to site {0}",
      errorMissingBranchNumber: "Please enter number > 0",
      fullName: "Long name",
      location: "Location",
      name: "Short name",
      rejectDeleteBranchMessage:
        "There is still 1 device assigned to this location. The device must first be assigned to another location. | {count} devices are still assigned to this location. The devices must first be assigned to another location.",
      title: "Sites",
      useInReport: "In report",
    },
    buttons: {
      change: "EDIT",
    },
    changeLogo: "Change logo",
    comBoxHumidityUnit: {
      absoluteHumidity: "Absolute humidity (g/m3)",
      mixingRatio: "Mixing ratio (g/kg)",
      relativeHumidity: "Relative humidity (%)",
      title: "Default humidity unit",
    },
    comBoxes: "HyDry boxes",
    company: "Which branch office(s)?",
    companySettings: {
      absoluteHumidity: "abs. humidity (g/m3)",
      addressFormat: {
        availableFields: "Available fields",
        commaNotAllowedAtEdge: "A comma cannot be first or last",
        defaultUsed: "With no fields the default format is used.",
        hint: "Sets the order the parts of an address are written in.",
        preview: "Preview",
        templateFields: {
          CITY: "City",
          COMMA: "Comma",
          COUNTRY: "Country",
          HOUSE_NUMBER: "House number",
          STREET: "Street",
          ZIP_CODE: "Postal code",
        },
        title: "Address format",
      },
      addressGeocoding: "Geocode addresses",
      companyData: "Branch office data",
      companyEmailAddress: "Email address",
      companyIdentifier: "Branch identification",
      companyName: "Company name",
      companySettingsTitle: "Branch office settings",
      errorCompanyIdentifier:
        "Invalid input. Please use only alphanumeric characters.",
      errorEmailAddress: "Please enter valid email address",
      mixingRatio: "Mixing ratio (g/kg)",
      preferredHumidityUnit: "Preferred specification MOISTURE",
      primaryLanguage: "Primary language",
      shortName: "Short name",
      timezone: "Timezone",
      usePrimaryLanguageForReports: "Use primary language for reports?",
    },
    currentUser: {
      formatCurrentUser: "Current user: {0}, role: {1},",
      formatCurrentUserValidationLevel: "Validation: {0}",
      setPassword: "Change user password",
      showCurrentUserSettings: "Show my user data",
      title: "Current user",
    },
    aiPredictions: {
      title: "ASSIST",
      mode: {
        OFF: "No",
        ALL_DRYINGS: "Yes, with all dryings",
        ACTIVE_AND_NEW_ONLY: "Yes, only active and new dryings",
      },
      activationBackfill: {
        started: "ASSIST activation saved. Historical calculation started.",
        alreadyRunning: "ASSIST activation saved. Historical calculation is already running.",
        noOp: "ASSIST activation saved, but backend did not start the historical calculation.",
        triggerFailed: "ASSIST activation saved, but the historical calculation could not be started.",
      },
    },
    billingCatalogs: {
      title: "Manage billing catalogs",
      sectionTitle: "Billing Catalogs",
      listTitle: "Billing Catalogs",
      noCatalogs: "No billing catalogs available.",
      syncFromApi: "Sync from API",
      syncSuccess: "{0} items imported across {1} catalogs.",
      syncError: "Failed to sync billing catalogs.",
      updateError: "Failed to save the change.",
      noPriceClassName: "No price class",
      columns: {
        catalogName: "Issuer",
        tenant: "Price source",
        version: "Version",
        fileName: "File name",
        numberOfEntries: "Entries",
        branchNumber: "Branch",
        validFrom: "Valid from",
        validUntil: "Valid until",
        importedAt: "Imported on",
      },
      detail: {
        title: "Billing Catalog",
        validityOpenEnded: "open-ended",
        loading: "Loading billing catalog...",
        loadError: "Failed to load billing catalog",
        uncategorized: "Uncategorized",
        columns: {
          articleId: "Position",
          headline: "Headline",
          text: "Description",
          unit: "Unit",
          price: "Price",
          limit: "Limit",
          qualifier: "Qualifier",
        },
        download: "Download",
      },
    },
    deviceCheckManagement: {
      title: "Manage device check",
    },
    devices: {
      allowCategoryTemplateCreate:
        "Allow creation of new device categories / device types during CSV import?",
      allowCategoryTemplateUpdate:
        "Allow updating of device category/device type during CSV import?",
      allowNewCategory:
        "Allow new device categories to be added during CSV import?",
      allowNewTemplate: "Allow new device types to be added during CSV import?",
    },
    dryRuns: "Dryings",
    errorInvalidNumber: "Please enter a whole number",
    errorNumberRange: "Please enter a whole number between {0} and {1}",
    exportSettings: {
      allDevices: "All devices",
      deviceFilter: "Device status selection",
      devicesSelection: "Device selection",
      exportDialog: {
        message: "1 Device processed | {count} Devices processed",
        title: "Export information",
      },
      hyDryDevices: "HyDry devices",
      otherDevices: "Other Devices",
    },
    hyDryBox: "HyDry Box",
    hyDryDevice: {
      cancel: "CANCEL",
      configurations: "Settings HyDry devices",
      configurationsImportExport: "Configure import",
      date: "Date",
      deviceError: "errors in 1 device | Errors in {count} devices",
      deviceImportHistory: "Import history",
      devicesCategorySettings: "Device categories and device types",
      devicesDetected: "1 device detected | {count} devices detected",
      devicesDuplicated: "1 duplicate found | {count} duplicates found",
      devicesExport: "Export devices",
      devicesImport: "Import devices",
      devicesNew: "1 new device added | {count} new devices added",
      devicesProcessed: "1 Device processed | {count} Devices processed",
      devicesUpdated:
        "1 existing device updated | {count} existing devices updated",
      devicesUpload: "Uploading devices ...",
      editComBoxClientConfig: "Edit HyDry BOX client configuration",
      errorMessageCategoryNotFound: "Category not found",
      errorMessageCategoryUpdateNotAllowed: "Category cannot be changed",
      errorMessageDeviceAssignedToProject: "Device assigned to the project",
      errorMessageDeviceDoesNotExist: "Device does not exist",
      errorMessageBranchNotFound: "Branch does not exist",
      errorMessageInvalidDevicePowerUsageType: "Counter\n is invalid",
      errorMessageInvalidElectricityMeterManufacturer:
        "Meter manufacturer invalid",
      errorMessageInvalidInventoryNumber: "Inventory number invalid",
      errorMessageInvalidManufacturer: "Manufacturer is invalid",
      errorMessageInvalidPowerConsumptionPerHour: "Typical power is invalid",
      errorMessageInvalidQrCode: "QR/NFC code is invalid",
      errorMessageInventoryNumberAlreadyExists:
        "Inventory number already exists (conflict: {conflictId})",
      errorMessageInventoryNumberNotUnique:
        "Several devices with same inventory number were found.",
      errorMessageIresDevice: "New HyDry device cannot be imported",
      errorMessageMissingCategory: "Category missing",
      errorMessageMissingCategoryColumn:
        "Import file does not contain a column for the device category",
      errorMessageMissingInventoryNumber: "Inventory number missing",
      errorMessageMissingInventoryNumberColumn:
        "Import file does not contain a column for the inventory number",
      errorMessageMissingSerialNumberColumn:
        "Import file does not contain a column for the serial number",
      errorMessageMissingTemplate: "Type missing",
      errorMessageMissingTemplateColumn:
        "Import file does not contain a column for the device type",
      errorMessageQrCodeAlreadyExists: "QR/NFC code already exists (conflict: {conflictId})",
      errorMessageSerialNumberNotUnique:
        "Several devices with same serial number were found.",
      errorMessageTemplateNotFound: "Type was not found",
      errorMessageTemplateUpdateNotAllowed: "Device type cannot be changed",
      errorMessageTryAgain:
        "An error has occurred. Try again with a different file.",
      errorMessageWrongCsvSeparator:
        "File format is incorrect. Please follow the instructions.",
      errorMessageWrongFormat: "File must have the extension .CSV",
      errorMessageFileTooLarge: "The file is too large. Maximum file size: 5 MB.",
      exportDevice: "Export devices",
      csvHeaders: {
        category: "CATEGORY",
        type: "TYPE",
        inventoryNumber: "INVENTORY NUMBER",
        serialNumber: "SERIAL NUMBER",
        manufacturer: "MANUFACTURER",
        code: "CODE",
        power: "POWER",
        meter: "METER",
        electricityMeterManufacturer: "ELECTRICITY METER MANUFACTURER",
        electricityMeterNumber: "ELECTRICITY METER NUMBER",
        acquisitionDate: "ACQUISITION DATE",
        availability: "AVAILABILITY",
        location: "LOCATION",
        comment: "COMMENT",
        meterReading: "METER READING",
        locationName: "LOCATION NAME",
        error: "ERROR",
      },
      fileName: "File name",
      genericError: "Error",
      guide: {
        acquisitionDate: "ACQUISITION DATE",
        availability: "AVAILABILITY",
        category: "CATEGORY",
        code: "CODE",
        comment: "COMMENT +",
        counter: "METER",
        counterReading: "METER READING",
        electricityMeterManufacturer: "ELECTRICITY METER MANUFACTURER",
        electricityMeterNumber: "ELECTRICITY METER NUMBER",
        inventoryNumber: "INVENTORY NUMBER",
        location: "SITE",
        manufacturer: "MANUFACTURER",
        power: "POWER",
        serialNumber: "SERIAL NUMBER",
        step1: "Import via a CSV file with the following properties:",
        step2: "Order of fields",
        step3: "Device categories / device types",
        step4: "HyDry devices cannot be created or changed via import.",
        step5:
          "Each device must have either a unique inventory number or a unique serial number, otherwise it cannot be loaded.",
        step6: "Empty fields are not updated.",
        step7: "Formats / Selection",
        subStep1a: "Heading line (not analysed)",
        subStep1b: "Device data with fields corresponding to the heading line",
        subStep1c: "Field separator semicolon (;)",
        subStep1d: "Character format UTF-8",
        subStep3a:
          "Device types and device categories are only created or updated automatically if this is specified in CONFIGURATION IMPORT.",
        subStep7a:
          "COUNTER: Counter types 0=No counter, 1=Operating hours, 2=Power, 3=External power",
        subStep7b: "CODE: Enter barcode, QR code or NFC. Must be unique.",
        subStep7c: "ACQUISITION DATE: Use format DD.MM.YYYY",
        subStep7d: "AVAILABILITY: 0=available, 1-9=not available",
        title: "Import of devices",
        type: "TYPE",
      },
      confirmImport: "Confirm import",
      import: "import",
      importCancelled: "File import was cancelled",
      importDevices: "Import new devices",
      importSuccess: "File successfully imported",
      importPreview: "Import Preview",
      previewComplete: "Preview complete",
      newDevices: "New devices",
      newImport: "Import new file",
      noHistoryData: "--- no progress data found ---",
      readingFile: "Reading file ...",
      reportDownload: "Report",
      title: "HyDry devices",
      updatedDevices: "Updated devices",
      uploadBoxTest1: "Import file via drag & drop",
      uploadBoxTest2: "or",
      uploadBoxTest3: "Search file",
      user: "User",
    },
    hiddenComBoxHumidityUnit: {
      title: "Hidden humidity unit",
    },
    hyDryDevices: "HyDry Devices",
    hyDryDeviceSettings: {
      alwaysShowSerialNumber: "Always show serial number for HyDry devices?",
      minRunDurationForAnalysis: "Minimum run length for analyses",
    },
    ires: {
      enableSpecialRightsForIresClientOrAdmin:
        "Activate special rights for IRES users?",
      ignoreIresAdminOrIresClientCheck:
        "Ignore IRES Admin or IRES Client check?",
      ignoreIresAdminOrIresClientCheckShort:
        "Ignore IRES Admin or IRES Client check?",
      iresConfiguration: "IRES settings",
      memberClients: "Member clients",
      title: "IRES",
    },
    logo: "Logo",
    mailbox: {
      confirmDeleteMailboxMessage:
        "Are you sure you want to delete this mailbox?",
      confirmDeleteMailboxTitle: "Delete mailbox",
      errorNameAlreadyTaken: "Name is already in use",
      mailbox: "Mailbox",
      memberUsers: "Outgoing user",
      name: "Name",
      sortValue: "Sort number",
      targetUsers: "Input user",
    },
    mailboxes: "Manage mailboxes",
    messageSelection: "Configure messages",
    messages: "Messages",
    minProgramChainDurationInMinLabel: "Minimum drying duration",
    minProgramChainDurationInMinMessage:
      "Limit for displaying dryings for HyDry devices (dryings with shorter length are hidden):",
    minProgramChainDurationInMinTitle:
      "Minimum drying length for HyDry devices",
    minGeneralGapDurationInMinLabel: "Maximum gap to merge",
    minGeneralGapDurationInMinMessage:
      "Consecutive entries of the same project and phase are merged into one when the gap between them is at most this value (in minutes):",
    minGeneralGapDurationInMinTitle:
      "Threshold for merging identical entries",
    travelArrivalRadiusLabel: "Arrival radius (m)",
    travelArrivalRadiusTitle: "Arrival radius for drives",
    travelArrivalRadiusMessage:
      "From how far away a drive counts as interrupted rather than arrived. Straight-line " +
      "distance, in metres. Applies to all of your staff.",
    permissions: {
      assignProjectToOthers: "D2 Assign project to others",
      basicLicence: "B1 Basic licence projects",
      cancel: "CANCEL",
      clientAdministration: "M1 Member administration",
      createProject: "C2 Create new project",
      damageAssessmentLarge: "F2 Does damage assessment",
      defineDeviceCategories: "E1 Define device categories",
      deleteProject: "C3 Delete projects",
      deviceAdministration: "M2 Device management",
      drying: "F3 Does drying",
      dryingAndRecording: "B3 Drying licence",
      editAdmin: "Manage A1 Admin",
      editDevices: "E3 Manage devices",
      editProjects: "C5 Edit projects",
      editUser: "A2 Manage users",
      editValidation: "A3 Change own validation level",
      haveVehicle: "F5 Has vehicle",
      importDevicesCategories: "E2 Import devices",
      leakDetection: "F1 Does leak detection",
      manageProduction: "P2 Manage production",
      manageClients: "P3 Manage clients",
      office: "B4 Does Office",
      permissions: "Authorisations",
      projectManagement: " B5 Does Project management",
      projectsSuperVision: "D3 Does project management",
      rateDryings: "P1 Rate dryings",
      recording: "B2 Licence assessment",
      reopenCompletedPhases: "C4 Reopen projects",
      repair: "F4 Does restauration",
      return: "BACK",
      save: "SAVE",
      saveEdit: "SAVE CHANGES",
      saveEditsSuccessfull: "Changes saved",
      seeAllProjects: "C1 See all projects",
      seeAllSettings: "A4 Manage configuration",
      selfAssignProjects: "D1 Assign projects to yourself",
      settingsAdministration: "M3 General settings",
    },
    permissiontManagement: {
      title: "Manage roles",
    },
    projectManagement: {
      archivedProjects: {
        title: "View old projects",
      },
      deviceManagerSettings: {
        canUserAddContactPersons: "User may add apartments",
        canUserAddDevices: "User may add devices",
        canUserAddProjects: "User may add projects",
        canUserAddRooms: "User may add rooms",
        recentlyCompletedTask: "Show finished work (days)",
        title: "Settings IRES Work ",
        validation: {
          maxValue: "Value may be a maximum of {max}",
          minValue: "Value must be at least {min}",
        },
      },
      projectEditingSettings: {
        defaultDryingDuration: "Preset drying time (days)",
        defaultFollowUpInspectionInterval:
          "Resubmission always after 1 day | Resubmission always after {count} days",
        projectDuration: "Preset project runtimes",
        title: "Settings project implementation",
        automaticProjectNames: "Automatic project names",
        deviceAssignment: "Device assignment",
        roomLevelDeviceAssignment: "Device assignment at room level",
        projectOverviewTilesForOfficeProjects: "Tiles for device assignment",
        templateFields: {
          PROJECT_NUMBER: "Project number",
          ZIP_CODE: "Postal code",
          CITY: "City",
          STREET: "Street",
          HOUSE_NUMBER: "House number",
          NAME: "Name",
          COMMA: "Comma",
        },
        resetToAuto: "Reset to automatic",
        availableFields: "Available fields",
        commaNotAllowedAtEdge: "Comma cannot be placed at the beginning or end.",
        preview: "Preview",
      },
      projectManagerSettings: {
        actionButtons: {
          apartmentAttendees: "K3 Flat: ATTENDEES",
          options: {
            hide: "Hide",
            hideAlt: "Do not propose",
            red: "Red",
            yellow: "Yellow",
          },
          leakDetectionSketchAndMeasurementPoints:
            "K2 Leak detection: Sketches + measurement points",
          pipeSystem: "K2 Leak detection: PIPING SYSTEM",
          projectAttendees: "K2 Project: PERSONS PRESENT",
          projectCause: "Cause",
          title: "Action Buttons",
          tradeRenovation: "K3 Leak detection: TRADES RECONSTRUCTION",
        },
        damageAssessment: {
          enforceFullDamageAssessment: "Always COMPLETE DAMAGE ASSESSMENT?",
          title: "Damage assessment",
        },
        measurementPoints: {
          canAddMeasurementPointsInApartment:
            "Allow measurement points in FLATS?",
          preferAbsHumidity: "Show moisture preferably as ABS. MOISTURE?",
          roomClimateMeasuringPoints: "Measurement point ROOM CLIMATE",
          measurementPointPresetPhase: "Preset in LEAK DETECTION",
          measurementPointPresetPhaseOptions: {
            leakDetection: "Leak detection",
            drying: "Drying",
          },
          title: "Measurement points",
        },
        photo: {
          hintPhotoQuality: "Quality note for photos",
          title: "Images",
        },
        projectPhases: {
          dryingSetupEnquiry: "Enquiry after drying set-up?",
          enforceFullDamageAssessment: "Always COMPLETE DAMAGE ASSESSMENT?",
          title: "Project phases",
        },
        sketch: {
          errorPresetRoomHeight: "Values must be between 0 and 500.",
          errorPresetWallThickness: "Values must be between 0 and 99.",
          presetInnerWallThickness: "Inner wall",
          presetOuterWallThickness: "Outer wall",
          presetPartyWallThickness: "Party wall",
          presetRoomHeight: "Preset room height (cm) (0 = None)",
          presetWallThickness: "Preset wall thickness (cm) (0 = None)",
          sketchInRooms: "K3 Sketch in rooms",
          title: "Sketch",
        },
        title: "Settings IRES Project",
        trades: {
          quantitySurveyInReport: "Quantity survey in the report",
          tableAutomaticallyInReport: "Table automatically in the report",
          tableSorting: {
            options: {
              apartmentPhase: "Flat, phase",
              apartmentTrade: "Flat, trade",
              phaseTrade: "Phase, trade",
              roomPhase: "Room, phase",
              roomTrade: "Room, trade",
              tradePhase: "Trade, phase",
            },
            title: "Sorting table",
          },
          title: "Service provider trade",
        },
        serviceList: {
          title: "Service list",
          presetFlexibleServiceList: "Preset flexible service list",
        },
      },
      projectSettings: {
        editProjectsIn: "Execute CHANGE PROJECT DATA?",
        finaliseProjectsIn: "Execute PROJECT COMPLETION?",
        newAppointmentsIn: "Execute NEW APPOINTMENTS?",
        newProjectsIn: "Execute NEW PROJECTS?",
        projectTypesConfiguration: {
          active: "Active",
          label: "Label",
          phases: "Phases",
          platforms: "Platforms",
          title: "Possible project types",
          type: "TYPE",
          validation: {
            atLeastOneActive: "Please activate at least one project type",
            labelDuplicate:
              "The name has already been assigned. Please choose a unique name",
            typeBadgeDuplicate:
              "Type code has already been used. Please choose a unique code",
            typeBadgeInvalid:
              "Type code is invalid. Only 1-2 alphanumeric characters (A-Z, 0-9) are permitted",
          },
        },
        title: "Project settings",
      },
      title: "Projects",
    },
    report: {
      dataProtection: {
        contactDataInExternalReports: "Contact data in external reports",
        title: "Data protection",
      },
      emailInboxes: {
        damageReportEmailAddress: "Email for damage reports",
        dryingReportEmailAddress: "Email for drying reports",
        leakDetectionReportEmailAddress: "Email for leak detection reports",
        title: "E-mail inboxes",
      },
      errorEmailAddress: "Please enter valid email address",
      equipmentUsage: {
        includeGenericDeviceAssignments: "Include devices in report",
        createCertificate: "Create certificate",
        title: "Equipment usage",
      },
      images: {
        contentOrder: "Block order in reports",
        contentOrderOptions: {
          sketchImagesText: "Sketches / Images / Text",
          sketchTextImages: "Sketches / Text / Images",
          textSketchImages: "Text / Sketches / Images",
        },
        imageForMeasurementPoints: "Images for measurement points",
        imageQuality: "Preset image quality",
        imageQualityHigh: "High",
        imageQualityLow: "Low",
        imageQualityNormal: "Medium",
        imageReportAfterDamageAssessment:
          "Create image report after damage assessment",
        imageReportAfterDamageAssessmentOptions: {
          no: "No image reports",
          selectionAsExternalReport: "Select like for external report",
          selectionAsInternalReport: "Select like for internal report",
        },
        imagesPerRow: "Images per line",
        showDamagePatternInfoInLeakDetectionReport:
          "Show damage pattern in leak detection report",
        showReportConfigInProject: "Ask for image configuration",
        title: "Images in reports",
      },
      json: {
        title: "Reports as JSON",
        sendReportAsJson: "Generate and distribute reports as JSON",
      },
      logo: {
        dropHint: "Drop logo here or click",
        expandPreview: "Enlarge preview",
        hint: "Accepted formats: JPEG and PNG",
        noLogo: "No logo",
        removeLogo: "Remove logo",
        uploadLogo: "Upload logo",
        scalingFactor: "Logo scaling (%)",
        selectFile: "Select file",
        title: "Logo",
      },
      outgoingReports: {
        reportsList: "Reports as list",
        reportsListOptions: {
          individualPdfDocuments: "PDF documents separated",
          separatePdfAndTimeEntries: "PDF and time entries separated",
          summarizedReportsOnly: "Summarised reports only",
        },
        saveReport: "in directory",
        sendAsEmail: "send as email",
        sendOutgoingReportsAsOptions: {
          iresCloud: "Yes, via IRES Cloud",
          localEmail: "Yes, via local e-mail",
        },
        title: "Outgoing reports",
      },
      reportEmailAddress: "Email address for reports",
      reportSettings: "Settings reports",
      timeEntriesOnNewPage: "Time entries on new page?",
      timeTracking: {
        companyAddressInTimeRecord: "Company address in time entry?",
        phaseInTimeRecord: "Project phase",
        workTimeInTimeRecord: "Working time in time sheet",
      },
      individualReports: {
        title: "Individual reports",
        documentsInReports: "PDF documents",
        timeEntriesInReports: "Time entries",
        reportInclusionOptions: {
          internalReport: "in the internal report",
          externalReport: "in the external report",
          separateReport: "as an individual report",
          separateReportTotal: "as one individual report (total)",
          separateReportIndividual: "as an individual report each",
        },
        measurementProtocolAsSeparateReport: "Measurement protocol as separate report",
        measurementProtocolAsSeparateReportOptions: {
          no: "No",
          yes: "Yes",
        },
        imageReportAfterDamageAssessment: "Image reports and image selection",
      },
      footer: {
        title: "Footer",
        footerText: "Text in footer",
        footerTextOptions: {
          appVersion: "App version",
          company: "Company",
          location: "Location",
        },
        projectInfo: "Project info in footer",
        projectInfoOptions: {
          projectId: "Project number",
          collectionNumber: "Collection number",
          projectIdAndCollectionNumber: "Project number / Collection number",
        },
        showTotalPageCount: "Show total page count (7 of 13)",
      },
      title: "Reports",
    },
    roleManagement: {
      cancelMessage:
        "You have already made changes. Would you like to discard these changes?",
      cancelTitle: "Discard changes?",
      capabilityOption: {
        conditional: "Possibly",
        no: "No",
        yes: "Yes",
      },
      edit: "Configure roles",
      editRole: "Edit role",
      error: {
        activeUserForRole: "There are still active users with this role",
        wrongLabel: "Please enter a valid role name",
      },
      roles: {
        description: "Description",
        label: "Name",
        roleActive: "Status",
        roleId: "No",
        users: "# Users",
      },
      memberClientHint: "Note: The role configuration can be changed in the MASTER.",
      title: "Manage roles",
      titleAlt: "Show roles",
      viewRolesConfiguration: "Show role configuration",
    },
    scheduling: {
      control: {
        acceptableDelayInMin: "Delay",
        title: "Control",
      },
      defaultBreakDurations: {
        lunchBreak: "Lunch pause",
        maxTimeWithoutBreak: "Time until pause",
        title: "Pauses",
      },
      defaultTaskDurations: "Preset work time",
      objectiveFunctionParameters: {
        title: "Target function",
        weights: {
          dailyWorkTimeExceedance: "Weighting of excess work hours/day",
          targetDate: "Weighting target date",
          targetDateFixed: "Weighting fixed target date",
          targetQualification: "Weighting target qualification",
          targetTime: "Weighting Target time",
          targetTimeFixed: "Fixed target time weighting",
          targetUser: "Weighting of worker",
          timeGap: "Weighting time gap",
          total: "Total scaling",
          travelTime: "Weighting of travel time",
          weeklyWorkTimeExceedance: "Weighting of excess working hours/week",
        },
      },
      occupiedTimeUsage: {
        breakUsage: "Pause",
        none: "off",
        plan: "schedule",
        show: "show",
        travelTimeUsage: "Travel times",
      },
      planningBoard: {
        formatColor: "Colour {0}",
        taskColors: "Colours",
        title: "Scheduling presentation",
        visibleArea: {
          fourWeeks: "4 weeks",
          from: "Display from",
          oneDay: "1 day",
          oneWeek: "1 week",
          title: "Visible area",
          twoWeeks: "2 weeks",
          until: "Display until",
        },
        visibleRange: {
          title: "Display period",
        },
      },
      section: {
        geocodingAndTravelTimes: "Geocoding and journey times",
        planningBoard: "Scheduling presentation",
        planningControl: "Scheduling configuration",
      },
      title: "Scheduling",
      travelTimeAndPauses: "Travel times and pauses ",
      travelTimeSettings: {
        betweenTaskAndDepot: "Preset first travel time",
        betweenTasks: "Preset intermediate travel time",
        title: "Geocoding and journey times",
        travelTimeBuffer: "Time surcharge",
        travelTimeCalculationViaMap: "Travel time via map",
      },
      workingHours: {
        defaultWorkDayEnd: "Work hours end",
        defaultWorkDayStart: "Work hours start",
        defaultWorkingHoursPerDay: "Work time/day",
        defaultWorkingHoursPerWeek: "Work hours/week",
        earliestWorkDayStart: "Earliest start",
        latestWorkDayEnd: "Latest end",
        lunchBreakAfter: "Plan break after",
        longBreakDuration: "Extended break duration",
        longBreakThresholdHours: "Work hours over",
        maxWorkingHoursPerDay: "Max. work time/day",
        maxWorkingHoursPerWeek: "Max. working hours per week",
        minBreakDuration: "Min. break duration",
        shortBreakDuration: "Normal break duration",
        shortBreakThresholdHours: "Work hours over",
        title: "Work hours and pauses",
      },
    },
    sharedEmailAddress: {
      changePasswordHint:
        "Please enter new password to share your email address",
      changePasswordHintOld:
        "Please enter new password to share your email address",
      title: "Password for sharing the email address",
      titleOld: "Share email address",
    },
    sharedEmailAddressOptions: {
      title: "Edit shared email address",
    },
    showDeviceManagementInCockpit: {
      title: "Show device management in cockpit",
    },
    system: {
      clientEmailAndPassword: "Database email address and password",
      dataStorage: "Configure data storage",
      dataStorageDatabase: "Storage database",
      dataStorageTablet: "Data storage tablet",
      finishedProjects: {
        title: "Archive projects",
        currentProjectsNotTouched:
          "Move projects that are no longer being pursued?",
        deleteProjectsNotProcessed: "Project in K1, no action: Delete project?",
        moveFinishedProjects: "Move FINISHED PROJECTS to OLD PROJECTS?",
        moveProjectsClosed:
          "Project in K8 completed, not finished: Move project?",
        moveProjectsDamagePatternClosed:
          "Project in K4 completed, not finished: Move project?",
        moveProjectsOnHold:
          "Project in K4 waiting for insurance. Move project?",
        numberOfDays: {
          never: "Never",
          one: "1 day",
          two: "2 days",
          three: "3 days",
          four: "4 days",
        },
        numberOfMonths: {
          never: "Never",
          three: "3 months",
          six: "6 months",
          nine: "9 months",
          twelve: "12 months",
          twentyFour: "24 months",
        },
        numberOfWeeks: {
          never: "Never",
          one: "1 week",
          two: "2 weeks",
          four: "4 weeks",
          eight: "8 weeks",
          twelve: "12 weeks",
        },
        recentlyFinishedProjects:
          "Show recently completed projects at CURRENT PROJECTS?",
      },
      geoEncoding: "Map",
      tracking: "Tracking",
      moveDevicesDialog: {
        message:
          "All devices are returned to the warehouse from which they were originally loaded. Would you like to continue?",
        title: "Move devices back to warehouses?",
      },
      operationalPlaning: "Scheduling",
      mira: {
        title: "Mira",
        mode: {
          OFF: "No",
          IRES_ONLY: "IRES only",
          ON: "Yes",
        },
      },
      systemConfiguration: "System configuration",
      chat: {
        title: "Enable chat / messenger?",
        mode: {
          NONE: "No",
          PERSONAL_ONLY: "Personal chat only",
          PROJECT_ONLY: "Project chat only",
          BOTH: "Both chats",
        },
      },
      title: "System",
    },
    timeTracking: {
      configuration: "Configure work time recording",
      createDailyTracking: "Create daily closing",
      dailyTracking: "Daily closing",
      isStartEndMandatory: "Start and end mandatory",
      sectionTitle: "Work time recording",
      sendDailyTracking: "Send daily closing",
      specifyStartEnd: "Specify start and end",
      title: "Time recording",
      workingHours: "Work hours and pauses",
    },
    upload: "Upload",
    userManagement: "User",
    userSettings: {
      alwaysUseManagerAsSupervisor: "Always set Manager as Project manager",
      cockpitActiveForAllUsers: "Show cockpit for all users?",
      keepProjectOwner: "Retain worker",
      strictBranchFilters: "Site binding",
      title: "User settings",
    },
    users: "Manage users",
    vehicleManagement: {
      createVehicle: "Create vehicle",
      deleteVehicle: "Delete vehicle",
      deleteVehicleMessage: "Really delete vehicle {0}?",
      editVehicle: "Edit vehicle",
      errorDuplicateLicencePlate: "Licence plate already existing",
      errorDuplicateVehicleId: "Vehicle ID already existing",
      errorMissingLicencePlate: "Licence plate must not be blank",
      errorMissingVehicleId: "Vehicle ID must not be empty",
      licencePlate: "Licence plate",
      location: "Site",
      size: "Size",
      sortNumber: "Sort No..",
      title: "Manage vehicles",
      user: "User",
      vehicleId: "Vehicle ID",
    },
  },
  sharedEmailAddressForm: {
    changeHomeClientButton: "Set new home client",
    changeHomeClientTitle: "Set new home client",
    changePasswordButton: "Assign new password for shared email address",
    changePasswordTitle: "Password for sharing the email address",
    confirmChangeHomeClient: "Change home client to {0}?",
    confirmChangeHomeClientTitle: "Are you sure?",
    quitSharingButton: "Stop sharing email address for this client",
    quitSharingTitle: "Please enter new email address",
  },
  sharedEmailAddressOptionsDialog: {
    message:
      "Multiple registration for HyDry Portal. Please select the desired client.",
    title: "Multiple registration for HyDry Portal",
    titleForSwitchingSharedUser: "Select shared user",
  },
  sharedUserOfGroup: {
    clientOptionsDialog: {
      message:
        "Multiple registration for HyDry Portal. Please select the desired client.",
      title: "Multiple registration for HyDry Portal",
      titleForSwitchingClient: "Select client",
    },
  },
  userPicker: {
    noMatchingUsers: "No matching users found.",
    noUsers: "There are no other users available.",
    selectUser: "Select user",
  },
  users: {
    activateCockpit: "Activate cockpit in app",
    activeFilters: "--- active filters: {0} ---",
    allRoles: "All roles",
    admin: "Admin",
    createUser: "Create user",
    deleteSharedEmailAddressDialog: {
      message: "Shared email access is removed. ",
      title: "Remove shared email access",
    },
    deleteUser: "Delete",
    deleteUserMessage: "Are you sure you want to delete user {0}?",
    editUser: "Edit user",
    emailAddress: "Email address",
    error: {
      notAllowedToChangeRole: "Only a SysAdmin of this client may change roles or create users.",
      saveFailed: "The user could not be saved. Please try again.",
      emailAlreadyUsed: "Email address is already in use",
      missingEmailAddress: "Please enter email address",
      missingNickname: "Please enter short names",
      missingRole: "Please specify role",
      missingValidationLevel: "Please enter value for formal checks",
      missingStaffNumber: "Please enter personnel number",
      invalidSupervisor: "Selected manager must have project supervision capability",
      nicknameAlreadyTaken: "Short name is already taken",
      passwordToShort: "Password must consist of at least 8 characters.",
      staffNumberAlreadyTaken: "Personnel number is already assigned",
      invalidField: {
        nickname: "Invalid short name (1–100 characters)",
        email: "Invalid email address",
        role: "Invalid role",
        staffNumber: "Invalid personnel number (max. 50 characters)",
        generic: "Invalid input — please check all fields",
      },
    },
    firstName: "First name",
    homeClient: "Home client",
    language: "Language",
    lastEdit: "Last update: {0} {1}",
    lastName: "Last name",
    licences: "Licences",
    lock: "lock",
    lockUser: "Block user",
    lockUserMessage: "Are you sure you want to lock user {0} {1}?",
    mobilePhone: "Mobile",
    nickname: "Short name",
    noUsersFound: "--- no users found ---",
    passwordHint:
      "Note/For the first login, the personnel number is required as the password",
    postalCode: "Postcode",
    resetUserPassword: "RESET PASSWORD",
    resetUserPasswordMsg: "Please enter temporary password for user {0} {1}",
    role: {
      admin: "Admin",
      customRole1: "Customised role 1",
      customRole2: "Customised role 2",
      customRole3: "Customised role 3",
      customRole4: "Customised role 4",
      customRole5: "Device manager",
      editRole: "Edit role",
      isActive: "Active role",
      label: "Role label",
      leakDetection: "Leak detection",
      na: "",
      notSpecified: "",
      office: "Office",
      projectManager: "Project manager",
      sysAdmin: "SysAdmin",
      technicanAndLeakDetection: "Technician + leak detector",
      technician1: "Technician 1",
      technician2: "Technician 2",
    },
    staffNumber: "Staff number",
    stationaryPhone: "Phone landline",
    supervisor: "Manager",
    temporaryPassword: "Temporary password",
    unlock: "unblock",
    unlockUser: "Unblock user",
    unlockUserMessage: "Are you sure you want to unlock user {0} {1}?",
    userAddressHousenumber: "House number",
    userAddressStreet: "Street",
    userCountry: "Country",
    userData: "User data",
    userLocation: "Location",
    userRole: "Role",
    userValidationLevel: "Validation",
    usesTablet: "Uses tablet",
    validationLevel: {
      low: "low",
      normal: "normal",
      strict: "strict",
    },
    vehicle: "Vehicle",
    vehicleAtHome: "Vehicle at home",
  },
  vehicles: {
    allocatedUser: "User",
    branch: "Site",
    devices: {
      concludeLoading: "Loading into vehicle",
      concludeUnloading: "Unloading in warehouse {0}",
      currentWarehouse: "Current stock:",
      deviceMoveInfo: "{0} from {1}",
      load: "Load vehicle",
      loadFailureMessage: "Error when loading devices into vehicle {0}",
      loadSuccessMessage:
        "1 device successfully loaded into vehicle {0} | {0} devices successfully loaded into vehicle {count}",
      locationUpdateFailureMessage:
        "Failed to update location of 1 device | Failed to update locations of {count} devices",
      locationUpdateSuccessMessage:
        "Location of 1 device successfully updated | Location of {count} device successfully updated",
      emptyDevicesHint: "No devices found.",
      noMatchingDevicesFound: "No suitable devices found",
      numberOfAvailableDevices:
        "1 device available | {count} devices available",
      numberOfSelectedDevices:
        "Device selection: 1 | Device selection: {count}",
      overview: "Devices in vehicle",
      title: "Devices in vehicle {0}",
      unload: "Unload vehicle",
      unloadFailureMessage: "Error when unloading devices from warehouse {0}",
      unloadSuccessMessage:
        "1 device successfully unloaded into warehouse {0} | {0} devices successfully unloaded into warehouse {count}",
      crossWarehouseUnloadTitle: "Different home warehouse",
      crossWarehouseUnloadMessage: "Some devices do not belong to this warehouse. Are you sure you want to unload them here?",
    },
    licencePlate: "Licence plate",
    numberOfDevices: "Devices in vehicle",
    vehicleId: "Vehicle ID",
  },
  quality: {
    title: "RENO Daily Assessment",
    chainTitle: "RENO Daily Assessment: Chain {0}",
    tabs: {
      daily: "Daily Result",
      manual: "Manual Result",
    },
    windows: {
      all: "All",
      days: "{0} Days",
      selectWindows: "Select Windows",
    },
    modelVersion: {
      label: "Model version",
    },
    trafficLight: {
      title: "Assessment",
      good: "Good",
      needsReview: "Needs Review",
      critical: "Critical",
      unknown: "Unknown",
    },
    status: {
      probablyDry: "Probably dry",
      probablyStationary: "Probably stationary",
    },
    binary: {
      title: "Binary Selection",
      abnormal: "Abnormal",
      normal: "Normal",
    },
    groupA: {
      title: "Main Labels",
      normal: "Normal",
      powerOutages: "Power Outages",
      newMoistureIngress: "New Moisture Ingress",
      slowDrying: "Slow Drying",
      unfavorableAmbientConditions: "Unfavorable Ambient Conditions",
    },
    groupD: {
      title: "Root Cause Slow Drying",
      peripheralMoisture: "Peripheral Moisture",
      withoutFoil: "Without Foil",
      ambientConditions: "Ambient Conditions",
      lowAirflow: "Low Airflow",
    },
    labels: {
      title: "Multi-Select Labels",
      subGroupA: "Drying Issues",
      subGroupB: "Device / Meta",
      powerFailure: "Power failures affecting drying",
      newMoisture: "New moisture ingress",
      slowDrying: "Slow drying",
      unfavorableConditions: "Unfavorable ambient temperature",
      ambientHumidityBad: "Unfavorable ambient humidity",
      lowInitialMoisture: "Low initial moisture",
      relayDefect: "Relay defect",
      notForTraining: "Do not use for training",
      clearClass: "Clear class",
    },
    actions: {
      saveCorrections: "Save Corrections",
      manualCalculation: "Manual Calculation",
      calculate: "Calculate",
      cancel: "Cancel",
      rerun: "Re-run",
    },
    messages: {
      correctionSaved: "Correction saved successfully",
      correctionError: "Error saving correction",
      predictionLoading: "RENO assessment is being calculated...",
      predictionComplete: "Prediction complete",
      predictionError: "Prediction error",
      featureNotActivated: "Predictions are not activated for this client.",
      latestModelOnlyRecalculation: "Recalculation is only available for the latest model version.",
      backfillComplete: "All daily predictions have been recalculated with the new model.",
      manualCalculationHint: "The calculation will be performed with the current RENO model over the entire drying period.",
      noData: "No RENO data available",
      noDailyData: "No daily assessment available",
      noDaySelected: "Please select a day in the time series.",
      noManualData: "No manual assessment available",
      programNotSupported: "RENO is not supported for this program number.",
      newerModelAvailable: "Newer model available ({0}). Results can be recalculated with the new version.",
      correctedBadge: "Corrected",
      correctedAt: "Corrected on {0}",
      correctedBy: "by {0}",
    },
    trend: {
      title: "Trend",
      days: "Last {0} days",
    },
    timeSeries: {
      title: "RENO Time Series",
      qualityLabel: "Quality",
      noData: "No time series data available",
      generateHistory: "Generate history",
      backfillProgress: "{0} of {1} days calculated",
      targets: {
        dry: "Dry",
        stationary: "Stationary",
        newMoistureIngress: "New Humidity",
        slowDrying: "Slow",
        powerOutage: "Power",
        relayDefect: "Relay",
        unfavorableAmbient: "Climate",
        lowAirflow: "Airflow",
        peripheralMoisture: "Peripheral Moisture",
        roomTemperature: "Temperature",
        roomHumidity: "Rel. humidity",
        moistureLoad: "Abs. humidity",
        deviceOutput: "Output",
        favorableWeather: "Ventilate",
      },
    },
    timeline: {
      stationary: "Stationary",
      dry: "Dry",
    },
    noAiModel: "No AI model",
  },
  mira: {
    exceptions: {
      leftOut: "{0} left out as exceptions",
    },
    landing: {
      comingSoon: "Details coming soon",
      available: "1 figure available | {n} figures available",
      waiting: "1 waiting for data | {n} waiting for data",
      ratioLong: "{0} of {1} figures",
      settings: {
        open: "Settings",
        title: "{0}: figures",
        editTitle: "Edit {0} figures",
        availableHeading: "Available figures",
        waitingHeading: "What unlocks further figures",
        defaultChoice: "The tile shows the first {0} figures of this section.",
        ownChoice: "The tile shows only the chosen figures.",
        hint: "Click the figures in the order they should appear on the tile (at most {0}). Click one again to take it out.",
        reset: "Default",
        saved: "Selection saved",
        saveError: "The selection could not be saved.",
      },
      descriptions: {
        businessDevelopment: "Projects, project duration, conclusion types and response time",
        processFlow: "How long the steps of a job take and where it waits",
        hydry: "Drying time, pauses, measurement frequency and drying area",
        devices: "Device days, operating hours, power consumption and fleet utilisation",
        insurance: "Approval time, acceptance rate and approved drying time",
        dataQuality: "How completely your projects and devices are recorded",
      },
    },
    unlock: {
      title: "Unlock more metrics",
      waiting: "1 metric is waiting for your data | {n} metrics are waiting for your data",
      allUnlocked: "All metrics are unlocked",
      showAll: "Show all",
      parts: {
        RECORD: {
          title: "What you can record",
          subtitle: "The more complete these details, the more figures you see.",
        },
        CASES: {
          title: "Comes with more cases",
          subtitle: "Nothing to do here: the figure appears once enough cases come together.",
        },
      },
      shareProgress: "{0} recorded · visible from {1}",
      countProgress: "{0} of {1} cases needed",
      casesInstruction: "Appears once at least {0} cases are reached in the period.",
    },
    periods: {
      rolling12: "Last 12 months",
      ytd: "This year",
      quarter: "Q{0} {1}",
      groups: {
        rolling: "Period",
        months: "Months",
        quarters: "Quarters",
        years: "Years",
      },
    },
    baseline: {
      twelveMonthsBefore: "The 12 months before",
      sameMonthsLastYear: "The same months last year",
      previousYear: "Previous year",
      comparedWith: "Compared with: {0} ({1} to {2})",
      scaledNote: "totals scaled to the length of the period",
    },
    sections: {
      businessDevelopment: "Business development",
      processFlow: "Process",
      hydry: "Drying",
      devices: "Devices",
      insurance: "Insurers",
      dataQuality: "Data quality",
    },
    format: {
      hours: "{0} h",
      percent: "{0}%",
      percentBelow: "< {0}%",
      percentAbove: "> {0}%",
      deltaPoints: "{0} PP",
      others: "Others ({0})",
      spread: "P15 {0} · P85 {1}",
      median: "Median {0}",
    },
    allClients: {
      label: "All clients",
    },
    periodTooltip: "Period",
    edition: "{0} · From the workshop · {1}",
    comparison: {
      upwardTooltip: "Compare upwards",
      downwardTooltip: "Compare downwards",
      saved: {
        manage: "Manage comparisons …",
        create: "New comparison",
        editTitle: "Edit comparison",
        reset: "Reset",
        kindLabel: "Compare",
        kinds: {
          BRANCHES: "Branches",
          MEMBERS: "Clients",
          INSURERS: "Insurers",
        },
        max: "At most {0} comparisons: delete one to create a new one.",
        nameRequired: "Give the comparison a name.",
        saved: "Comparison saved",
        deleted: "Comparison deleted",
        saveError: "The comparison could not be saved.",
        deleteTitle: "Delete comparison",
        deleteMessage: "Do you really want to delete the comparison \"{0}\"?",
        listTitle: "Comparisons",
        empty: "You have not created a comparison yet. Create one and choose what you want to compare yourself with.",
        hint: {
          BRANCHES: "Click the branches in the order their bars should stand in, at most {0}.",
          MEMBERS: "Click the clients in the order their bars should stand in, at most {0}.",
          INSURERS: "Click the insurers in the order their bars should stand in, at most {0}.",
        },
        noCandidates: {
          BRANCHES: "This client has no branches.",
          MEMBERS: "This group has no clients.",
          INSURERS: "This client has no insurers with enough projects.",
        },
      },
      choice: "Comparison: {0}",
      cardTitle: "{0} by client",
      referenceGroup: "Group total",
      markers: "P15 {0} · median {1} · P85 {2}",
      markersLegend: "Lines: {0}, over the projects of the first row",
      withoutValue: "No value: {0}",
      membersSuffix: "across {0} of {1} companies",
      membershipAssumed: "Group as composed on {0}: earlier changes are not reflected.",
      showAll: "Show all",
      showLess: "Show less",
      empty: "No client in the group has a value for this figure in the period.",
      cardTitleBranches: "{0} by branch",
      cardTitleInsurers: "{0} by insurer",
      emptyInsurers: "No insurer has a value for this figure in the period.",
      insurerOther: "Other insurers",
      cardTitleGroupView: "{0} in the group",
      emptyBranches: "No branch has a value for this figure in the period.",
      groupView: {
        withheld: "Too few companies or cases: {0}",
        empty: "There is no group value for this figure.",
      },
      noMetricForBranches: "There is no branch comparison for this figure.",
      noMetricForInsurers: "There is no comparison by insurer for this figure.",
      referenceClient: "Total",
      branchNone: "No branch",
      branchOther: "Other branches",
      branchUnknown: "Unknown branch",
      headline: "{0}: {1}",
      modes: {
        NONE: "No comparison",
        MEMBERS: "Member clients of the group",
        BRANCHES: "Branches of the client",
        MARKET: "Market",
        GROUP: "Group",
        INSURERS: "Insurers",
      },
    },
    market: {
      cardTitle: "{0} in the market",
      tileCaption: "Market {0}",
      tileCaptionWithClients: "Market {0} ({1})",
      clients: "{0} clients",
      countryOption: "Market {0}",
      tooFewCompanies: "Too few companies with enough cases: {0}",
      empty: "There is no market value for this figure.",
      entities: {
        projects: "Market",
      },
    },
    trend: {
      title: "Trend: {0}",
      grains: {
        month: "Month",
        quarter: "Quarter",
        year: "Year",
      },
      gapNote: "Gaps: too few cases in the period to show a value.",
      partialNote: "Hollow point: the current year, not yet complete.",
      scrollHint: "Earlier periods: swipe sideways.",
      bandNote: "Band: P15 to P85, the middle 70% of cases.",
      rangeNote: "{0} to {1}, whatever period is chosen",
      periodNote: "Shaded grey: the chosen period.",
      medianLineNote: "Line: average · thin line: median",
      partialYear: "{0} (to date)",
      tooFew: "too few",
      tooltipBasis: "over {0}",
      tooltipMedian: "Median {0}",
      noData: "There is no data for this figure in the chosen view.",
    },
    units: {
      projects: "{0} projects",
      projectsOne: "1 project",
      dryings: "{0} dryings",
      dryingsOne: "1 drying",
      assignments: "{0} assignments",
      assignmentsOne: "1 assignment",
      assignmentsWithReading: "{0} assignments with a meter reading",
      assignmentsWithReadingOne: "1 assignment with a meter reading",
      readings: "{0} counter readings",
      readingsOne: "1 counter reading",
      offers: "{0} offers",
      offersOne: "1 offer",
      answers: "{0} answers",
      answersOne: "1 answer",
      deviceDays: "{0} device days",
      deviceDaysOne: "1 device day",
      devices: "{0} devices",
      devicesOne: "1 device",
    },
    stacked: {
      tooltipTotal: "Total {0}",
      restNote: "{0} more below in the ranking",
      barFloorNote: "Bars based on fewer than {0} cases are hidden.",
    },
    levels: {
      best: "Best",
      worst: "Worst",
      highest: "Highest",
      lowest: "Lowest",
      note: "Per period, across all with a value: the two outer values and the 25%, 50% and 75% marks between them. The marks split the compared entries, not the value; each bar is one entry's own value. Each one is listed in the ranking below.",
      namesFor: "In brackets: who stands there in {0}.",
      ranked: "Five places in the ranking below, the same in every period.",
    },
    caveat: {
      weakestFieldWithGaps: "The value is the least filled-in field. Insurer, drying area and project manager are not checked here yet.",
      routeRecordedSince2025: "The recording source has only been stored since 2025.",
    },
    dataQuality: {
      title: "Data quality",
      noData: "There are no Mira analyses for your company yet.",
      loadError: "The Mira analyses could not be loaded.",
      noValue: "No data in this period",
      periodRange: "{0}: {1} to {2}",
      generatedAt: "As of: {0}",
      weakestField: "Least filled in: {0}",
      energyCaption: "of {0} ended assignments of devices with their own meter",
      insurerCaptureCaption: "across {0} projects that are not direct orders",
      fieldsTitle: "Field coverage by field",
      fieldsSubtitle: "across {0} projects, least filled-in field first",
      energyTitle: "Meter readings",
      energyRingCaption: "with readings",
      energySubtitle: "how the ended assignments of devices with their own meter are recorded",
      status: {
        good: "Well recorded",
        warning: "Incomplete",
        critical: "Too little recorded",
      },
      legend: {
        good: "80 % and above",
        warning: "40 to 79 %",
        critical: "below 40 %: figures that depend on it stay hidden",
      },
      fields: {
        branch: "Branch",
        projectTypeId: "Project type",
        damageDay: "Day of the damage",
        outcomeState: "Damage assessment result",
        rooms: "Rooms in the damage assessment",
        timeline: "Start and end",
        timeEntries: "Time entries on the project",
      },
      energy: {
        withReading: "With meter readings",
        unknownReading: "Without a meter reading",
        invalidReading: "Invalid meter reading",
        implausibleReading: "Implausibly high consumption",
        onImplausibleProject: "{0} of them are on projects with implausibly high consumption; they are counted above.",
      },
      unlocks: {
        title: "What unlocks further figures",
        description: "These figures stay hidden for the chosen period until enough is recorded.",
        none: "No figure is missing recorded data in the chosen period.",
        fallback: "Too little recorded data in this period.",
      },
    },
    drying: {
      title: "Drying",
      families: {
        box: "Box",
        mini: "Mini",
        panel: "Panel",
      },
      units: {
        day: "{0} day",
        days: "{0} days",
        squareMetres: "{0} m²",
        perWeek: "{0} per week",
        perProject: "{0} per project",
      },
      captions: {
        dryingTime: "{0} · across {1} dryings ({2})",
        pauseShare: "{0} · across {1} dryings ({2})",
        dryingsWithoutFamily: "{0} · across {1} dryings",
        projectDryingTime: "{0} · across {1} projects",
        projectPauseShare: "{0} · across {1} projects",
        measurementFrequency: "across {1} dryings, {0} of them without an intermediate measurement",
        measurementsPerProject: "across {1} projects, {0} of them without an intermediate measurement",
        dryingArea: "{0} · across {1} projects",
        forecast: "on average over the forecast · across {1} dryings, {0} of them longer than planned",
      },
      cards: {
        dryingTime: "HyDry drying time by device type",
        dryingTimeSubtitle: "Program chains without a project of 4 hours or more, mean and median",
        pauseShare: "Share of pauses by device type",
        pauseShareSubtitle: "Pauses as a share of drying time, dryings without a project",
        measurementFrequency: "Measurement frequency",
        measurementFrequencySubtitle: "Measurement series per week of drying, excluding the series at drying set-up and pack-up",
        measurementsPerProject: "Intermediate measurements per project",
        measurementsPerProjectSubtitle: "Intermediate measurements per dried project with a measurement at drying set-up",
        dryingArea: "Drying area",
        dryingAreaSubtitle: "average area per dried project",
        forecast: "Forecast and actual drying time",
        forecastSubtitle: "how often and how far dryings run past their forecast",
      },
      dotPlot: {
        mean: "Mean",
        median: "Median",
        count: "Dryings",
      },
      shortChains: "{0} program chains under 4 hours are not counted.",
      shareWithPause: "{0} with a pause",
      pause: {
        dryingPause: "Drying pause",
        powerCut: "Power cut",
      },
      measurementGroups: {
        hydry: "With HyDry devices ({0})",
        conventional: "Conventional devices only ({0})",
        noDevices: "No devices assigned ({0})",
      },
      area: {
        floor: "Floor",
        wallCeiling: "Wall / ceiling",
      },
      forecast: {
        overForecast: "Longer than planned",
      },
      facts: {
        median: "Median",
        withoutArea: "Projects without an area",
        meanOverrun: "On average over the forecast",
        fromDefault: "Forecast kept at the default",
        noForecast: "Without a forecast",
        noActual: "Without an actual duration",
      },
      inPreparation: "In preparation: {0}",
    },
    devices: {
      title: "Devices",
      controlParts: {
        box: "Box",
        mini: "Mini",
        both: "both",
        none: "neither",
      },
      fleets: {
        own: "Own devices",
      },
      units: {
        kWh: "{0} kWh",
        kWhPerDay: "{0} kWh/day",
        kWhPerSquareMetre: "{0} kWh/m²",
        MWh: "{0} MWh",
        hours: "{0} h",
      },
      captions: {
        fleet: "{0} · largest fleet",
        energy: "across {0} assignments with a meter reading",
        energyLeftOut: "across {0} assignments with a meter reading · {1} projects not counted",
        energyPerProject: "{0} · across {1} projects",
        energyPerDryingDay: "{0} · across {1} projects",
        energyPerArea: "{0} · across {1} projects",
        partialReadings: "{0} with incomplete meter readings",
        deviceDays: "across {0} assignments",
        devicesPerProject: "{0} · across {1} projects with drying devices",
        controlDevicesPerProject: "{0} · across {1} projects with a Box or Mini",
        controlProjectShare: "{0} of {1} finished projects",
        hydryControlLine: "HyDry Control: {0} per project with a Box or Mini ({1})",
        operatingHours: "across {0} counter readings",
        operatingHoursDerivedOnly: "from the assignment duration only: {0}",
      },
      cards: {
        categoryMix: "Device days by category",
        categoryMixSubtitle: "Share of all device days of your own devices",
        energy: "Power consumption",
        energySubtitle: "Devices with their own electricity meter, in kWh",
        operatingHours: "Operating hours",
        operatingHoursSubtitle: "counters read off the device and hours from the assignment duration, never added together",
      },
      facts: {
        daysInUse: "{0} of {1} days",
        total: "Total",
        perProject: "Average per project",
        leftOutOfTotal: "Projects not in the total (implausible consumption)",
        leftOutOfAverage: "Projects not in the average (over 120 kWh per day)",
        counterHours: "Operating hours read off the counter",
        derivedConfirmed: "From the assignment duration, confirmed",
        derivedUnconfirmed: "From the assignment duration, unconfirmed",
        implausibleReadings: "Implausible readings, not counted",
      },
      unknownCategory: "Unknown category",
    },
    businessDevelopment: {
      title: "Business development",
      captions: {
        projects: "finished in this period",
        duration: "{0} · across {1} finished projects",
        rooms: "{0} · across {1} projects",
        reactionTime: "{0} · across {1} projects with a damage day",
        rejections: "{0} of {1} projects with a decision",
      },
      cards: {
        outcomes: "Conclusion types",
        outcomesSubtitle: "Result of the damage assessment per project",
        outcomesRingCaption: "with a result",
        branches: "Projects per branch",
        branchesSubtitle: "Share of all projects with a branch",
        projectTypes: "Mix of project types",
        projectTypesSubtitle: "Share of all projects with a project type",
        damageCauses: "Causes of damage",
        damageCausesSubtitle: "{0} of {1} projects finished in IRES Project with a cause of damage; a project with several causes counts for each",
        damageCausesMarketSubtitle: "Share of the projects with a cause of damage ({0} of yours); a project with several causes counts for each, so together over 100 %",
        damageCausesMore: "More causes: {0}",
      },
      facts: {
        rejections: "Rejections",
        rejectedOf: "{0} of {1} ({2})",
        noRejections: "none in this period",
      },
      unknownBranch: "Unknown branch",
      unknownProjectType: "Unknown project type",
      unknownDamageCause: "Unknown cause",
      services: {
        title: "Services",
        caption: "A project counts in every service it finished in the period.",
        leakDetection: "Leak detection",
        damageAssessment: "Damage assessment",
        drying: "Drying",
        repair: "Restoration",
      },
    },
    insurance: {
      title: "Insurers",
      captions: {
        approval: "{0} · across {1} offers",
        acceptance: "{0} of {1} answers accepted",
        overrun: "{0} · across {1} dryings with an accepted offer",
        directOrders: "{0} of {1} projects with a value",
      },
      cards: {
        answers: "Insurer answers",
        answersSubtitle: "to the offers from IRES Project, by the month of the answer",
        approval: "Approval and drying",
        approvalSubtitle: "dryings with an accepted offer, by the month the project ended",
      },
      parts: {
        accepted: "Accepted",
        rejected: "Rejected",
      },
      bars: {
        overApproved: "Dried longer than approved",
        cut: "Fewer days approved than requested",
      },
      facts: {
        recordedTogether: "Recorded together with the offer (no approval time)",
        implausibleDates: "Impossible dates",
        meanOverrun: "Average over the approval",
        medianOverrun: "Median over the approval",
        noApprovedDays: "No approved drying time",
        noActual: "No actual drying time",
      },
      insurer: {
        card: "Insurers",
        cardSubtitle: "Share of the projects finished in the period",
        insurersHeading: "Per insurer: share of the {0} projects with an insurer",
        others: "Other insurers",
        unidentified: "not identified",
        cases: {
          insured: "With an insurer",
          noInfo: "Not stated",
          direct: "Direct order",
        },
      },
    },
    processFlow: {
      title: "Process",
      captions: {
        transition: "{0} · across {1} projects",
      },
      groups: {
        order: "Order and assessment",
        drying: "Approval and drying",
        restoration: "Restoration and completion",
      },
      cards: {
        order: "Order of project steps",
        routes: "Recording source",
        routesSubtitle: "what the project steps were recorded with",
      },
      routes: {
        viaApp: "IRES Project",
        viaErp: "ERP system",
        viaPortal: "IRES Office",
      },
      facts: {
        noRoute: "Steps without a source",
      },
      stack: {
        title: "Project flow",
        caption: "Over {0} projects with all steps · {1} out of order, not counted",
        insuranceHeader: "With insurer approval ({0} projects)",
        damageToApproval: "Damage assessment to approval",
        approvalToSetup: "Approval to drying set-up",
        stages: {
          toDamageAssessment: "To damage assessment",
          toDryingSetup: "To drying set-up",
          drying: "Drying",
          toProjectEnd: "To project end",
        },
      },
    },
    metrics: {
      "MIRA-PRJ-003": {
        title: "Mix of conclusion types",
        unlock: "Conclude the damage assessment with its result.",
      },
      "MIRA-PRJ-006": {
        title: "Projects per branch",
        unlock: "Assign a branch to every project.",
      },
      "MIRA-PRJ-007": {
        title: "Mix of project types",
        unlock: "Choose the project type on every project.",
      },
      "MIRA-PRJ-008": {
        title: "Response time (damage to project start)",
        unlock: "Enter the day of the damage on every project.",
      },
      "MIRA-PRJ-011": {
        title: "Number of rooms (project size)",
        unlock: "Add the affected rooms in the damage assessment.",
      },
      "MIRA-PRJ-012": {
        title: "Mix of building types",
        unlock: "State the property / building in the description.",
      },
      "MIRA-PRJ-013": {
        title: "Causes of damage",
        unlock: "Record the cause of damage in the damage assessment.",
      },
      "MIRA-PRJ-015": {
        title: "Property features",
        unlock: "Fill in the property features in the description.",
      },
      "MIRA-PRJ-016": {
        title: "Mix of claims adjusters",
        unlock: "State the type of claims adjuster on every project.",
      },
      "MIRA-PHA-001": {
        title: "Phase duration",
        unlock: "Start and conclude every phase in the project timeline.",
      },
      "MIRA-PHA-002": {
        title: "Waiting time between phases",
        unlock: "Conclude each phase and start the next one in the project timeline.",
      },
      "MIRA-PHA-003": {
        title: "Time to the damage assessment",
        unlock: "Record first contact (K1) on every project.",
      },
      "MIRA-PHA-004": {
        title: "Time to device assignment",
        unlock: "Assign the devices you set up to the project.",
      },
      "MIRA-PHA-006": {
        title: "Time to restoration",
        unlock: "Too few projects with restoration in this period. The figure appears once there are enough.",
      },
      "MIRA-PHA-010": {
        title: "Recording source per phase",
        unlock: "The recording source has only been stored since 2025, so older periods do not have it.",
      },
      "MIRA-PHA-011": {
        title: "Project flow",
        unlock: "For every project, finish the damage assessment, drying set-up, drying end and project end in order.",
      },
      "MIRA-PHA-012": {
        title: "Project start to order",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-013": {
        title: "Order to leak detection / damage assessment",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-014": {
        title: "Leak detection to damage assessment",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-015": {
        title: "Damage assessment to drying start",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-016": {
        title: "Damage assessment to approval",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-017": {
        title: "Approval to drying / restoration start",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-018": {
        title: "Drying duration",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-019": {
        title: "Drying end to restoration completed",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-020": {
        title: "Restoration duration",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-021": {
        title: "To project conclusion",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PHA-022": {
        title: "Order to drying start",
        unlock: "Too few finished projects with both steps in this period. The figure appears once enough come together.",
      },
      "MIRA-PRJ-017": {
        title: "Services",
        unlock: "For every project, finish the services you carried out.",
      },
      "MIRA-DRY-001": {
        title: "Average drying time without a project (HyDry)",
        unlock: "Too few HyDry dryings without a project with a known start and end in this period.",
      },
      "MIRA-DRY-002": {
        title: "Share of pauses without a project (HyDry)",
        unlock: "Too few HyDry dryings without a project whose pauses are fully known in this period.",
      },
      "MIRA-DRY-003": {
        title: "Average conventional drying time",
        unlock: "Too few finished projects dried with your own devices only. Assign the devices for the actual drying time.",
      },
      "MIRA-DRY-009": {
        title: "Average drying time per project (HyDry)",
        unlock: "Too few finished projects dried with HyDry devices. Assign the devices to the project with a start and an end.",
      },
      "MIRA-DRY-010": {
        title: "Average drying time per project (conventional)",
        unlock: "Too few finished projects dried with conventional devices only. Assign the devices to the project with a start and an end.",
      },
      "MIRA-DRY-011": {
        title: "Share of pauses per project (HyDry)",
        unlock: "Too few finished HyDry projects whose pauses are fully known in this period.",
      },
      "MIRA-DRY-005": {
        title: "Measurement frequency",
        unlock: "Record the measurement at drying set-up and at drying pack-up in the measurement log.",
      },
      "MIRA-DRY-012": {
        title: "Intermediate measurements per project",
        unlock: "Record the measurement at drying set-up in the measurement log.",
      },
      "MIRA-DRY-007": {
        title: "Average drying area",
        unlock: "Record the affected building components with their area in the damage assessment.",
      },
      "MIRA-DRY-008": {
        title: "Forecast and actual drying time",
        unlock: "Enter the drying time forecast and assign the devices to the project.",
      },
      "MIRA-DEV-001": {
        title: "Device days",
        unlock: "Assign the devices to the project with a start and an end.",
      },
      "MIRA-DEV-002": {
        title: "Operating hours",
        unlock: "Record the operating hours when you pack up other devices.",
      },
      "MIRA-DEV-003": {
        title: "Devices per project",
        unlock: "Assign the devices you use to the projects.",
      },
      "MIRA-DEV-015": {
        title: "HyDry Control per project",
        unlock: "Too few finished projects with a Box or Mini in the period.",
      },
      "MIRA-DEV-016": {
        title: "Projects with HyDry Control",
        unlock: "Assign the devices you use to the projects.",
      },
      "MIRA-DEV-017": {
        title: "Devices per project (companies with own devices)",
      },
      "MIRA-DEV-018": {
        title: "Devices per project (HyDry only)",
      },
      "MIRA-DEV-004": {
        title: "Power consumption",
        unlock: "Record the devices’ meter readings at set-up and pack-up.",
      },
      "MIRA-DEV-005": {
        title: "Average power consumption per project",
        unlock: "Too few projects with complete meter readings in this period.",
      },
      "MIRA-DEV-006": {
        title: "Fleet utilisation",
        unlock: "Too little data about your device inventory in this period.",
      },
      "MIRA-DEV-011": {
        title: "Fleet utilisation Box",
        unlock: "Too little data about your Boxes in this period.",
      },
      "MIRA-DEV-012": {
        title: "Fleet utilisation Mini",
        unlock: "Too little data about your Minis in this period.",
      },
      "MIRA-DEV-013": {
        title: "Fleet utilisation Panel",
        unlock: "Too little data about your Panels in this period.",
      },
      "MIRA-DEV-014": {
        title: "Fleet utilisation own devices",
        unlock: "Too little data about your own devices in this period.",
      },
      "MIRA-DEV-009": {
        title: "Average power use per drying day",
        unlock: "Too few projects with complete meter readings in this period.",
      },
      "MIRA-DEV-010": {
        title: "Power use per m² of drying area",
        unlock: "Too few finished projects with a drying area and meter readings in this period.",
      },
      "MIRA-DEV-008": {
        title: "Mix of categories / templates",
        unlock: "Give your devices a valid category and a valid template.",
      },
      "MIRA-INS-001": {
        title: "Projects per insurer",
      },
      "MIRA-INS-002": {
        title: "Average project duration per insurer",
      },
      "MIRA-INS-003": {
        title: "Insurer assignment rate",
        unlock: "State the insurer on every project.",
      },
      "MIRA-INS-004": {
        title: "Approval time",
        unlock: "Too few offers with an answer from the insurer in this period.",
      },
      "MIRA-INS-005": {
        title: "Offer acceptance rate",
        unlock: "Too few offers with an answer from the insurer in this period.",
      },
      "MIRA-INS-006": {
        title: "Approved and actual drying time",
        unlock: "Too few accepted offers with an approved drying time in this period.",
      },
      "MIRA-INS-008": {
        title: "Direct orders",
        unlock: "Record the direct order on the project.",
      },
      "MIRA-DQ-001": {
        title: "Field coverage",
      },
      "MIRA-DQ-002": {
        title: "Meter reading coverage",
      },
      "MIRA-PRJ-001": {
        title: "Projects",
      },
      "MIRA-PRJ-002": {
        title: "Average project duration",
      },
      "MIRA-PRJ-004": {
        title: "Rejection rate",
      },
      "MIRA-PHA-005": {
        title: "Time to drying pack-up",
      },
      "MIRA-PHA-007": {
        title: "Time to project conclusion",
      },
      "MIRA-DRY-004": {
        title: "HyDry advantage over conventional drying",
      },
      "MIRA-DRY-006": {
        title: "Drying success",
      },
    },
  },
  maps: {
    city: "City",
    postalCode: "Postal code",
    street: "Street",
    houseNumber: "House number",
    result: "Result",
    start: "Start",
    destination: "Destination",
    deleteMarkers: "Delete markers",
    deleteRoutes: "Delete routes",
    geocode: "Search address",
    showRoute: "Show route",
    noAddress: "Please enter at least a city, street, or postal code.",
    geocodingFailed: "Address could not be found.",
    routeMissingAddresses: "Please enter start and destination.",
    routeFailed: "Route could not be calculated.",
    distance: "Distance",
    duration: "Travel time",
  },
  timeTrackingHistory: {
    dayEntries: "Day entries",
    noEntries: "No entries for this day.",
    selectDayHint: "Please select a day in the calendar.",
    daySummary: "Day overview",
    dayClosed: "Day closed",
    dayOpen: "Day open",
    today: "Today",
    projectWork: "Project work",
    projectTime: "Project time",
    activeProjectEntries: "Active project – Entries",
    lastProjectEntries: "Last project – Entries",
    projectEntries: "Project – Entries",
    backToActiveProject: "Back to active project",
    backToLastProject: "Back to last project",
    noProjectEntries: "No project entries available.",
    loadingProjectEntries: "Loading project entries…",
    projectArchived: "Archived",
    projectDeleted: "Deleted",
    mergedEntriesTooltip: "Merged from {count} entries",
    startOfDay: "Start of day",
    endOfDay: "End of day",
    columns: {
      time: "Time",
      duration: "Duration",
      description: "Description",
      timeRange: "Time range",
      date: "Date",
      phase: "Phase",
      project: "Project",
      user: "User",
      source: "Source",
    },
    phases: {
      damageAssessment: "Damage assessment",
      leakDetection: "Leak detection",
      drying: "Drying",
      dryingPreparation: "Drying setup",
      repair: "Restoration",
    },
    tasks: {
      orderEntry: "Establish contact",
      firstContact: "First contact",
      leakDetection: "Leak detection",
      damageAssessment: "Damage assessment",
      insuranceOffer: "Insurance offer",
      dryingApproval: "Drying approval",
      dryingPreparation: "Drying setup",
      intermediateMeasurement: "Measurement",
      dryingConclusion: "Drying packup",
      repair: "Restoration",
      projectConclusion: "Project finished",
    },
    travel: {
      toOffice: "Drive to office",
      toHome: "Drive home",
      toProject: "Travel to address",
      approach: "Approach",
    },
    autoContext: {
      prepareDrying: "Prepare drying",
      finalMeasurement: "Final measurement",
      finalResubmission: "Final resubmission",
      finalDrying: "Final drying",
    },
    categories: {
      pause: "Pause",
      travelingTime: "Travel time",
      internal: "Internal",
      other: "Other",
      general: "General",
      interruption: "Interruption",
      silentInterruption: "Silent Interruption",
    },
    summary: {
      totalTime: "Tracked time",
      workingTime: "Calculated working time",
      travelTime: "Travel time",
      projectTime: "Project time",
      internalWork: "Internal work",
      pause: "Pause",
      unexplained: "Unexplained",
    },
    markerReasons: {
      overlapStart: "Start time overlaps with another entry.",
      overlapEnd: "Another entry starts before this entry ends.",
      dayClamped: "Value was capped to the selected day boundary.",
      crossDay: "Entry spans multiple days.",
      adjustedData: "Timestamp was adjusted due to inconsistent source data.",
      mergedBoundary: "Displayed boundary comes from merged adjacent entries (within configured merge gap).",
    },
  },
  staleEntryAutoClose: {
    title: "Time entry automatically closed",
    subtitle: "We automatically closed this task because no further activity was recorded from you.\nWould you like to adjust your end time?",
    projectEntryLabel: "Project work: {project}",
    projectEntryLabelFallback: "Project work",
    otherEntryLabel: "General entry",
    proposedEndLabel: "Suggested end time",
    editHint: "Adjust end time",
    accept: "Confirm",
    invalidTime: "Invalid time.",
    successMessage: "Time entry has been closed.",
  },
};
